
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $24caf1db45c3b300$exports = {};
$24caf1db45c3b300$exports = JSON.parse("[\"https://accounts.wdtest1.com\",\"https://sb-03-kepler.wdtest1.com/static/auth\",\"kepler://authorize\",\"http://localhost:3000\",\"https://sb-03-yoda.wdtest1.com\",\"http://localhost:1234\"]");


const $85b18de75239c237$export$ab1569362331cdaf = false;
const $85b18de75239c237$export$1c940ca0480630d9 = true;
const $85b18de75239c237$export$e43bc5d19fa365 = false;
const $85b18de75239c237$export$f4b2f34c9ce2f292 = true;


// data coming in query params:
const { search: $2f1387074b88af05$var$search } = window.location;
const $2f1387074b88af05$var$urlSearchParams = new URLSearchParams($2f1387074b88af05$var$search);
const $2f1387074b88af05$var$params = Object.fromEntries($2f1387074b88af05$var$urlSearchParams.entries());
const $2f1387074b88af05$var$stateQuery = $2f1387074b88af05$var$params.state ? JSON.parse(atob($2f1387074b88af05$var$params.state)) : {};
const { locale: $2f1387074b88af05$var$locale, protocol: $2f1387074b88af05$var$protocol = 'kepler', app: $2f1387074b88af05$var$app = 'WebApp', url: $2f1387074b88af05$var$url = '', clientId: $2f1387074b88af05$var$clientId = '', ui_locales: $2f1387074b88af05$var$ui_locales = '', type: $2f1387074b88af05$var$type = '', skipVerification: $2f1387074b88af05$var$skipVerification = false, audience: $2f1387074b88af05$var$audience = 'mycloud.com' } = $2f1387074b88af05$var$stateQuery;
const $2f1387074b88af05$export$ca000e230c0caa3e = new Map([
    [
        'locale',
        $2f1387074b88af05$var$locale
    ],
    [
        'protocol',
        $2f1387074b88af05$var$protocol
    ],
    [
        'app',
        $2f1387074b88af05$var$app
    ],
    [
        'url',
        $2f1387074b88af05$var$url
    ],
    [
        'clientId',
        $2f1387074b88af05$var$clientId
    ],
    [
        'ui_locales',
        $2f1387074b88af05$var$ui_locales
    ],
    [
        'type',
        $2f1387074b88af05$var$type
    ],
    [
        'skipVerification',
        $2f1387074b88af05$var$skipVerification
    ],
    [
        'code',
        $2f1387074b88af05$var$params.code
    ],
    [
        'error',
        $2f1387074b88af05$var$params.error
    ],
    [
        'error_description',
        $2f1387074b88af05$var$params.error_description
    ],
    [
        'state',
        $2f1387074b88af05$var$params.state
    ],
    [
        'audience',
        $2f1387074b88af05$var$audience
    ]
]);
// omit skipverification in returned `state` query param
const { skipVerification: $2f1387074b88af05$var$_, ...$2f1387074b88af05$var$returnState } = $2f1387074b88af05$var$stateQuery;
const $2f1387074b88af05$var$returnParams = new URLSearchParams({
    ...$2f1387074b88af05$var$params,
    state: (0, $85b18de75239c237$export$e43bc5d19fa365) ? btoa(JSON.stringify($2f1387074b88af05$var$returnState)) : $2f1387074b88af05$var$params.state
});
const $2f1387074b88af05$export$936cdf5afafe81ea = ()=>$2f1387074b88af05$export$ca000e230c0caa3e.get('url') ? `${$2f1387074b88af05$export$ca000e230c0caa3e.get('url')}?${$2f1387074b88af05$var$returnParams}` : `${$2f1387074b88af05$export$ca000e230c0caa3e.get('protocol')}://?authenticate=true&${$2f1387074b88af05$var$returnParams}`;
const $2f1387074b88af05$export$fcd377fc623480d5 = ()=>$2f1387074b88af05$export$ca000e230c0caa3e.get('url') ? $2f1387074b88af05$export$ca000e230c0caa3e.get('url') : `${$2f1387074b88af05$export$ca000e230c0caa3e.get('protocol')}://`;
const $2f1387074b88af05$export$18943cbb6279ee9e = ({ skipVerification: skipVerification = false } = {})=>[
        `${$2f1387074b88af05$export$ca000e230c0caa3e.get('service.account.login.url')}/authorize?`,
        'response_type=code&',
        `ui_locales=${$2f1387074b88af05$export$ca000e230c0caa3e.get('ui_locales')}&`,
        `client_id=${$2f1387074b88af05$export$ca000e230c0caa3e.get('clientId')}&`,
        `redirect_uri=${window.location.origin}&`,
        'scope=openid offline_access&',
        // re-use the state param from the original request
        (0, $85b18de75239c237$export$f4b2f34c9ce2f292) ? `state=${$2f1387074b88af05$var$params.state}&` : `state=${btoa(JSON.stringify({
            ...$2f1387074b88af05$var$stateQuery,
            skipVerification: skipVerification
        }))}&`,
        `audience=${$2f1387074b88af05$export$ca000e230c0caa3e.get('audience')}`
    ].join('');
// replacing the last slash in the strings, just in case
const $2f1387074b88af05$var$checkUrlWhitelisted = ()=>{
    const u = $2f1387074b88af05$export$ca000e230c0caa3e.get('url');
    // os5 admin UI
    // ASK TO KEEP THIS PATHNAME SO WE COULD RELY ON IT
    if (u.match('/web/auth0')) return true;
    // rocket & drax admin UI
    // ASK TO KEEP THIS STATE VALUE SO WE COULD RELY ON IT
    if ($2f1387074b88af05$export$ca000e230c0caa3e.get('app') === 'rocket&drax') return true;
    // other client apps with static URLs listed in the "Allowed Callback URLs"
    const urls = (0, (/*@__PURE__*/$parcel$interopDefault($24caf1db45c3b300$exports))).map((i)=>i.replace(/\/$/, ''));
    return urls.includes(u.replace(/\/$/, ''));
};
const $2f1387074b88af05$var$checkProtocolWhitelisted = ()=>{
    const p = $2f1387074b88af05$export$ca000e230c0caa3e.get('protocol');
    // inerested only in the protocol part.
    // we are good if it does match
    const protocols = (0, (/*@__PURE__*/$parcel$interopDefault($24caf1db45c3b300$exports))).map((i)=>i.split('://')?.[0]);
    return protocols.includes(p);
};
const $2f1387074b88af05$export$4365e79c2c6c6867 = ()=>$2f1387074b88af05$export$ca000e230c0caa3e.get('url') ? $2f1387074b88af05$var$checkUrlWhitelisted() : $2f1387074b88af05$var$checkProtocolWhitelisted();
const $2f1387074b88af05$export$e5c18469ad8c5a41 = ()=>$2f1387074b88af05$export$ca000e230c0caa3e.get('type') === 'password-reset';


var $b3e28066947b9fe1$exports = {};
$b3e28066947b9fe1$exports = JSON.parse('{"success-page-sub-logo-text":"Jeden \xfa\u010Det {{company_name}} pro v\u0161echny va\u0161e aplikace.","success-page-text":"Vra\u0165te se do aplikace a pokra\u010Dujte v nastaven\xed.","return-to-app-button-text":"Zp\u011Bt do aplikace {{app}}","error-page-title":"Jejda!","error-page-text":"Do\u0161lo k probl\xe9mu s p\u0159ipojen\xedm k va\u0161emu \xfa\u010Dtu.","error-page-two-factor-code-expired-error":"Vypr\u0161ela platnost k\xf3du pro dvoj\xfarov\u0148ov\xe9 ov\u011B\u0159ov\xe1n\xed","error-page-need-help-text":"Pot\u0159ebujete pomoc? <a href=\\"https://support.wdc.com\\" target=\\"_blank\\" rel=\\"noopener noreferrer\\">Nav\u0161tivte n\xe1\u0161 web pomoci online</a>","error-page-try-again-button":"Zkuste to znovu","error-page-blocked-user-error":"V z\xe1jmu ochrany va\u0161ich dat byl p\u0159\xedstup k va\u0161emu \xfa\u010Dtu zak\xe1z\xe1n. Chcete-li znovu z\xedskat p\u0159\xedstup ke sv\xe9mu \xfa\u010Dtu, mus\xedte obnovit heslo. Doporu\u010Dujeme zvolit siln\xe9 a jedine\u010Dn\xe9 heslo, kter\xe9 jste je\u0161t\u011B nikdy nepou\u017Eili.","error-page-blocked-user-error2":"P\u0159\xedstup k va\u0161emu \xfa\u010Dtu byl zak\xe1z\xe1n.","error-user-exists":"Tato e-mailov\xe1 adresa je ji\u017E pou\u017E\xedv\xe1na","back":"Zp\u011Bt","inline-error":"N\u011Bco se nezda\u0159ilo. Zkuste to znovu.","footer-1":"Jeden \xfa\u010Det {{company_name}} pro v\u0161echny va\u0161e aplikace.","footer-2":"\xa9 2026 {{company_name}} Corporation nebo jej\xed pobo\u010Dky. V\u0161echna pr\xe1va vyhrazena.","verify-email-title":"Ov\u011B\u0159te svou e-mailovou adresu","verify-email-text-1":"V\xe1\u0161 \xfa\u010Det byl vytvo\u0159en. Z d\u016Fvodu lep\u0161\xed ochrany va\u0161eho \xfa\u010Dtu {{company_name}} mus\xedte ov\u011B\u0159it svou e-mailovou adresu. Zkontrolujte e-maily odeslan\xe9 spole\u010Dnost\xed {{company_name}} na e-mailovou adresu <b>{{email}}</b>. Postupujte podle pokyn\u016F v e-mailu a pot\xe9 se vra\u0165te sem a klikn\u011Bte na tla\u010D\xedtko <b>Zkontrolovat stav ov\u011B\u0159en\xed</b>.","verify-email-text-2":"V p\u0159\xedpad\u011B pot\u0159eby m\u016F\u017Eete <b><a href=\\"#\\" data-action=\\"verify-email#changeEmail\\">zm\u011Bnit e-mailovou adresu</a></b>, kterou pou\u017E\xedv\xe1te pro sv\u016Fj \xfa\u010Det {{company_name}}.","verify-email-button-1.1":"Zkontrolovat stav ov\u011B\u0159en\xed","verify-email-button-1.2":"Ov\u011B\u0159uje se...","verify-email-button-1.3":"E-mail nebyl ov\u011B\u0159en","verify-email-button-2.1":"Odeslat e-mail znovu","verify-email-button-2.2":"Odes\xedl\xe1 se znovu...","verify-email-button-2.3":"E-mail byl odesl\xe1n","verify-email-verification-error-message":"Va\u0161e e-mailov\xe1 adresa je\u0161t\u011B nen\xed ov\u011B\u0159ena.","verify-email-toast":"Po\u010Dkejte, ne\u017E se e-mail objev\xed ve va\u0161\xed schr\xe1nce. M\u016F\u017Ee to trvat n\u011Bkolik minut.","change-email-title":"Zm\u011Bnit e-mail","change-email-text":"Zadejte e-mailovou adresu, na kterou v\xe1m po\u0161leme ov\u011B\u0159ovac\xed e-mail.","change-email-placeholder":"Nov\xfd e-mail","change-email-button-1.1":"Zm\u011Bnit e-mail","change-email-button-1.2":"M\u011Bn\xed se...","reset-password-title":"Obnovit heslo","reset-password-text":"Zadejte svou e-mailovou adresu a my <br/> v\xe1m za\u0161leme pokyny pro obnovu hesla.","reset-password-placeholder":"E-mailov\xe1 adresa","reset-password-button-text":"Pokra\u010Dovat","reset-password-success":"Zkontrolujte pros\xedm adresu {{email}}, <br/> zaslali jsme na ni instrukce pro restart hesla.","reset-password-retry":"Odeslat e-mail znovu"}');


var $ae7908dc6063fdc7$exports = {};
$ae7908dc6063fdc7$exports = JSON.parse('{"success-page-sub-logo-text":"En {{company_name}}-konto for dine apps.","success-page-text":"Vend tilbage til applikationen for at forts\xe6tte ops\xe6tningen.","return-to-app-button-text":"Vend tilbage til {{app}}","error-page-title":"Hovsa!","error-page-text":"Vi st\xf8dte p\xe5 et problem med at oprette forbindelse til din konto.","error-page-two-factor-code-expired-error":"Tofaktorgodkendelseskode udl\xf8bet","error-page-need-help-text":"Brug for hj\xe6lp? <a href=\\"https://support.wdc.com\\" target=\\"_blank\\" rel=\\"noopener noreferrer\\">Bes\xf8g vores online hj\xe6lpeside</a>","error-page-try-again-button":"Pr\xf8v igen","error-page-blocked-user-error":"For at beskytte dine data er adgangen til din konto blevet deaktiveret. For at f\xe5 adgang til din konto igen, skal du nulstille din adgangskode. Vi foresl\xe5r, at du v\xe6lger en st\xe6rk, unik adgangskode, som du aldrig har brugt f\xf8r.","error-page-blocked-user-error2":"Adgang til din konto er blevet deaktiveret.","error-user-exists":"Denne e-mailadresse er allerede brugt","back":"Tilbage","inline-error":"Der gik noget galt. Pr\xf8v igen.","footer-1":"En {{company_name}}-konto for dine apps.","footer-2":"\xa9 2026 {{company_name}} Corporation eller dets datterselskaber. Alle rettigheder forbeholdes.","verify-email-title":"Bekr\xe6ft din e-mail","verify-email-text-1":"Din konto er oprettet. For bedre at beskytte din {{company_name}}-konto, skal du bekr\xe6fte din e-mailadresse. Se efter en e-mail sendt fra {{company_name}} til <b>{{email}}</b>. F\xf8lg instruktionerne i e-mailen, og vend derefter tilbage hertil for at klikke p\xe5 <b>Tjek bekr\xe6ftelsesstatus</b>.","verify-email-text-2":"Hvis du har brug for det, kan du <b><a href=\\"#\\" data-action=\\"verify-email#changeEmail\\">\xe6ndre e-mailadressen</a></b>, du bruger til din {{company_name}} konto.","verify-email-button-1.1":"Tjek bekr\xe6ftelsesstatus","verify-email-button-1.2":"Bekr\xe6fter...","verify-email-button-1.3":"E-mail er ikke bekr\xe6ftet","verify-email-button-2.1":"Send e-mail igen","verify-email-button-2.2":"Sender igen...","verify-email-button-2.3":"E-mail sendt","verify-email-verification-error-message":"Din e-mailadresse er ikke bekr\xe6ftet endnu.","verify-email-toast":"V\xe6r t\xe5lmodig, det kan tage et par minutter, f\xf8r e-mailen vises i din indbakke.","change-email-title":"Skift e-mail","change-email-text":"Indtast din e-mailadresse, s\xe5 vi kan sende dig en e-mail til bekr\xe6ftelse.","change-email-placeholder":"Ny e-mail","change-email-button-1.1":"Skift e-mail","change-email-button-1.2":"Skifter\u2026","reset-password-title":"Nulstil adgangskode","reset-password-text":"Indtast din e-mailadresse, <br/> s\xe5 sender vi dig en vejledning til, <br/> hvordan du nulstiller din adgangskode.","reset-password-placeholder":"E-mailadresse","reset-password-button-text":"Forts\xe6t","reset-password-success":"Se e-mailadressen {{email}} <br/> for at f\xe5 vejledning til nulstilling af adgangskoden.","reset-password-retry":"Send e-mail igen"}');


var $578dd4c2dfdedf29$exports = {};
$578dd4c2dfdedf29$exports = JSON.parse('{"success-page-sub-logo-text":"Ein {{company_name}}-Konto f\xfcr Ihre Apps.","success-page-text":"Kehren Sie zur Anwendung zur\xfcck, um die Einrichtung fortzusetzen.","return-to-app-button-text":"Zu {{app}} zur\xfcckkehren","error-page-title":"Ups!","error-page-text":"Bei der Verbindung zu Ihrem Konto ist ein Fehler aufgetreten.","error-page-two-factor-code-expired-error":"Zwei-Faktor-Authentifizierungscode abgelaufen","error-page-need-help-text":"Ben\xf6tigen Sie Hilfe? <a href=\\"https://support.wdc.com\\" target=\\"_blank\\" rel=\\"noopener noreferrer\\">Besuchen Sie unsere Hilfeseite im Internet</a>","error-page-try-again-button":"Versuchen Sie es erneut","error-page-blocked-user-error":"Zum Schutz Ihrer Daten wurde Ihr Konto deaktiviert. Um den Zugriff auf Ihr Konto wiederherzustellen, m\xfcssen Sie Ihr Passwort zur\xfccksetzen. Wir empfehlen, ein sicheres, einmaliges Passwort auszuw\xe4hlen, das Sie noch nie verwendet haben.","error-page-blocked-user-error2":"Der Zugriff auf Ihr Konto wurde deaktiviert.","error-user-exists":"Diese E-Mail-Adresse wird bereits verwendet","back":"Zur\xfcck","inline-error":"Es ist ein Problem aufgetreten. Versuchen Sie es erneut.","footer-1":"Ein {{company_name}}-Konto f\xfcr Ihre Apps.","footer-2":"\xa92026 {{company_name}} Corporation oder ihre Tochtergesellschaften. Alle Rechte vorbehalten.","verify-email-title":"E-Mail-Adresse best\xe4tigen","verify-email-text-1":"Ihr Konto wurde erstellt. Um Ihr {{company_name}}-Konto besser zu sch\xfctzen, m\xfcssen Sie Ihre E-Mail-Adresse verifizieren. Suchen Sie nach einer E-Mail von {{company_name}} an <b>{{email}}</b>. Befolgen Sie die Anweisungen in der E-Mail, kehren Sie dann hierher zur\xfcck und klicken Sie auf <b>Verifizierungsstatus pr\xfcfen</b>.","verify-email-text-2":"Wenn es notwendig ist, k\xf6nnen Sie <b><a href=\\"#\\" data-action=\\"verify-email#changeEmail\\">die E-Mail-Adresse \xe4ndern</a></b>, die Sie f\xfcr Ihr {{company_name}}-Konto verwenden.","verify-email-button-1.1":"Verifizierungsstatus pr\xfcfen","verify-email-button-1.2":"Wird verifiziert\xa0\u2026","verify-email-button-1.3":"E-Mail nicht verifiziert","verify-email-button-2.1":"E-Mail erneut senden","verify-email-button-2.2":"Wird erneut gesendet\xa0\u2026","verify-email-button-2.3":"E-Mail gesendet","verify-email-verification-error-message":"Ihre E-Mail-Adresse wurde noch nicht verifiziert.","verify-email-toast":"Haben Sie Geduld, es kann ein paar Minuten dauern, bis die E-Mail in Ihrem Posteingang angezeigt wird.","change-email-title":"E-Mail-Adresse \xe4ndern","change-email-text":"Geben Sie Ihre E-Mail-Adresse ein, damit wir Ihnen eine E-Mail zur Verifizierung schicken k\xf6nnen.","change-email-placeholder":"Neue E-Mail","change-email-button-1.1":"E-Mail-Adresse \xe4ndern","change-email-button-1.2":"\xc4ndern\xa0\u2026","reset-password-title":"Passwort zur\xfccksetzen","reset-password-text":"Geben Sie Ihre E-Mail-Adresse ein,<br/> und wir senden Ihnen eine Anleitung <br/> zum Zur\xfccksetzen Ihres Passworts zu.","reset-password-placeholder":"E-Mail-Adresse","reset-password-button-text":"Fortfahren","reset-password-success":"Bitte \xfcberpr\xfcfen Sie die E-Mail-Adresse <br/> {{email}}, um die Anleitung zum <br/> Zur\xfccksetzen Ihres Passworts zu erhalten.","reset-password-retry":"E-Mail erneut senden"}');


var $288fb4462e10fb6f$exports = {};
$288fb4462e10fb6f$exports = JSON.parse('{"success-page-sub-logo-text":"\u0388\u03BD\u03B1\u03C2 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC\u03C2 {{company_name}} \u03B3\u03B9\u03B1 \u03C4\u03B9\u03C2 \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AD\u03C2 \u03C3\u03B1\u03C2.","success-page-text":"\u0395\u03C0\u03B9\u03C3\u03C4\u03C1\u03AD\u03C8\u03C4\u03B5 \u03C3\u03C4\u03B7\u03BD \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7 \u03C1\u03CD\u03B8\u03BC\u03B9\u03C3\u03B7.","return-to-app-button-text":"\u0395\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE \u03C3\u03C4\u03BF {{app}}","error-page-title":"\u03A9\u03C7!","error-page-text":"\u03A0\u03B1\u03C1\u03BF\u03C5\u03C3\u03B9\u03AC\u03C3\u03C4\u03B7\u03BA\u03B5 \u03BA\u03AC\u03C0\u03BF\u03B9\u03BF \u03C3\u03C6\u03AC\u03BB\u03BC\u03B1 \u03BC\u03B5 \u03C4\u03B7 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7 \u03C3\u03C4\u03BF\u03BD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC \u03C3\u03B1\u03C2.","error-page-two-factor-code-expired-error":"\u039F \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03B5\u03BB\u03AD\u03B3\u03C7\u03BF\u03C5 \u03C4\u03B1\u03C5\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2 \u03B4\u03CD\u03BF \u03C0\u03B1\u03C1\u03B1\u03B3\u03CC\u03BD\u03C4\u03C9\u03BD \u03AD\u03BB\u03B7\u03BE\u03B5","error-page-need-help-text":"\u03A7\u03C1\u03B5\u03B9\u03AC\u03B6\u03B5\u03C3\u03C4\u03B5 \u03B2\u03BF\u03AE\u03B8\u03B5\u03B9\u03B1; <a href=\\"https://support.wdc.com\\" target=\\"_blank\\" rel=\\"noopener noreferrer\\">\u0395\u03C0\u03B9\u03C3\u03BA\u03B5\u03C6\u03C4\u03B5\u03AF\u03C4\u03B5 \u03C4\u03BF\u03BD \u03B9\u03C3\u03C4\u03CC\u03C4\u03BF\u03C0\u03BF \u03B7\u03BB\u03B5\u03BA\u03C4\u03C1\u03BF\u03BD\u03B9\u03BA\u03AE\u03C2 \u03B2\u03BF\u03AE\u03B8\u03B5\u03B9\u03B1\u03C2 \u03C0\u03BF\u03C5 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C4\u03BF\u03C5\u03BC\u03B5</a>","error-page-try-again-button":"\u03A0\u03C1\u03BF\u03C3\u03C0\u03B1\u03B8\u03AE\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC","error-page-blocked-user-error":"\u0393\u03B9\u03B1 \u03C4\u03B7\u03BD \u03C0\u03C1\u03BF\u03C3\u03C4\u03B1\u03C3\u03AF\u03B1 \u03C4\u03C9\u03BD \u03B4\u03B5\u03B4\u03BF\u03BC\u03AD\u03BD\u03C9\u03BD \u03C3\u03B1\u03C2, \u03B7 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7 \u03C3\u03C4\u03BF \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC \u03C3\u03B1\u03C2 \u03AD\u03C7\u03B5\u03B9 \u03B1\u03C0\u03B5\u03BD\u03B5\u03C1\u03B3\u03BF\u03C0\u03BF\u03B9\u03B7\u03B8\u03B5\u03AF. \u0393\u03B9\u03B1 \u03BD\u03B1 \u03B5\u03C0\u03B1\u03BD\u03B1\u03BA\u03C4\u03AE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7 \u03C3\u03C4\u03BF\u03BD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC \u03C3\u03B1\u03C2, \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03BA\u03AC\u03BD\u03B5\u03C4\u03B5 \u03B5\u03C0\u03B1\u03BD\u03B1\u03C6\u03BF\u03C1\u03AC \u03C4\u03BF\u03C5 \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03AE\u03C2 \u03C3\u03B1\u03C2. \u03A3\u03B1\u03C2 \u03C0\u03C1\u03BF\u03C4\u03B5\u03AF\u03BD\u03BF\u03C5\u03BC\u03B5 \u03BD\u03B1 \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03B5\u03C4\u03B5 \u03AD\u03BD\u03B1\u03BD \u03B9\u03C3\u03C7\u03C5\u03C1\u03CC, \u03BC\u03BF\u03BD\u03B1\u03B4\u03B9\u03BA\u03CC \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2 \u03C0\u03BF\u03C5 \u03B4\u03B5\u03BD \u03AD\u03C7\u03B5\u03C4\u03B5 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03B9 \u03C0\u03BF\u03C4\u03AD \u03C3\u03C4\u03BF \u03C0\u03B1\u03C1\u03B5\u03BB\u03B8\u03CC\u03BD.","error-page-blocked-user-error2":"\u0397 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7 \u03C3\u03C4\u03BF\u03BD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC \u03C3\u03B1\u03C2 \u03AD\u03C7\u03B5\u03B9 \u03B1\u03C0\u03B5\u03BD\u03B5\u03C1\u03B3\u03BF\u03C0\u03BF\u03B9\u03B7\u03B8\u03B5\u03AF.","error-user-exists":"\u0397 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 email \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03B5\u03AF\u03C4\u03B1\u03B9 \u03AE\u03B4\u03B7","back":"\u03A0\u03AF\u03C3\u03C9 \u03CC\u03C8\u03B7","inline-error":"\u03A0\u03B1\u03C1\u03BF\u03C5\u03C3\u03B9\u03AC\u03C3\u03C4\u03B7\u03BA\u03B5 \u03C0\u03C1\u03CC\u03B2\u03BB\u03B7\u03BC\u03B1. \u03A0\u03C1\u03BF\u03C3\u03C0\u03B1\u03B8\u03AE\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC.","footer-1":"\u0388\u03BD\u03B1\u03C2 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC\u03C2 {{company_name}} \u03B3\u03B9\u03B1 \u03C4\u03B9\u03C2 \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AD\u03C2 \u03C3\u03B1\u03C2.","footer-2":"\xa9 2026 {{company_name}} Corporation \u03AE \u03BF\u03B9 \u03B8\u03C5\u03B3\u03B1\u03C4\u03C1\u03B9\u03BA\u03AD\u03C2 \u03C4\u03B7\u03C2. \u039C\u03B5 \u03B5\u03C0\u03B9\u03C6\u03CD\u03BB\u03B1\u03BE\u03B7 \u03C0\u03B1\u03BD\u03C4\u03CC\u03C2 \u03B4\u03B9\u03BA\u03B1\u03B9\u03CE\u03BC\u03B1\u03C4\u03BF\u03C2.","verify-email-title":"\u0395\u03C0\u03B1\u03BB\u03B7\u03B8\u03B5\u03CD\u03C3\u03C4\u03B5 \u03C4\u03B7 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 email \u03C3\u03B1\u03C2","verify-email-text-1":"\u0394\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AE\u03B8\u03B7\u03BA\u03B5 \u03BF \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC\u03C2 \u03C3\u03B1\u03C2. \u0393\u03B9\u03B1 \u03BD\u03B1 \u03C0\u03C1\u03BF\u03C3\u03C4\u03B1\u03C4\u03B5\u03CD\u03C3\u03B5\u03C4\u03B5 \u03BA\u03B1\u03BB\u03CD\u03C4\u03B5\u03C1\u03B1 \u03C4\u03BF\u03BD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC \u03C3\u03B1\u03C2 {{company_name}}, \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03B5\u03C0\u03B1\u03BB\u03B7\u03B8\u03B5\u03CD\u03C3\u03BF\u03C5\u03BC\u03B5 \u03C4\u03B7 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 \u03B7\u03BB\u03B5\u03BA\u03C4\u03C1\u03BF\u03BD\u03B9\u03BA\u03BF\u03CD \u03C4\u03B1\u03C7\u03C5\u03B4\u03C1\u03BF\u03BC\u03B5\u03AF\u03BF\u03C5 \u03C3\u03B1\u03C2. \u0395\u03BB\u03AD\u03B3\u03BE\u03C4\u03B5 \u03B3\u03B9\u03B1 \u03AD\u03BD\u03B1 \u03BC\u03AE\u03BD\u03C5\u03BC\u03B1 \u03B7\u03BB\u03B5\u03BA\u03C4\u03C1\u03BF\u03BD\u03B9\u03BA\u03BF\u03CD \u03C4\u03B1\u03C7\u03C5\u03B4\u03C1\u03BF\u03BC\u03B5\u03AF\u03BF\u03C5 \u03B1\u03C0\u03B5\u03C3\u03C4\u03B1\u03BB\u03BC\u03AD\u03BD\u03BF \u03B1\u03C0\u03CC {{company_name}} \u03C3\u03B5 <b>{{email}}</b>. \u0391\u03BA\u03BF\u03BB\u03BF\u03C5\u03B8\u03AE\u03C3\u03C4\u03B5 \u03C4\u03B9\u03C2 \u03BF\u03B4\u03B7\u03B3\u03AF\u03B5\u03C2 \u03C3\u03C4\u03BF \u03BC\u03AE\u03BD\u03C5\u03BC\u03B1 \u03B7\u03BB\u03B5\u03BA\u03C4\u03C1\u03BF\u03BD\u03B9\u03BA\u03BF\u03CD \u03C4\u03B1\u03C7\u03C5\u03B4\u03C1\u03BF\u03BC\u03B5\u03AF\u03BF\u03C5 \u03BA\u03B1\u03B9 \u03C3\u03C4\u03B7 \u03C3\u03C5\u03BD\u03AD\u03C7\u03B5\u03B9\u03B1, \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03AD\u03C8\u03B5\u03C4\u03B5 \u03B5\u03B4\u03CE \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03BA\u03AC\u03BD\u03B5\u03C4\u03B5 \u03BA\u03BB\u03B9\u03BA \u03C3\u03C4\u03BF <b>\u0388\u03BB\u03B5\u03B3\u03C7\u03BF\u03C2 \u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B1\u03C3\u03B7\u03C2 \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2</b>.","verify-email-text-2":"\u0395\u03AC\u03BD \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5, \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 <b><a href=\\"#\\" data-action=\\"verify-email#changeEmail\\">\u03B1\u03BB\u03BB\u03AC\u03BE\u03B5\u03C4\u03B5 \u03C4\u03B7 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 \u03B7\u03BB\u03B5\u03BA\u03C4\u03C1\u03BF\u03BD\u03B9\u03BA\u03BF\u03CD \u03C4\u03B1\u03C7\u03C5\u03B4\u03C1\u03BF\u03BC\u03B5\u03AF\u03BF\u03C5</a></b> \u03C0\u03BF\u03C5 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03B5\u03AF\u03C4\u03B5 \u03B3\u03B9\u03B1 \u03C4\u03BF\u03BD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC {{company_name}} \u03C3\u03B1\u03C2.","verify-email-button-1.1":"\u0388\u03BB\u03B5\u03B3\u03C7\u03BF\u03C2 \u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B1\u03C3\u03B7\u03C2 \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2","verify-email-button-1.2":"\u0395\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u2026","verify-email-button-1.3":"\u0397 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 \u03B7\u03BB\u03B5\u03BA\u03C4\u03C1\u03BF\u03BD\u03B9\u03BA\u03BF\u03CD \u03C4\u03B1\u03C7\u03C5\u03B4\u03C1\u03BF\u03BC\u03B5\u03AF\u03BF\u03C5 \u03B4\u03B5\u03BD \u03B5\u03C0\u03B1\u03BB\u03B7\u03B8\u03B5\u03CD\u03C4\u03B7\u03BA\u03B5","verify-email-button-2.1":"\u0395\u03BA \u03BD\u03AD\u03BF\u03C5 \u03B1\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE \u03BC\u03B7\u03BD\u03CD\u03BC\u03B1\u03C4\u03BF\u03C2 \u03B7\u03BB\u03B5\u03BA\u03C4\u03C1\u03BF\u03BD\u03B9\u03BA\u03BF\u03CD \u03C4\u03B1\u03C7\u03C5\u03B4\u03C1\u03BF\u03BC\u03B5\u03AF\u03BF\u03C5","verify-email-button-2.2":"\u0395\u03BA \u03BD\u03AD\u03BF\u03C5 \u03B1\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE\u2026","verify-email-button-2.3":"\u03A4\u03BF \u03BC\u03AE\u03BD\u03C5\u03BC\u03B1 \u03B7\u03BB\u03B5\u03BA\u03C4\u03C1\u03BF\u03BD\u03B9\u03BA\u03BF\u03CD \u03C4\u03B1\u03C7\u03C5\u03B4\u03C1\u03BF\u03BC\u03B5\u03AF\u03BF\u03C5 \u03B5\u03C3\u03C4\u03AC\u03BB\u03B7","verify-email-verification-error-message":"\u0397 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 \u03B7\u03BB\u03B5\u03BA\u03C4\u03C1\u03BF\u03BD\u03B9\u03BA\u03BF\u03CD \u03C4\u03B1\u03C7\u03C5\u03B4\u03C1\u03BF\u03BC\u03B5\u03AF\u03BF\u03C5 \u03C3\u03B1\u03C2 \u03B4\u03B5\u03BD \u03B5\u03C0\u03B1\u03BB\u03B7\u03B8\u03B5\u03CD\u03C4\u03B7\u03BA\u03B5 \u03B1\u03BA\u03CC\u03BC\u03B7.","verify-email-toast":"\u039A\u03AC\u03BD\u03C4\u03B5 \u03C5\u03C0\u03BF\u03BC\u03BF\u03BD\u03AE, \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF \u03BD\u03B1 \u03C7\u03C1\u03B5\u03B9\u03B1\u03C3\u03C4\u03BF\u03CD\u03BD \u03BB\u03AF\u03B3\u03B1 \u03BB\u03B5\u03C0\u03C4\u03AC \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03B5\u03BC\u03C6\u03B1\u03BD\u03B9\u03C3\u03C4\u03B5\u03AF \u03C4\u03BF \u03BC\u03AE\u03BD\u03C5\u03BC\u03B1 \u03C3\u03C4\u03B1 \u03B5\u03B9\u03C3\u03B5\u03C1\u03C7\u03CC\u03BC\u03B5\u03BD\u03AC \u03C3\u03B1\u03C2.","change-email-title":"\u0391\u03BB\u03BB\u03B1\u03B3\u03AE \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7\u03C2 \u03B7\u03BB\u03B5\u03BA\u03C4\u03C1\u03BF\u03BD\u03B9\u03BA\u03BF\u03CD \u03C4\u03B1\u03C7\u03C5\u03B4\u03C1\u03BF\u03BC\u03B5\u03AF\u03BF\u03C5","change-email-text":"\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03B7 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 \u03B7\u03BB\u03B5\u03BA\u03C4\u03C1\u03BF\u03BD\u03B9\u03BA\u03BF\u03CD \u03C4\u03B1\u03C7\u03C5\u03B4\u03C1\u03BF\u03BC\u03B5\u03AF\u03BF\u03C5 \u03C3\u03B1\u03C2, \u03CE\u03C3\u03C4\u03B5 \u03BD\u03B1 \u03BC\u03C0\u03BF\u03C1\u03AD\u03C3\u03BF\u03C5\u03BC\u03B5 \u03BD\u03B1 \u03C3\u03B1\u03C2 \u03C3\u03C4\u03B5\u03AF\u03BB\u03BF\u03C5\u03BC\u03B5 \u03AD\u03BD\u03B1 \u03BC\u03AE\u03BD\u03C5\u03BC\u03B1 \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7\u03C2.","change-email-placeholder":"\u039D\u03AD\u03B1 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 \u03B7\u03BB\u03B5\u03BA\u03C4\u03C1\u03BF\u03BD\u03B9\u03BA\u03BF\u03CD \u03C4\u03B1\u03C7\u03C5\u03B4\u03C1\u03BF\u03BC\u03B5\u03AF\u03BF\u03C5","change-email-button-1.1":"\u0391\u03BB\u03BB\u03B1\u03B3\u03AE \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7\u03C2 \u03B7\u03BB\u03B5\u03BA\u03C4\u03C1\u03BF\u03BD\u03B9\u03BA\u03BF\u03CD \u03C4\u03B1\u03C7\u03C5\u03B4\u03C1\u03BF\u03BC\u03B5\u03AF\u03BF\u03C5","change-email-button-1.2":"\u0391\u03BB\u03BB\u03B1\u03B3\u03AE \u03C3\u03B5 \u03B5\u03BE\u03AD\u03BB\u03B9\u03BE\u03B7\u2026","reset-password-title":"\u0395\u03C0\u03B1\u03BD\u03B1\u03C6\u03BF\u03C1\u03AC \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2","reset-password-text":"\u0395\u03B9\u03C3\u03B1\u03B3\u03AC\u03B3\u03B5\u03C4\u03B5 \u03C4\u03B7 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 email \u03C3\u03B1\u03C2 \u03BA\u03B1\u03B9 \u03B8\u03B1 \u03C3\u03B1\u03C2 <br/> \u03C3\u03C4\u03B5\u03AF\u03BB\u03BF\u03C5\u03BC\u03B5 \u03BF\u03B4\u03B7\u03B3\u03AF\u03B5\u03C2 <br> \u03B5\u03C0\u03B1\u03BD\u03B1\u03C6\u03BF\u03C1\u03AC\u03C2 \u03C4\u03BF\u03C5 \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD \u03C3\u03B1\u03C2.","reset-password-placeholder":"\u0394\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 email","reset-password-button-text":"\u03A3\u03C5\u03BD\u03AD\u03C7\u03B5\u03B9\u03B1","reset-password-success":"\u0395\u03BB\u03AD\u03B3\u03BE\u03C4\u03B5 \u03C4\u03B7 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 email <br/>{{email}} \u03B3\u03B9\u03B1 \u03BF\u03B4\u03B7\u03B3\u03AF\u03B5\u03C2 <br/> \u03B5\u03C0\u03B1\u03BD\u03B1\u03C6\u03BF\u03C1\u03AC\u03C2 \u03C4\u03BF\u03C5 \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD \u03C3\u03B1\u03C2.","reset-password-retry":"\u0395\u03BA \u03BD\u03AD\u03BF\u03C5 \u03B1\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE email"}');


var $3d464347f9f3a992$exports = {};
$3d464347f9f3a992$exports = JSON.parse('{"success-page-sub-logo-text":"One {{company_name}} Account for your apps.","success-page-text":"Return to the application to continue setup.","return-to-app-button-text":"Return to {{app}}","error-page-title":"Whoops!","error-page-text":"We encountered an issue connecting to your account.","error-page-two-factor-code-expired-error":"Two-factor authentication code expired","error-page-need-help-text":"Need help? <a href=\\"https://support.wdc.com\\" target=\\"_blank\\" rel=\\"noopener noreferrer\\">Visit our online help site</a>","error-page-try-again-button":"Try again","error-page-blocked-user-error":"To protect your data, access to your account has been disabled. To regain access to your account, you must reset your password. We suggest that you select a strong, unique password that you\'ve never used before.","error-page-blocked-user-error2":"Access to your account has been disabled.","error-user-exists":"This email address is already used","back":"Back","inline-error":"Something went wrong. Try again.","footer-1":"One {{company_name}} Account for your apps.","footer-2":"\xa9 2026 {{company_name}} Corporation or its affiliates. All rights reserved.","verify-email-title":"Verify your email","verify-email-text-1":"Your account is created. To better protect your {{company_name}} Account, you must verify your email address. Check for an email sent from {{company_name}} to <b>{{email}}</b>. Follow the instructions in the email then return here to click <b>Check verification status</b>.","verify-email-text-2":"If you need to, you can <b><a href=\\"#\\" data-action=\\"verify-email#changeEmail\\">change the email address</a></b> you use for your {{company_name}} account.","verify-email-button-1.1":"Check verification status","verify-email-button-1.2":"Verifying...","verify-email-button-1.3":"Email not verified","verify-email-button-2.1":"Resend email","verify-email-button-2.2":"Resending...","verify-email-button-2.3":"Email sent","verify-email-verification-error-message":"Your email address isn\'t verified yet.","verify-email-toast":"Be patient, it might take a few minutes for the email to appear in your inbox.","change-email-title":"Change email","change-email-text":"Enter your email address so that we can send you an email to verify.","change-email-placeholder":"New email","change-email-button-1.1":"Change email","change-email-button-1.2":"Changing...","reset-password-title":"Reset password","reset-password-text":"Enter your email address and we will send <br/> you instructions to reset your password.","reset-password-placeholder":"Email address","reset-password-button-text":"Continue","reset-password-success":"Please check the email address {{email}} <br/> for instructions to reset your password.","reset-password-retry":"Resend email"}');


var $de6dba7c8e8a8f85$exports = {};
$de6dba7c8e8a8f85$exports = JSON.parse('{"success-page-sub-logo-text":"Una cuenta de {{company_name}} para tus aplicaciones.","success-page-text":"Volver a la aplicaci\xf3n para continuar con la configuraci\xf3n.","return-to-app-button-text":"Volver a {{app}}","error-page-title":"\xa1Vaya!","error-page-text":"Hemos tenido un problema al intentar conectar con tu cuenta.","error-page-two-factor-code-expired-error":"El c\xf3digo de la autenticaci\xf3n de dos factores ha caducado","error-page-need-help-text":"\xbfNecesitas ayuda? <a href=\\"https://support.wdc.com\\" target=\\"_blank\\" rel=\\"noopener noreferrer\\">Visita la p\xe1gina de ayuda online.</a>","error-page-try-again-button":"Int\xe9ntalo de nuevo","error-page-blocked-user-error":"Se ha deshabilitado el acceso a la cuenta para proteger tus datos. Restablece tu contrase\xf1a para acceder de nuevo a tu cuenta. Te sugerimos que elijas una contrase\xf1a segura y \xfanica que nunca hayas usado antes.","error-page-blocked-user-error2":"Se ha deshabilitado el acceso a tu cuenta.","error-user-exists":"Esta direcci\xf3n de correo electr\xf3nico ya est\xe1 en uso","back":"Volver","inline-error":"Algo ha fallado. Int\xe9ntalo de nuevo.","footer-1":"Una cuenta de {{company_name}} para tus aplicaciones.","footer-2":"\xa9 2026 {{company_name}} Corporation o sus filiales. Todos los derechos reservados.","verify-email-title":"Verificar tu correo electr\xf3nico","verify-email-text-1":"Se ha creado tu cuenta. Para proteger mejor tu cuenta de {{company_name}}, debemos verificar tu direcci\xf3n de correo electr\xf3nico. Comprueba si has recibido un correo electr\xf3nico de {{company_name}} enviado a <b>{{email}}</b>. Sigue las instrucciones del correo electr\xf3nico y despu\xe9s vuelve aqu\xed para hacer clic en <b>Comprobar estado de verificaci\xf3n</b>.","verify-email-text-2":"Si lo necesitas, puedes <b><a href=\\"#\\" data-action=\\"verify-email#changeEmail\\">cambiar la direcci\xf3n de correo electr\xf3nico</a></b> que usas para tu cuenta de {{company_name}}.","verify-email-button-1.1":"Comprobar estado de verificaci\xf3n","verify-email-button-1.2":"Verificando\u2026","verify-email-button-1.3":"Correo electr\xf3nico no verificado","verify-email-button-2.1":"Reenviar correo electr\xf3nico","verify-email-button-2.2":"Reenviando\u2026","verify-email-button-2.3":"Correo electr\xf3nico enviado","verify-email-verification-error-message":"Tu direcci\xf3n de correo electr\xf3nico a\xfan no se ha verificado.","verify-email-toast":"Ten paciencia, el correo electr\xf3nico puede tardar unos minutos en aparecer en tu bandeja de entrada.","change-email-title":"Cambiar correo electr\xf3nico","change-email-text":"Introduce tu direcci\xf3n de correo electr\xf3nico para que podamos reenviarte un correo electr\xf3nico para verificar.","change-email-placeholder":"Nuevo correo electr\xf3nico","change-email-button-1.1":"Cambiar correo electr\xf3nico","change-email-button-1.2":"Cambiando\u2026","reset-password-title":"Restablecer contrase\xf1a","reset-password-text":"Introduzca su direcci\xf3n de correo electr\xf3nico y le <br/> enviaremos un correo electr\xf3nico con <br/> instrucciones para restablecer su contrase\xf1a.","reset-password-placeholder":"Correo electr\xf3nico","reset-password-button-text":"Enviar Correo Electr\xf3nico","reset-password-success":"Por favor revise la direcci\xf3n de correo <br/> electr\xf3nico {{email}} y busque un email <br/> conteniendo instrucciones acerca de como <br/> restablecer su contrase\xf1a.","reset-password-retry":"Reenviar email"}');


var $aa7533656934a9e9$exports = {};
$aa7533656934a9e9$exports = JSON.parse('{"success-page-sub-logo-text":"Yksi {{company_name}}-tili sovelluksillesi.","success-page-text":"Palaa sovellukseen jatkaaksesi asennusta.","return-to-app-button-text":"Palaa kohteeseen {{app}}","error-page-title":"Hupsis!","error-page-text":"Havaitsimme ongelman, kun yritimme muodostaa yhteyden tiliisi.","error-page-two-factor-code-expired-error":"Kaksiosainen todennuskoodi vanhentui","error-page-need-help-text":"Tarvitsetko apua? <a href=\\"https://support.wdc.com\\" target=\\"_blank\\" rel=\\"noopener noreferrer\\">K\xe4y verkko-ohjesivustollamme</a>","error-page-try-again-button":"Yrit\xe4 uudelleen","error-page-blocked-user-error":"Tilisi on poistettu k\xe4yt\xf6st\xe4, jotta tietojasi voidaan suojella. Palauta tilin k\xe4ytt\xf6oikeudet asettamalla salasanasi uudelleen. Suosittelemme, ett\xe4 valitset vahvan ja ainutlaatuisen salasanan, jota et ole k\xe4ytt\xe4nyt koskaan aiemmin.","error-page-blocked-user-error2":"K\xe4ytt\xe4j\xe4tilisi on poistettu k\xe4yt\xf6st\xe4.","error-user-exists":"T\xe4t\xe4 s\xe4hk\xf6postiosoitetta on jo k\xe4ytetty","back":"Takaisin","inline-error":"Jokin meni vikaan. Yrit\xe4 uudelleen.","footer-1":"Yksi {{company_name}}-tili sovelluksillesi.","footer-2":"\xa9 2026 {{company_name}} Corporation tai sen tyt\xe4ryhti\xf6t. Kaikki oikeudet pid\xe4tet\xe4\xe4n.","verify-email-title":"Vahvista s\xe4hk\xf6postiosoitteesi","verify-email-text-1":"Tilisi on luotu. Sinun on vahvistettava s\xe4hk\xf6postiosoitteesi, jotta voimme suojata {{company_name}} -tilisi. Katso s\xe4hk\xf6posti, joka on l\xe4hetetty kohteesta {{company_name}} kohteeseen <b>{{email}}</b>. Noudata s\xe4hk\xf6postin ohjeita ja palaa takaisin t\xe4h\xe4n napsauttaaksesi <b>Tarkista vahvistustila</b>.","verify-email-text-2":"Voit tarvittaessa <b><a href=\\"#\\" data-action=\\"verify-email#changeEmail\\">vaihtaa s\xe4hk\xf6postiosoitetta</a></b>, jota k\xe4yt\xe4t {{company_name}}-tilille.","verify-email-button-1.1":"Tarkista vahvistustila","verify-email-button-1.2":"Vahvistetaan...","verify-email-button-1.3":"S\xe4hk\xf6posti ei ole vahvistettu","verify-email-button-2.1":"L\xe4het\xe4 s\xe4hk\xf6posti uudelleen","verify-email-button-2.2":"L\xe4hetet\xe4\xe4n uudelleen...","verify-email-button-2.3":"S\xe4hk\xf6posti l\xe4hetetty","verify-email-verification-error-message":"S\xe4hk\xf6postiosoitettasi ei ole viel\xe4 vahvistettu.","verify-email-toast":"Ole k\xe4rsiv\xe4llinen, s\xe4hk\xf6postin saapumisessa saattaa kest\xe4\xe4 muutama minuutti.","change-email-title":"Vaihda s\xe4hk\xf6postiosoite","change-email-text":"Sy\xf6t\xe4 s\xe4hk\xf6postiosoitteesi, jotta voimme l\xe4hett\xe4\xe4 sinulle vahvistettavan s\xe4hk\xf6postin.","change-email-placeholder":"Uusi s\xe4hk\xf6posti","change-email-button-1.1":"Vaihda s\xe4hk\xf6postiosoite","change-email-button-1.2":"Vaihdetaan...","reset-password-title":"Aseta salasana uudelleen","reset-password-text":"Anna s\xe4hk\xf6postiosoitteesi, ja l\xe4het\xe4mme <br/> sinulle ohjeet salasanan vaihtamiseen.","reset-password-placeholder":"S\xe4hk\xf6postiosoite","reset-password-button-text":"Jatkaa","reset-password-success":"S\xe4hk\xf6postiosoitteessa {{email}} <br/> on ohjeet salasanan vaihtamiseen.","reset-password-retry":"L\xe4het\xe4 s\xe4hk\xf6postiviesti uudelleen"}');


var $640cefc443ccf9c9$exports = {};
$640cefc443ccf9c9$exports = JSON.parse('{"success-page-sub-logo-text":"Un seul compte {{company_name}} pour vos applications.","success-page-text":"Revenir \xe0 l\'application pour continuer la configuration.","return-to-app-button-text":"Revenir \xe0 {{app}}","error-page-title":"Oups.","error-page-text":"Nous avons rencontr\xe9 un probl\xe8me lors de la connexion \xe0 votre compte.","error-page-two-factor-code-expired-error":"Le code d\'authentification \xe0 deux facteurs a expir\xe9","error-page-need-help-text":"Besoin d\'aide\xa0? <a href=\\"https://support.wdc.com\\" target=\\"_blank\\" rel=\\"noopener noreferrer\\">Consultez notre site d\'aide en ligne</a>","error-page-try-again-button":"Veuillez r\xe9essayer","error-page-blocked-user-error":"Pour prot\xe9ger vos donn\xe9es, l\'acc\xe8s \xe0 votre compte a \xe9t\xe9 d\xe9sactiv\xe9. Pour r\xe9cup\xe9rer l\'acc\xe8s \xe0 votre compte, vous devez r\xe9initialiser votre mot de passe. Nous vous recommandons de choisir un mot de passe fort et unique que vous n\'avez jamais utilis\xe9.","error-page-blocked-user-error2":"L\'acc\xe8s \xe0 votre compte a \xe9t\xe9 d\xe9sactiv\xe9.","error-user-exists":"Cette adresse e-mail est d\xe9j\xe0 utilis\xe9e","back":"Retour","inline-error":"Une erreur s\'est produite. Veuillez r\xe9essayer.","footer-1":"Un seul compte {{company_name}} pour vos applications.","footer-2":"\xa9 2026 {{company_name}} Corporation ou ses soci\xe9t\xe9s affili\xe9es. Tous droits r\xe9serv\xe9s.","verify-email-title":"V\xe9rifier votre e-mail","verify-email-text-1":"Votre compte est cr\xe9\xe9. Afin de mieux prot\xe9ger votre compte {{company_name}}, nous devons v\xe9rifier votre adresse e-mail. Un e-mail a \xe9t\xe9 envoy\xe9 par {{company_name}} \xe0 <b>{{email}}</b>. Suivez les instructions de l\'e-mail, puis revenez ici pour cliquer sur <b>V\xe9rifier l\'\xe9tat de la v\xe9rification</b>.","verify-email-text-2":"Si n\xe9cessaire, vous pouvez <b><a href=\\"#\\" data-action=\\"verify-email#changeEmail\\">modifier l\'adresse e-mail</a></b> que vous utilisez pour votre compte {{company_name}}.","verify-email-button-1.1":"V\xe9rifier l\'\xe9tat de la v\xe9rification","verify-email-button-1.2":"V\xe9rification\u2026","verify-email-button-1.3":"E-mail non v\xe9rifi\xe9","verify-email-button-2.1":"Envoyer l\'e-mail \xe0 nouveau","verify-email-button-2.2":"Renvoi\u2026","verify-email-button-2.3":"E-mail envoy\xe9","verify-email-verification-error-message":"Votre adresse e-mail n\'est pas encore v\xe9rifi\xe9e.","verify-email-toast":"Soyez patient, quelques minutes peuvent s\'\xe9couler avant que l\'e-mail n\'apparaisse dans votre bo\xeete de r\xe9ception.","change-email-title":"Changer l\'adresse e-mail","change-email-text":"Entrez votre adresse e-mail afin que nous puissions vous envoyer un e-mail de v\xe9rification.","change-email-placeholder":"Nouvel e-mail","change-email-button-1.1":"Changer l\'adresse e-mail","change-email-button-1.2":"Modification\u2026","reset-password-title":"R\xe9initialiser le mot de passe","reset-password-text":"Saisissez votre adresse e-mail et nous vous <br/> enverrons des instructions pour r\xe9initialiser <br/> votre mot de passe.","reset-password-placeholder":"Adresse e-mail","reset-password-button-text":"Continuer","reset-password-success":"Veuillez consulter l\'adresse e-mail <br/> {{email}} pour savoir comment r\xe9initialiser <br/> votre mot de passe.","reset-password-retry":"Renvoyer un e-mail"}');


var $217f7e685d0c4b7e$exports = {};
$217f7e685d0c4b7e$exports = JSON.parse('{"success-page-sub-logo-text":"Egy {{company_name}}-fi\xf3k az alkalmaz\xe1sokhoz.","success-page-text":"A be\xe1ll\xedt\xe1s folytat\xe1s\xe1hoz l\xe9pjen vissza az alkalmaz\xe1sba.","return-to-app-button-text":"Visszat\xe9r\xe9s a(z) {{app}} alkalmaz\xe1shoz","error-page-title":"Hopp\xe1!","error-page-text":"Hiba l\xe9pett fel a fi\xf3kj\xe1hoz val\xf3 csatlakoz\xe1s k\xf6zben.","error-page-two-factor-code-expired-error":"A k\xe9tfaktoros hiteles\xedt\xe9si k\xf3d lej\xe1rt","error-page-need-help-text":"Seg\xedts\xe9gre van sz\xfcks\xe9ge?<a href=\\"https://support.wdc.com\\" target=\\"_blank\\" rel=\\"noopener noreferrer\\">L\xe1togasson el online s\xfag\xf3oldalunkra</a>","error-page-try-again-button":"Pr\xf3b\xe1lkozzon \xfajra","error-page-blocked-user-error":"Adatai v\xe9delme \xe9rdek\xe9ben a fi\xf3kj\xe1hoz val\xf3 hozz\xe1f\xe9r\xe9st letiltottuk. A fi\xf3kj\xe1hoz val\xf3 hozz\xe1f\xe9r\xe9s visszaszerz\xe9s\xe9hez alaphelyzetbe kell \xe1ll\xedtania jelszav\xe1t. Azt javasoljuk, v\xe1lasszon egy er\u0151s, egyedi jelsz\xf3t, amelyet kor\xe1bban m\xe9g nem haszn\xe1lt.","error-page-blocked-user-error2":"A fi\xf3kj\xe1hoz val\xf3 hozz\xe1f\xe9r\xe9st letiltottuk.","error-user-exists":"Ez az e-mail c\xedm m\xe1r haszn\xe1latban van","back":"Vissza","inline-error":"Hiba t\xf6rt\xe9nt.Pr\xf3b\xe1lkozzon \xfajra.","footer-1":"Egy {{company_name}}-fi\xf3k az alkalmaz\xe1sokhoz.","footer-2":"\xa9 2026 {{company_name}} Corporation vagy t\xe1rsv\xe1llalatai. Minden jog fenntartva.","verify-email-title":"E-mail-c\xedm meger\u0151s\xedt\xe9se","verify-email-text-1":"A fi\xf3kja l\xe9trej\xf6tt.A {{company_name}}-fi\xf3k hat\xe9konyabb v\xe9delme \xe9rdek\xe9ben meg kell er\u0151s\xedten\xfcnk az e-mail-c\xedm\xe9t.Ellen\u0151rizze a(z) {{company_name}} \xe1ltal a k\xf6vetkez\u0151 c\xedmre k\xfcld\xf6tt e-mailt: <b>{{email}}</b>.K\xf6vesse az e-mailben kapott utas\xedt\xe1sokat, majd t\xe9rjen vissza ide, \xe9s kattintson a <b>Hiteles\xedt\xe9si \xe1llapot ellen\u0151rz\xe9se</b> elemre.","verify-email-text-2":"Sz\xfcks\xe9g eset\xe9n <b><a href=\\"#\\" data-action=\\"verify-email#changeEmail\\">m\xf3dos\xedthatja a {{company_name}}-fi\xf3khoz haszn\xe1lt e-mail-c\xedmet</a></b>.","verify-email-button-1.1":"Hiteles\xedt\xe9si \xe1llapot ellen\u0151rz\xe9se","verify-email-button-1.2":"Hiteles\xedt\xe9s...","verify-email-button-1.3":"Az e-mail-c\xedm nincs hiteles\xedtve","verify-email-button-2.1":"E-mail \xfajrak\xfcld\xe9se","verify-email-button-2.2":"\xdajrak\xfcld\xe9s...","verify-email-button-2.3":"E-mail elk\xfcldve","verify-email-verification-error-message":"Az \xd6n e-mail-c\xedme m\xe9g nincs hiteles\xedtve.","verify-email-toast":"Kis t\xfcrelmet, n\xe9h\xe1ny percet ig\xe9nybe vehet, am\xedg az e-mail megjelenik a postal\xe1d\xe1j\xe1ban.","change-email-title":"E-mail-c\xedm m\xf3dos\xedt\xe1sa","change-email-text":"Adja meg az e-mail-c\xedm\xe9t, hogy elk\xfcldhess\xfcnk egy e-mailt a hiteles\xedt\xe9shez.","change-email-placeholder":"\xdaj e-mail-c\xedm","change-email-button-1.1":"E-mail-c\xedm m\xf3dos\xedt\xe1sa","change-email-button-1.2":"M\xf3dos\xedt\xe1s...","reset-password-title":"Jelsz\xf3 alaphelyzetbe \xe1ll\xedt\xe1sa","reset-password-text":"Adja meg az e-mail-c\xedm\xe9t, \xe9s elk\xfcldj\xfck \xd6nnek <br/> a jelsz\xf3 vissza\xe1ll\xedt\xe1s\xe1hoz sz\xfcks\xe9ges utas\xedt\xe1sokat.","reset-password-placeholder":"E-mail-c\xedm","reset-password-button-text":"Folytat\xe1s","reset-password-success":"K\xe9rj\xfck, ellen\u0151rizze a jelsz\xf3 vissza\xe1ll\xedt\xe1s\xe1hoz <br/> sz\xfcks\xe9ges utas\xedt\xe1sok k\xe9zbes\xedt\xe9s\xe9re szolg\xe1l\xf3 <br/> {{email}} e-mail-c\xedmet .","reset-password-retry":"E-mail \xfajrak\xfcld\xe9se"}');


var $431880d11ebddbb4$exports = {};
$431880d11ebddbb4$exports = JSON.parse('{"success-page-sub-logo-text":"Un Account {{company_name}} per le tue app.","success-page-text":"Torna all\'applicazione per procedere con la configurazione.","return-to-app-button-text":"Torna a {{app}}","error-page-title":"Ops","error-page-text":"Si \xe8 verificato un problema di connessione al tuo account.","error-page-two-factor-code-expired-error":"Codice di autenticazione a due fattori scaduto","error-page-need-help-text":"Serve aiuto? <a href=\\"https://support.wdc.com\\" target=\\"_blank\\" rel=\\"noopener noreferrer\\">Consulta la nostra guida online</a>","error-page-try-again-button":"Riprova","error-page-blocked-user-error":"Per proteggere i tuoi dati, l\'accesso al tuo account \xe8 stato disabilitato. Per accedere di nuovo all\u2019account, \xe8 necessario reimpostare la password. Ti suggeriamo di scegliere una password complessa e univoca, mai usata prima.","error-page-blocked-user-error2":"L\'accesso al tuo account \xe8 stato disabilitato.","error-user-exists":"Questo indirizzo e-mail \xe8 gi\xe0 stato utilizzato","back":"Indietro","inline-error":"Si \xe8 verificato un errore. Riprova.","footer-1":"Un Account {{company_name}} per le tue app.","footer-2":"\xa9 2026 {{company_name}} Corporation o sue affiliate. Tutti i diritti riservati.","verify-email-title":"Verifica l\'indirizzo e-mail","verify-email-text-1":"Il tuo account \xe8 stato creato. Per proteggere al meglio il tuo account {{company_name}}, dobbiamo verificare il tuo indirizzo e-mail. Verifica la presenza di un\'email inviata da {{company_name}} a <b>{{email}}</b>. Segui le istruzioni contenute nell\'e-mail e poi torna qui per cliccare su <b>Controlla lo stato della verifica</b>.","verify-email-text-2":"Se lo desideri, puoi <b><a href=\\"#\\" data-action=\\"verify-email#changeEmail\\">cambiare l\'indirizzo e-mail</a></b> che utilizzi per il tuo account {{company_name}}.","verify-email-button-1.1":"Controlla lo stato della verifica","verify-email-button-1.2":"Verifica in corso...","verify-email-button-1.3":"E-mail non verificata","verify-email-button-2.1":"Invia di nuovo e-mail","verify-email-button-2.2":"Nuovo invio in corso...","verify-email-button-2.3":"E-mail inviata","verify-email-verification-error-message":"Il tuo indirizzo e-mail non \xe8 stato ancora verificato.","verify-email-toast":"Abbi pazienza, potrebbero volerci alcuni minuti prima che l\'e-mail venga visualizzata nella tua casella di posta.","change-email-title":"Modifica e-mail","change-email-text":"Inserisci il tuo indirizzo e-mail in modo da poterti inviare un\'e-mail di verifica.","change-email-placeholder":"Nuova e-mail","change-email-button-1.1":"Modifica e-mail","change-email-button-1.2":"Modifica in corso...","reset-password-title":"Reimposta password","reset-password-text":"Inserisci il tuo indirizzo e-mail e ti invieremo le istruzioni per reimpostare la password.","reset-password-placeholder":"Indirizzo e-mail","reset-password-button-text":"Continua","reset-password-success":"Controlla l\'indirizzo e-mail {{email}} per istruzioni su come reimpostare la password.","reset-password-retry":"Invia nuovamente e-mail"}');


var $92d9a57e5b734060$exports = {};
$92d9a57e5b734060$exports = JSON.parse('{"success-page-sub-logo-text":"\u30A2\u30D7\u30EA\u306B1\u4EF6\u306E{{company_name}}\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u3042\u308A\u307E\u3059\u3002","success-page-text":"\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u306B\u623B\u308B\u3068\u30BB\u30C3\u30C8\u30A2\u30C3\u30D7\u3092\u7D9A\u884C\u3057\u307E\u3059\u3002","return-to-app-button-text":"{{app}}\u306B\u623B\u308B","error-page-title":"\u7533\u3057\u8A33\u3054\u3056\u3044\u307E\u305B\u3093\u3002","error-page-text":"\u30A2\u30AB\u30A6\u30F3\u30C8\u3078\u306E\u63A5\u7D9A\u4E2D\u306B\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","error-page-two-factor-code-expired-error":"2\u8981\u7D20\u8A8D\u8A3C\u30B3\u30FC\u30C9\u306E\u671F\u9650\u304C\u5207\u308C\u3066\u3044\u307E\u3059","error-page-need-help-text":"\u30B5\u30DD\u30FC\u30C8\u304C\u5FC5\u8981\u3067\u3059\u304B\uFF1F <a href=\\"https://support.wdc.com\\" target=\\"_blank\\" rel=\\"noopener noreferrer\\">\u30AA\u30F3\u30E9\u30A4\u30F3\u30D8\u30EB\u30D7\u30B5\u30A4\u30C8\u306B\u30A2\u30AF\u30BB\u30B9</a>","error-page-try-again-button":"\u518D\u8A66\u884C","error-page-blocked-user-error":"\u304A\u5BA2\u69D8\u306E\u30C7\u30FC\u30BF\u3092\u4FDD\u8B77\u3059\u308B\u305F\u3081\u306B\u3001\u304A\u4F7F\u3044\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u304C\u7121\u52B9\u306B\u306A\u3063\u3066\u3044\u307E\u3059\u3002\u30A2\u30AB\u30A6\u30F3\u30C8\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u56DE\u5FA9\u3059\u308B\u306B\u306F\u3001\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002\u3053\u308C\u307E\u3067\u4F7F\u7528\u3057\u305F\u3053\u3068\u306E\u306A\u3044\u5F37\u529B\u306A\u4E00\u610F\u306E\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u304A\u9078\u3073\u3044\u305F\u3060\u304F\u3053\u3068\u3092\u304A\u52E7\u3081\u3044\u305F\u3057\u307E\u3059\u3002","error-page-blocked-user-error2":"\u304A\u4F7F\u3044\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u304C\u7121\u52B9\u306B\u306A\u3063\u3066\u3044\u307E\u3059\u3002","error-user-exists":"\u3053\u306E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306F\u3059\u3067\u306B\u4F7F\u7528\u3055\u308C\u3066\u3044\u307E\u3059","back":"\u623B\u308B","inline-error":"\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002 \u518D\u8A66\u884C\u3057\u3066\u304F\u3060\u3055\u3044\u3002","footer-1":"\u30A2\u30D7\u30EA\u306B1\u4EF6\u306E{{company_name}}\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u3042\u308A\u307E\u3059\u3002","footer-2":"\xa9 2026 {{company_name}} Corporation or its affiliates. All rights reserved.","verify-email-title":"\u30E1\u30FC\u30EB\u306E\u78BA\u8A8D","verify-email-text-1":"\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u4F5C\u6210\u3055\u308C\u307E\u3057\u305F\u3002{{company_name}}\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u9069\u5207\u306B\u4FDD\u8B77\u3059\u308B\u305F\u3081\u306B\u3001\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u78BA\u8A8D\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002{{company_name}}\u304B\u3089<b>{{email}}</b>\u306B\u9001\u4FE1\u3055\u308C\u305F\u30E1\u30FC\u30EB\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002 \u30E1\u30FC\u30EB\u306B\u8A18\u8F09\u3055\u308C\u305F\u624B\u9806\u306B\u5F93\u3063\u3066\u3053\u3061\u3089\u306B\u623B\u308A\uFF3B<b>\u78BA\u8A8D\u30B9\u30C6\u30FC\u30BF\u30B9\u3092\u30C1\u30A7\u30C3\u30AF</b>\uFF3D\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u307E\u3059\u3002","verify-email-text-2":"\u5FC5\u8981\u306B\u5FDC\u3058\u3066\u3001{{company_name}}\u30A2\u30AB\u30A6\u30F3\u30C8\u3067\u4F7F\u7528\u3059\u308B<b><a href=\\"#\\" data-action=\\"verify-email#changeEmail\\">\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5909\u66F4</a></b>\u3067\u304D\u307E\u3059\u3002","verify-email-button-1.1":"\u78BA\u8A8D\u30B9\u30C6\u30FC\u30BF\u30B9\u3092\u30C1\u30A7\u30C3\u30AF","verify-email-button-1.2":"\u78BA\u8A8D\u4E2D...","verify-email-button-1.3":"\u30E1\u30FC\u30EB\u304C\u78BA\u8A8D\u3055\u308C\u307E\u305B\u3093\u3067\u3057\u305F","verify-email-button-2.1":"\u30E1\u30FC\u30EB\u3092\u518D\u9001\u4FE1","verify-email-button-2.2":"\u518D\u9001\u4FE1\u4E2D...","verify-email-button-2.3":"\u30E1\u30FC\u30EB\u3092\u9001\u4FE1\u3057\u307E\u3057\u305F","verify-email-verification-error-message":"\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306F\u307E\u3060\u78BA\u8A8D\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002","verify-email-toast":"\u30E1\u30FC\u30EB\u304C\u9001\u4FE1\u3055\u308C\u308B\u307E\u3067\u306B\u3057\u3070\u3089\u304F\u304B\u304B\u308A\u307E\u3059\u306E\u3067\u3001\u304A\u5F85\u3061\u304F\u3060\u3055\u3044\u3002","change-email-title":"\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5909\u66F4","change-email-text":"\u78BA\u8A8D\u30E1\u30FC\u30EB\u3092\u9001\u4FE1\u3067\u304D\u308B\u3088\u3046\u306B\u3001\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002","change-email-placeholder":"\u65B0\u3057\u3044\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9","change-email-button-1.1":"\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5909\u66F4","change-email-button-1.2":"\u5909\u66F4\u3057\u3066\u3044\u307E\u3059...","reset-password-title":"\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u30EA\u30BB\u30C3\u30C8","reset-password-text":"\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u30EA\u30BB\u30C3\u30C8\u306B\u5FC5\u8981\u306A\u624B\u9806\u304C\u9001\u4FE1\u3055\u308C\u307E\u3059\u3002","reset-password-placeholder":"\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9","reset-password-button-text":"\u7D9A\u3051\u308B","reset-password-success":"\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u30EA\u30BB\u30C3\u30C8\u306B\u5FC5\u8981\u306A\u624B\u9806\u306E\u9001\u4FE1\u5148\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9 {{email}} \u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002","reset-password-retry":"\u30E1\u30FC\u30EB\u306E\u518D\u9001\u4FE1"}');


var $2bf28c51bb668546$exports = {};
$2bf28c51bb668546$exports = JSON.parse('{"success-page-sub-logo-text":"\uC571\uC5D0 \uB300\uD55C 1\uAC1C\uC758 {{company_name}} \uACC4\uC815.","success-page-text":"\uC560\uD50C\uB9AC\uCF00\uC774\uC158\uC73C\uB85C \uB3CC\uC544\uAC00 \uC124\uC815\uC744 \uACC4\uC18D \uC9C4\uD589\uD558\uC2ED\uC2DC\uC624.","return-to-app-button-text":"{{app}} \uC571\uC73C\uB85C \uB3CC\uC544\uAC00\uAE30","error-page-title":"\uC8C4\uC1A1\uD569\uB2C8\uB2E4.","error-page-text":"\uACC4\uC815\uC5D0 \uC5F0\uACB0\uD558\uB294 \uB3D9\uC548 \uBB38\uC81C\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4.","error-page-two-factor-code-expired-error":"2\uB2E8\uACC4 \uC778\uC99D \uCF54\uB4DC\uAC00 \uB9CC\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4","error-page-need-help-text":"\uB3C4\uC6C0\uC774 \uD544\uC694\uD558\uC2ED\uB2C8\uAE4C? <a href=\\"https://support.wdc.com\\" target=\\"_blank\\" rel=\\"noopener noreferrer\\">\uC628\uB77C\uC778 \uB3C4\uC6C0\uB9D0 \uC0AC\uC774\uD2B8 \uBC29\uBB38\uD558\uAE30</a>","error-page-try-again-button":"\uB2E4\uC2DC \uC2DC\uB3C4\uD558\uC2ED\uC2DC\uC624","error-page-blocked-user-error":"\uC0AC\uC6A9\uC790\uC758 \uB370\uC774\uD130\uB97C \uBCF4\uD638\uD558\uAE30 \uC704\uD574 \uACC4\uC815\uC5D0 \uB300\uD55C \uC561\uC138\uC2A4\uAC00 \uBE44\uD65C\uC131\uD654\uB418\uC5C8\uC2B5\uB2C8\uB2E4. \uACC4\uC815\uC5D0 \uB2E4\uC2DC \uC561\uC138\uC2A4\uD558\uB824\uBA74 \uC554\uD638\uB97C \uC7AC\uC124\uC815\uD574\uC57C \uD569\uB2C8\uB2E4. \uC774\uC804\uC5D0 \uC0AC\uC6A9\uD55C \uC801\uC774 \uC5C6\uB294 \uAC15\uB825\uD558\uACE0 \uACE0\uC720\uD55C \uC554\uD638\uB97C \uC120\uD0DD\uD558\uB294 \uAC83\uC774 \uC88B\uC2B5\uB2C8\uB2E4.","error-page-blocked-user-error2":"\uACC4\uC815\uC5D0 \uB300\uD55C \uC561\uC138\uC2A4\uAC00 \uBE44\uD65C\uC131\uD654\uB418\uC5C8\uC2B5\uB2C8\uB2E4.","error-user-exists":"\uC774\uBBF8 \uC0AC\uC6A9\uB41C \uC774\uBA54\uC77C \uC8FC\uC18C\uC784","back":"\uB4A4\uB85C","inline-error":"\uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4. \uB2E4\uC2DC \uC2DC\uB3C4\uD558\uC2ED\uC2DC\uC624.","footer-1":"\uC571\uC5D0 \uB300\uD55C 1\uAC1C\uC758 {{company_name}} \uACC4\uC815.","footer-2":"\xa9 2026 {{company_name}} \uB610\uB294 \uACC4\uC5F4\uC0AC All rights reserved.","verify-email-title":"\uC774\uBA54\uC77C \uD655\uC778","verify-email-text-1":"\uACC4\uC815\uC744 \uC0DD\uC131\uD588\uC2B5\uB2C8\uB2E4. {{company_name}} \uACC4\uC815\uC744 \uBCF4\uB2E4 \uC548\uC804\uD558\uAC8C \uBCF4\uD638\uD558\uB824\uBA74 \uC774\uBA54\uC77C \uC8FC\uC18C\uB97C \uD655\uC778\uD574\uC57C \uD569\uB2C8\uB2E4. {{company_name}}\uC5D0\uC11C <b>{{email}}</b>(\uC73C)\uB85C \uC804\uC1A1\uB41C \uC774\uBA54\uC77C\uC744 \uD655\uC778\uD558\uC2ED\uC2DC\uC624. \uC774\uBA54\uC77C\uC5D0 \uC788\uB294 \uC9C0\uCE68\uC744 \uB530\uB978 \uB2E4\uC74C\uC5D0 \uC5EC\uAE30\uB85C \uB3CC\uC544\uC640 <b>\uD655\uC778 \uC0C1\uD0DC \uD655\uC778</b>\uC744 \uD074\uB9AD\uD558\uC2ED\uC2DC\uC624.","verify-email-text-2":"\uD544\uC694\uD55C \uACBD\uC6B0, {{company_name}} \uACC4\uC815\uC5D0\uC11C \uC0AC\uC6A9\uD558\uB294 <b><a href=\\"#\\" data-action=\\"verify-email#changeEmail\\">\uC774\uBA54\uC77C \uC8FC\uC18C\uB97C \uBCC0\uACBD</a></b>\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.","verify-email-button-1.1":"\uD655\uC778 \uC0C1\uD0DC \uD655\uC778","verify-email-button-1.2":"\uD655\uC778 \uC911...","verify-email-button-1.3":"\uC774\uBA54\uC77C\uC774 \uD655\uC778\uB418\uC9C0 \uC54A\uC74C","verify-email-button-2.1":"\uC774\uBA54\uC77C \uC7AC\uC804\uC1A1","verify-email-button-2.2":"\uC7AC\uC804\uC1A1 \uC911...","verify-email-button-2.3":"\uC774\uBA54\uC77C\uC774 \uC804\uC1A1\uB428","verify-email-verification-error-message":"\uC774\uBA54\uC77C \uC8FC\uC18C\uB97C \uC544\uC9C1 \uD655\uC778\uD558\uC9C0 \uBABB\uD588\uC2B5\uB2C8\uB2E4.","verify-email-toast":"\uC774\uBA54\uC77C\uC774 \uBC1B\uC740 \uD3B8\uC9C0\uD568\uC5D0 \uD45C\uC2DC\uB418\uB294 \uB370 \uBA87 \uBD84\uC774 \uAC78\uB9B4 \uC218 \uC788\uC2B5\uB2C8\uB2E4.","change-email-title":"\uC774\uBA54\uC77C \uC120\uD0DD","change-email-text":"\uD655\uC778\uD560 \uC774\uBA54\uC77C\uC744 \uBCF4\uB0BC \uC218 \uC788\uB3C4\uB85D \uC774\uBA54\uC77C \uC8FC\uC18C\uB97C \uC785\uB825\uD558\uC2ED\uC2DC\uC624.","change-email-placeholder":"\uC0C8\uB85C\uC6B4 \uC774\uBA54\uC77C","change-email-button-1.1":"\uC774\uBA54\uC77C \uC120\uD0DD","change-email-button-1.2":"\uBCC0\uACBD \uC911...","reset-password-title":"\uC554\uD638 \uC7AC\uC124\uC815","reset-password-text":"\uC774\uBA54\uC77C \uC8FC\uC18C\uB97C \uC785\uB825\uD558\uBA74 \uBE44\uBC00\uBC88\uD638 \uC7AC\uC124\uC815 \uC9C0\uCE68\uC744 \uBCF4\uB0B4\uB4DC\uB9BD\uB2C8\uB2E4.","reset-password-placeholder":"\uC774\uBA54\uC77C \uC8FC\uC18C","reset-password-button-text":"\uACC4\uC18D","reset-password-success":"\uBE44\uBC00\uBC88\uD638 \uC7AC\uC124\uC815 \uC9C0\uCE68\uC744 \uC704\uD574 {{email}} \uC774\uBA54\uC77C \uC8FC\uC18C\uB97C \uD655\uC778\uD558\uC138\uC694.","reset-password-retry":"\uC774\uBA54\uC77C \uC7AC\uC804\uC1A1"}');


var $f68d446659acf1fc$exports = {};
$f68d446659acf1fc$exports = JSON.parse('{"success-page-sub-logo-text":"\xc9n {{company_name}}-konto til alle appene dine.","success-page-text":"G\xe5 tilbake til applikasjonen for \xe5 fortsette installasjonen.","return-to-app-button-text":"G\xe5 tilbake til {{app}}","error-page-title":"Uff da!","error-page-text":"Vi oppdaget et problem da vi koblet til kontoen din.","error-page-two-factor-code-expired-error":"Kode for tofaktorautentisering utl\xf8pt","error-page-need-help-text":"Trenger du hjelp? <a href=\\"https://support.wdc.com\\" target=\\"_blank\\" rel=\\"noopener noreferrer\\">Bes\xf8k hjelpesiden v\xe5r p\xe5 nettet</a>","error-page-try-again-button":"Pr\xf8v p\xe5 nytt","error-page-blocked-user-error":"For \xe5 beskytte dataene dine, er tilgang til kontoen din deaktivert. For \xe5 f\xe5 tilgang til kontoen din igjen, m\xe5 du tilbakestille passordet. Vi anbefaler at du velger et sterkt, unikt passord som du aldri har brukt f\xf8r.","error-page-blocked-user-error2":"Tilgang til kontoen din deaktivert.","error-user-exists":"Denne e-postadressen er allerede i bruk","back":"Tilbake","inline-error":"Noe gikk galt. Pr\xf8v p\xe5 nytt.","footer-1":"\xc9n {{company_name}}-konto til alle appene dine.","footer-2":"\xa9 2026 {{company_name}} Corporation eller deres tilknyttede selskaper. Med enerett.","verify-email-title":"Bekreft e-postadressen din","verify-email-text-1":"Kontoen din har blitt opprettet. For bedre \xe5 beskytte {{company_name}}-kontoen din, m\xe5 vi bekrefte e-postadressen din. Se etter en e-post som ble sendt fra {{company_name}} til <b>{{email}}</b>. F\xf8lg instruksjonene i e-posten og kom tilbake hit og klikk p\xe5 <b>Sjekk bekreftelsesstatus</b>.","verify-email-text-2":"Om du vil, kan du <b><a href=\\"#\\" data-action=\\"verify-email#changeEmail\\">endre e-postadressen</a></b> du bruker med {{company_name}}-kontoen din.","verify-email-button-1.1":"Sjekk bekreftelsesstatus","verify-email-button-1.2":"Bekrefter ...","verify-email-button-1.3":"E-postadressen ble ikke bekreftet","verify-email-button-2.1":"Send e-post p\xe5 nytt","verify-email-button-2.2":"Sender p\xe5 nytt ...","verify-email-button-2.3":"E-post sendt","verify-email-verification-error-message":"E-postadressen din er ikke bekreftet enn\xe5.","verify-email-toast":"V\xe6r t\xe5lmodig! Det kan ta noen minutter f\xf8r e-posten dukker opp i innboksen din.","change-email-title":"Endre e-postadresse","change-email-text":"Angi e-postadressen din, slik at vi kan sende deg en e-post for \xe5 bekrefte adressen.","change-email-placeholder":"Ny e-post","change-email-button-1.1":"Endre e-postadresse","change-email-button-1.2":"Endrer ...","reset-password-title":"Tilbakestill passord","reset-password-text":"Skriv inn e-postadressen din, <br/> s\xe5 sender vi deg instruksjoner for \xe5 tilbakestille passordet.","reset-password-placeholder":"E-postadresse","reset-password-button-text":"Fortsett","reset-password-success":"Sjekk e-postadressen {{email}} <br/> for \xe5 f\xe5 instruksjoner om hvordan <br/> du tilbakestiller passordet.","reset-password-retry":"Send e-post p\xe5 nytt"}');


var $90317269451af2df$exports = {};
$90317269451af2df$exports = JSON.parse('{"success-page-sub-logo-text":"E\xe9n {{company_name}}-account voor je apps.","success-page-text":"Ga terug naar de toepassing om door te gaan met instellen.","return-to-app-button-text":"Ga terug naar {{app}}","error-page-title":"Oeps!","error-page-text":"We zijn een probleem tegengekomen bij het maken van verbinding met je account.","error-page-two-factor-code-expired-error":"De code voor tweeledige verificatie is verlopen","error-page-need-help-text":"Hulp nodig? <a href=\\"https://support.wdc.com\\" target=\\"_blank\\" rel=\\"noopener noreferrer\\">Bezoek onze online Help-site</a>","error-page-try-again-button":"Probeer het opnieuw","error-page-blocked-user-error":"Ter bescherming van je gegevens is de toegang tot je account uitgeschakeld. Als je opnieuw toegang tot je account wilt krijgen, moet je je wachtwoord opnieuw instellen. We stellen voor dat je een sterk, uniek wachtwoord selecteert dat je nooit eerder hebt gebruikt.","error-page-blocked-user-error2":"De toegang tot je account is uitgeschakeld.","error-user-exists":"Dit e-mailadres wordt al gebruikt","back":"Terug","inline-error":"Er is iets misgegaan. Probeer het opnieuw.","footer-1":"E\xe9n {{company_name}}-account voor je apps.","footer-2":"\xa9 2026 {{company_name}} Corporation of haar dochterondernemingen. Alle rechten voorbehouden.","verify-email-title":"Je e-mail verifi\xebren","verify-email-text-1":"Je account wordt gemaakt. Om je {{company_name}}-account beter te kunnen beschermen, moeten we je e-mailadres verifi\xebren. Controleer op een e-mail die door {{company_name}} is verzenden naar <b>{{email}}</b>. Volg de instructies in de e-mail en keer vervolgens hier terug en klik op <b>Verificatiestatus controleren</b>.","verify-email-text-2":"Indien nodig, kun je <b><a href=\\"#\\" data-action=\\"verify-email#changeEmail\\">het e-mailadres wijzigen</a></b> dat je gebruikt voor je {{company_name}}-account.","verify-email-button-1.1":"Verificatiestatus controleren","verify-email-button-1.2":"Bezig met verifi\xebren...","verify-email-button-1.3":"E-mail niet geverifieerd","verify-email-button-2.1":"E-mail opnieuw verzenden","verify-email-button-2.2":"Bezig met opnieuw verzenden...","verify-email-button-2.3":"E-mail verzonden","verify-email-verification-error-message":"Je e-mailadres is nog niet geverifieerd.","verify-email-toast":"Een ogenblik geduld. Het kan enkele minuten duren voordat de e-mail in je postvak verschijnt.","change-email-title":"E-mail wijzigen ","change-email-text":"Voer je e-mailadres in zodat we je een e-mail kunnen sturen ter verificatie.","change-email-placeholder":"Nieuwe e-mail","change-email-button-1.1":"E-mail wijzigen ","change-email-button-1.2":"Bezig met wijzigen\u2026","reset-password-title":"Wachtwoord opnieuw instellen","reset-password-text":"Voer uw e-mailadres in. Dan sturen we u <br/> instructies om uw wachtwoord opnieuw <br/> in te stellen.","reset-password-placeholder":"E-mailadres","reset-password-button-text":"Doorgaan","reset-password-success":"Controleer het e-mailadres {{email}} <br/> voor instructies om uw wachtwoord <br/> opnieuw in te stellen.","reset-password-retry":"E-mail opnieuw verzenden"}');


var $7094030991333075$exports = {};
$7094030991333075$exports = JSON.parse('{"success-page-sub-logo-text":"Jedno konto {{company_name}} dla Twoich aplikacji.","success-page-text":"Wr\xf3\u0107 do aplikacji, aby kontynuowa\u0107 konfiguracj\u0119.","return-to-app-button-text":"Wr\xf3\u0107 do {{app}}","error-page-title":"Ups!","error-page-text":"Nast\u0105pi\u0142 problem podczas pr\xf3by po\u0142\u0105czenia z\xa0kontem.","error-page-two-factor-code-expired-error":"Kod uwierzytelniania dwusk\u0142adnikowego wygas\u0142","error-page-need-help-text":"Potrzebujesz pomocy? <a href=\\"https://support.wdc.com\\" target=\\"_blank\\" rel=\\"noopener noreferrer\\">Odwied\u017A nasz\u0105 stron\u0119 pomocy</a>","error-page-try-again-button":"Spr\xf3buj ponownie","error-page-blocked-user-error":"Dost\u0119p do Twojego konta zosta\u0142 zablokowany w\xa0celu ochrony danych. Aby odzyska\u0107 dost\u0119p do konta, musisz zresetowa\u0107 has\u0142o. Sugerujemy podanie silnego, nietypowego has\u0142a, kt\xf3re nie by\u0142o jeszcze u\u017Cywane.","error-page-blocked-user-error2":"Dost\u0119p do Twojego konta zosta\u0142 zablokowany.","error-user-exists":"Ten adres e-mail jest ju\u017C u\u017Cywany","back":"Wstecz","inline-error":"Co\u015B posz\u0142o nie tak. Spr\xf3buj ponownie.","footer-1":"Jedno konto {{company_name}} dla Twoich aplikacji.","footer-2":"\xa9 2026 {{company_name}} Corporation lub jej podmioty zale\u017Cne. Wszelkie prawa zastrze\u017Cone.","verify-email-title":"Zweryfikuj sw\xf3j adres e-mail","verify-email-text-1":"Utworzono konto. Aby lepiej chroni\u0107 Twoje konto w\xa0{{company_name}}, musisz zweryfikowa\u0107 sw\xf3j adres e-mail. Sprawd\u017A, czy otrzyma\u0142e\u015B wiadomo\u015B\u0107 e-mail z {{company_name}} na <b>{{email}}</b>. Post\u0119puj zgodnie z instrukcjami zawartymi w wiadomo\u015Bci e-mail, a nast\u0119pnie wr\xf3\u0107 tutaj i kliknij <b>Sprawd\u017A status weryfikacji</b>.","verify-email-text-2":"W razie potrzeby mo\u017Cesz <b><a href=\\"#\\" data-action=\\"verify-email#changeEmail\\">zmieni\u0107 adres e-mail</a></b> u\u017Cywany do obs\u0142ugi {{company_name}} konta.","verify-email-button-1.1":"Sprawd\u017A status weryfikacji","verify-email-button-1.2":"Weryfikowanie\u2026","verify-email-button-1.3":"Adres e-mail niezweryfikowany","verify-email-button-2.1":"Ponownie wy\u015Blij wiadomo\u015B\u0107 e-mail","verify-email-button-2.2":"Ponowne wysy\u0142anie\u2026","verify-email-button-2.3":"Wys\u0142ano wiadomo\u015B\u0107 e-mail","verify-email-verification-error-message":"Tw\xf3j adres e-mail nie jest jeszcze zweryfikowany.","verify-email-toast":"B\u0105d\u017A cierpliwy, mo\u017Ce min\u0105\u0107 kilka minut, zanim wiadomo\u015B\u0107 e-mail pojawi si\u0119 w skrzynce odbiorczej.","change-email-title":"Zmie\u0144 e-mail","change-email-text":"Wpisz sw\xf3j adres e-mail, aby\u015Bmy mogli wys\u0142a\u0107 Ci wiadomo\u015B\u0107 w celu weryfikacji.","change-email-placeholder":"Nowy e-mail","change-email-button-1.1":"Zmie\u0144 e-mail","change-email-button-1.2":"Zmienianie\u2026","reset-password-title":"Resetowanie has\u0142a","reset-password-text":"Wpisz sw\xf3j adres e-mail, <br/> a my wy\u015Blemy Ci instrukcje resetowania has\u0142a.","reset-password-placeholder":"Adres e-mail","reset-password-button-text":"Kontynuuj","reset-password-success":"Sprawd\u017A adres e-mail {{email}}, <br/> aby uzyska\u0107 instrukcje dotycz\u0105ce <br/> resetowania has\u0142a.","reset-password-retry":"Wy\u015Blij email ponownie"}');


var $eef01ff82f89d720$exports = {};
$eef01ff82f89d720$exports = JSON.parse('{"success-page-sub-logo-text":"Uma Conta {{company_name}} para os seus aplicativos.","success-page-text":"Voltar para o aplicativo para continuar a configura\xe7\xe3o.","return-to-app-button-text":"Voltar para {{app}}","error-page-title":"Epa!","error-page-text":"N\xf3s encontramos um problema ao conectar com a sua conta.","error-page-two-factor-code-expired-error":"C\xf3digo de autentica\xe7\xe3o de dois fatores expirado","error-page-need-help-text":"Precisa de ajuda? <a href=\\"https://support.wdc.com\\" target=\\"_blank\\" rel=\\"noopener noreferrer\\">Visite nosso site de ajuda on-line</a>","error-page-try-again-button":"Tente novamente","error-page-blocked-user-error":"Para proteger seus dados, o acesso \xe0 sua conta foi desativado. Para obter acesso novamente \xe0 sua conta, voc\xea precisa redefinir a sua senha. N\xf3s sugerimos que voc\xea selecione uma senha exclusiva forte que voc\xea nunca tenha usado antes.","error-page-blocked-user-error2":"O acesso \xe0 sua conta foi desativado.","error-user-exists":"Este endere\xe7o de e-mail j\xe1 est\xe1 sendo usado","back":"Voltar","inline-error":"Algo deu errado. Tente novamente.","footer-1":"Uma Conta {{company_name}} para os seus aplicativos.","footer-2":"\xa9 2026 {{company_name}} Corporation ou suas afiliadas. Todos os direitos reservados.","verify-email-title":"Verificar o seu e-mail","verify-email-text-1":"Sua conta est\xe1 criada. Para melhor proteger a sua conta {{company_name}}, precisamos confirmar o seu endere\xe7o de e-mail. Verifique um e-mail enviado por {{company_name}} para <b>{{email}}</b>. Siga as instru\xe7\xf5es no e-mail e depois volte aqui para clicar em <b>Verificar status da confirma\xe7\xe3o</b>.","verify-email-text-2":"Se for necess\xe1rio, voc\xea pode <b><a href=\\"#\\" data-action=\\"verify-email#changeEmail\\">alterar o endere\xe7o de e-mail</a></b> que usa para a sua conta {{company_name}}.","verify-email-button-1.1":"Verificar status da confirma\xe7\xe3o","verify-email-button-1.2":"Confirmando...","verify-email-button-1.3":"E-mail n\xe3o confirmado","verify-email-button-2.1":"Reenviar e-mail","verify-email-button-2.2":"Reenviando...","verify-email-button-2.3":"E-mail enviado","verify-email-verification-error-message":"Seu endere\xe7o de e-mail ainda n\xe3o est\xe1 confirmado.","verify-email-toast":"Tenha paci\xeancia, pode levar alguns minutos para que o e-mail apare\xe7a na sua caixa de entrada.","change-email-title":"Alterar e-mail","change-email-text":"Informe seu endere\xe7o de e-mail para que possamos enviar a voc\xea um e-mail para confirmar.","change-email-placeholder":"Novo e-mail","change-email-button-1.1":"Alterar e-mail","change-email-button-1.2":"Alterando...","reset-password-title":"Redefinir senha","reset-password-text":"Insira seu endere\xe7o de e-mail e lhe enviaremos <br/> instru\xe7\xf5es para redefinir sua senha.","reset-password-placeholder":"Endere\xe7o de e-mail","reset-password-button-text":"Continuar","reset-password-success":"Verifique o endere\xe7o de e-mail {{email}} <br/> para ver instru\xe7\xf5es de como redefinir sua senha.","reset-password-retry":"Reenviar e-mail"}');


var $9c7f0c8424cb6f59$exports = {};
$9c7f0c8424cb6f59$exports = JSON.parse('{"success-page-sub-logo-text":"\u041E\u0434\u043D\u0430 \u0443\u0447\u0435\u0442\u043D\u0430\u044F \u0437\u0430\u043F\u0438\u0441\u044C {{company_name}} \u0434\u043B\u044F \u0432\u0430\u0448\u0438\u0445 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0439.","success-page-text":"\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u0432 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435, \u0447\u0442\u043E\u0431\u044B \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0443.","return-to-app-button-text":"\u041D\u0430\u0437\u0430\u0434 \u0432 {{app}}","error-page-title":"\u041E\u0448\u0438\u0431\u043A\u0430!","error-page-text":"\u041F\u0440\u0438 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0438 \u043A \u0432\u0430\u0448\u0435\u0439 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 \u0432\u043E\u0437\u043D\u0438\u043A\u043B\u0430 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0430.","error-page-two-factor-code-expired-error":"\u0418\u0441\u0442\u0435\u043A \u0441\u0440\u043E\u043A \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u043A\u043E\u0434\u0430 \u0434\u0432\u0443\u0445\u0444\u0430\u043A\u0442\u043E\u0440\u043D\u043E\u0439 \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438","error-page-need-help-text":"\u041D\u0443\u0436\u043D\u0430 \u043F\u043E\u043C\u043E\u0449\u044C? <a href=\\"https://support.wdc.com\\" target=\\"_blank\\" rel=\\"noopener noreferrer\\">\u041F\u0435\u0440\u0435\u0439\u0434\u0438\u0442\u0435 \u043D\u0430 \u043D\u0430\u0448 \u0441\u0430\u0439\u0442 \u0441\u043F\u0440\u0430\u0432\u043A\u0438</a>","error-page-try-again-button":"\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043F\u043E\u043F\u044B\u0442\u043A\u0443","error-page-blocked-user-error":"\u0412 \u0446\u0435\u043B\u044F\u0445 \u0437\u0430\u0449\u0438\u0442\u044B \u0432\u0430\u0448\u0438\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u0432\u0430\u0448\u0435\u0439 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 \u043E\u0442\u043A\u043B\u044E\u0447\u0435\u043D. \u0427\u0442\u043E\u0431\u044B \u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u0441\u0432\u043E\u0435\u0439 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438, \u0432\u0430\u043C \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0441\u0431\u0440\u043E\u0441\u0438\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C. \u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C \u0432\u044B\u0431\u0440\u0430\u0442\u044C \u043D\u0430\u0434\u0435\u0436\u043D\u044B\u0439 \u0438 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u0432\u044B \u043D\u0438\u043A\u043E\u0433\u0434\u0430 \u0440\u0430\u043D\u0435\u0435 \u043D\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043B\u0438.","error-page-blocked-user-error2":"\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0432\u0430\u0448\u0435\u0439 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 \u043E\u0442\u043A\u043B\u044E\u0447\u0435\u043D.","error-user-exists":"\u042D\u0442\u043E\u0442 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B \u0443\u0436\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442\u0441\u044F","back":"\u041D\u0430\u0437\u0430\u0434","inline-error":"\u0427\u0442\u043E-\u0442\u043E \u043F\u043E\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A. \u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043F\u043E\u043F\u044B\u0442\u043A\u0443.","footer-1":"\u041E\u0434\u043D\u0430 \u0443\u0447\u0435\u0442\u043D\u0430\u044F \u0437\u0430\u043F\u0438\u0441\u044C {{company_name}} \u0434\u043B\u044F \u0432\u0430\u0448\u0438\u0445 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0439.","footer-2":"\xa9 {{company_name}} Corporation \u0438\u043B\u0438 \u0435\u0435 \u0430\u0444\u0444\u0438\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0435 \u043B\u0438\u0446\u0430, 2026 \u0433. \u0412\u0441\u0435 \u043F\u0440\u0430\u0432\u0430 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u044B.","verify-email-title":"\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u0441\u0432\u043E\u0439 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B","verify-email-text-1":"\u0423\u0447\u0435\u0442\u043D\u0430\u044F \u0437\u0430\u043F\u0438\u0441\u044C \u0441\u043E\u0437\u0434\u0430\u043D\u0430. \u0414\u043B\u044F \u043F\u043E\u0432\u044B\u0448\u0435\u043D\u0438\u044F \u0437\u0430\u0449\u0438\u0442\u044B \u0441\u0432\u043E\u0435\u0439 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 {{company_name}} \u0432\u0430\u043C \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u043F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C \u0441\u0432\u043E\u0439 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B. \u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u043D\u0430\u043B\u0438\u0447\u0438\u0435 \u043F\u0438\u0441\u044C\u043C\u0430, \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u043E\u0433\u043E \u043E\u0442 {{company_name}} \u043D\u0430 \u0430\u0434\u0440\u0435\u0441 <b>{{email}}</b>. \u0421\u043B\u0435\u0434\u0443\u0439\u0442\u0435 \u0438\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u044F\u043C \u0432 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u043C \u043F\u0438\u0441\u044C\u043C\u0435, \u0437\u0430\u0442\u0435\u043C \u0432\u0435\u0440\u043D\u0438\u0442\u0435\u0441\u044C \u0441\u044E\u0434\u0430, \u0447\u0442\u043E\u0431\u044B \u043D\u0430\u0436\u0430\u0442\u044C \u043A\u043D\u043E\u043F\u043A\u0443 <b>\u041F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C \u0441\u0442\u0430\u0442\u0443\u0441 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F</b>.","verify-email-text-2":"\u041F\u0440\u0438 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E\u0441\u0442\u0438 \u0432\u044B \u043C\u043E\u0436\u0435\u0442\u0435 <b><a href=\\"#\\" data-action=\\"verify-email#changeEmail\\">\u0438\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B</a></b>, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u0432\u044B \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442\u0435 \u0434\u043B\u044F \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 {{company_name}}.","verify-email-button-1.1":"\u041F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C \u0441\u0442\u0430\u0442\u0443\u0441 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F","verify-email-button-1.2":"\u041F\u0440\u043E\u0432\u0435\u0440\u043A\u0430...","verify-email-button-1.3":"\u0410\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B \u043D\u0435 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D","verify-email-button-2.1":"\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E","verify-email-button-2.2":"\u041F\u043E\u0432\u0442\u043E\u0440\u043D\u0430\u044F \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0430...","verify-email-button-2.3":"\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E","verify-email-verification-error-message":"\u0412\u0430\u0448 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B \u0435\u0449\u0435 \u043D\u0435 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D.","verify-email-toast":"\u041D\u0435 \u0442\u043E\u0440\u043E\u043F\u0438\u0442\u0435\u0441\u044C, \u043C\u043E\u0436\u0435\u0442 \u043F\u0440\u043E\u0439\u0442\u0438 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u043C\u0438\u043D\u0443\u0442, \u043F\u0440\u0435\u0436\u0434\u0435 \u0447\u0435\u043C \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0435 \u043F\u0438\u0441\u044C\u043C\u043E \u043F\u043E\u044F\u0432\u0438\u0442\u0441\u044F \u0432 \u043F\u0430\u043F\u043A\u0435 \u0432\u0445\u043E\u0434\u044F\u0449\u0438\u0445 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0439.","change-email-title":"\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B","change-email-text":"\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0441\u0432\u043E\u0439 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B, \u0447\u0442\u043E\u0431\u044B \u043C\u044B \u043C\u043E\u0433\u043B\u0438 \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0432\u0430\u043C \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0435 \u043F\u0438\u0441\u044C\u043C\u043E \u0434\u043B\u044F \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F.","change-email-placeholder":"\u041D\u043E\u0432\u044B\u0439 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B","change-email-button-1.1":"\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B","change-email-button-1.2":"\u0418\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0435...","reset-password-title":"\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C","reset-password-text":"\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B, <br/> \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0438\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u0438 \u043F\u043E \u0441\u043C\u0435\u043D\u0435 \u043F\u0430\u0440\u043E\u043B\u044F.","reset-password-placeholder":"\u0410\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B","reset-password-button-text":"\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C","reset-password-success":"\u041C\u044B \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u0438\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u0438 \u043F\u043E \u0441\u0431\u0440\u043E\u0441\u0443 \u043F\u0430\u0440\u043E\u043B\u044F <br/> \u043D\u0430 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B: {{email}}. <br/> \u0423\u0431\u0435\u0434\u0438\u0442\u0435\u0441\u044C, \u0447\u0442\u043E \u0432\u0430\u043C \u043F\u0440\u0438\u0448\u043B\u043E \u043F\u0438\u0441\u044C\u043C\u043E.","reset-password-retry":"\u041F\u043E\u0432\u0442\u043E\u0440\u043D\u043E \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043F\u0438\u0441\u044C\u043C\u043E \u043D\u0430 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0443\u044E \u043F\u043E\u0447\u0442\u0443"}');


var $27420302afe287db$exports = {};
$27420302afe287db$exports = JSON.parse('{"success-page-sub-logo-text":"Jeden \xfa\u010Det {{company_name}} pre v\u0161etky va\u0161e aplik\xe1cie.","success-page-text":"Ak chcete pokra\u010Dova\u0165 s nastaven\xedm, vr\xe1\u0165te sa do aplik\xe1cie.","return-to-app-button-text":"Vr\xe1ti\u0165 sa do aplik\xe1cie {{app}}","error-page-title":"Ojoj!","error-page-text":"Vyskytol sa probl\xe9m s pripojen\xedm k v\xe1\u0161mu \xfa\u010Dtu.","error-page-two-factor-code-expired-error":"Vypr\u0161ala platnos\u0165 k\xf3du pre dvoj\xfarov\u0148ov\xe9 overovanie","error-page-need-help-text":"Potrebujete pomoc? <a href=\\"https://support.wdc.com\\" target=\\"_blank\\" rel=\\"noopener noreferrer\\">Nav\u0161t\xedvte n\xe1\u0161 web pomoci online</a>","error-page-try-again-button":"Sk\xfaste to znova","error-page-blocked-user-error":"Pr\xedstup do v\xe1\u0161ho \xfa\u010Dtu sme deaktivovali, aby sme ochr\xe1nili va\u0161e \xfadaje. Ak chcete do svojho \xfa\u010Dtu znova z\xedska\u0165 pr\xedstup, mus\xedte resetova\u0165 heslo. Odpor\xfa\u010Dame zvoli\u0165 siln\xe9, jedine\u010Dn\xe9 heslo, ktor\xe9 ste e\u0161te nikdy nepou\u017E\xedvali.","error-page-blocked-user-error2":"Pr\xedstup do v\xe1\u0161ho \xfa\u010Dtu bol zak\xe1zan\xfd.","error-user-exists":"T\xe1to e-mailov\xe1 adresa sa u\u017E pou\u017E\xedva","back":"Sp\xe4\u0165","inline-error":"Vyskytol sa probl\xe9m. Sk\xfaste to znova.","footer-1":"Jeden \xfa\u010Det {{company_name}} pre v\u0161etky va\u0161e aplik\xe1cie.","footer-2":"\xa9 2026 {{company_name}} Corporation a jej pridru\u017Een\xe9 spolo\u010Dnosti. V\u0161etky pr\xe1va vyhraden\xe9.","verify-email-title":"Overte svoj e-mail","verify-email-text-1":"V\xe1\u0161 \xfa\u010Det bol vytvoren\xfd. Z d\xf4vodu lep\u0161ej ochrany v\xe1\u0161ho \xfa\u010Dtu {{company_name}} mus\xedme overi\u0165 va\u0161u e-mailov\xfa adresu. Skontrolujte e-maily odoslan\xe9 spolo\u010Dnos\u0165ou {{company_name}} na e-mail <b>{{email}}</b>. Pod\u013Ea pokynov v\xa0e-maili sa vr\xe1\u0165te sem a kliknite na mo\u017Enos\u0165 <b>Skontrolova\u0165 stav overenia</b>.","verify-email-text-2":"V\xa0pr\xedpade potreby m\xf4\u017Eete <b><a href=\\"#\\" data-action=\\"verify-email#changeEmail\\">zmeni\u0165 e-mailov\xfa adresu</a></b>, ktor\xfa pou\u017E\xedvate s\xa0\xfa\u010Dtom {{company_name}}.","verify-email-button-1.1":"Skontrolova\u0165 stav overenia","verify-email-button-1.2":"Overuje sa\u2026","verify-email-button-1.3":"E-mail nebol overen\xfd","verify-email-button-2.1":"Odosla\u0165 e-mail znova","verify-email-button-2.2":"Odosiela sa znova\u2026","verify-email-button-2.3":"E-mail bol odoslan\xfd","verify-email-verification-error-message":"Va\u0161a e-mailov\xe1 adresa e\u0161te nie je overen\xe1.","verify-email-toast":"Bu\u010Fte trpezliv\xed, e-mail sa m\xf4\u017Ee objavi\u0165 vo va\u0161ej po\u0161te a\u017E za nieko\u013Eko min\xfat.","change-email-title":"Zmeni\u0165 e-mail","change-email-text":"Zadajte e-mailov\xfa adresu, na ktor\xfa v\xe1m po\u0161leme overovac\xed e-mail.","change-email-placeholder":"Nov\xfd e-mail","change-email-button-1.1":"Zmeni\u0165 e-mail","change-email-button-1.2":"Men\xed sa\u2026","reset-password-title":"Obnovi\u0165 heslo","reset-password-text":"Zadajte e-mailov\xfa adresu, <br/> aby sme v\xe1m mohli posla\u0165 pokyny <br/> na obnovenie hesla.","reset-password-placeholder":"E-mailov\xe1 adresa","reset-password-button-text":"Pokra\u010Dova\u0165","reset-password-success":"Skontrolujte e-mailov\xfa adresu <br/> {{email}}, kde n\xe1jdete pokyny na <br/> resetovanie hesla.","reset-password-retry":"Op\xe4tovne zasla\u0165 e-mail"}');


var $ab2d101383674107$exports = {};
$ab2d101383674107$exports = JSON.parse('{"success-page-sub-logo-text":"Ett {{company_name}}-konto f\xf6r dina appar.","success-page-text":"\xc5terv\xe4nd till applikationen f\xf6r att forts\xe4tta installeringen.","return-to-app-button-text":"\xc5terg\xe5 till {{app}}","error-page-title":"Hoppsan!","error-page-text":"Vi st\xf6tte p\xe5 ett problem n\xe4r vi ansl\xf6t till ditt konto.","error-page-two-factor-code-expired-error":"Koden f\xf6r tv\xe5faktorsautentisering har g\xe5tt ut","error-page-need-help-text":"Beh\xf6ver du hj\xe4lp? <a href=\\"https://support.wdc.com\\" target=\\"_blank\\" rel=\\"noopener noreferrer\\">Bes\xf6k v\xe5r hj\xe4lpsida online</a>","error-page-try-again-button":"F\xf6rs\xf6k igen","error-page-blocked-user-error":"F\xf6r att skydda din data har \xe5tkomst till ditt konto inaktiverats. F\xf6r att \xe5terf\xe5 \xe5tkomst till ditt konto m\xe5ste du \xe5terst\xe4lla ditt l\xf6senord. Vi f\xf6resl\xe5r att du v\xe4ljer ett starkt, unikt l\xf6senord som du aldrig har anv\xe4nt tidigare.","error-page-blocked-user-error2":"\xc5tkomsten till ditt konto har inaktiverats.","error-user-exists":"Denna e-postadress \xe4r upptagen","back":"Tillbaka","inline-error":"N\xe5got gick fel. F\xf6rs\xf6k igen.","footer-1":"Ett {{company_name}}-konto f\xf6r dina appar.","footer-2":"\xa9 2026 {{company_name}} Corporation eller dess dotterbolag. Alla r\xe4ttigheter f\xf6rbeh\xe5lles.","verify-email-title":"Verifiera din e-postadress","verify-email-text-1":"Ditt konto har skapats. F\xf6r att skydda ditt {{company_name}}-konto b\xe4ttre beh\xf6ver vi verifiera din e-postadress. S\xf6k efter en e-post som skickats fr\xe5n {{company_name}} till <b>{{email}}</b>. F\xf6lj instruktionerna i e-postmeddelandet g\xe5 sedan tillbaka hit f\xf6r att klicka p\xe5 <b>Kontrollera verifieringsstatus</b>.","verify-email-text-2":"Om du beh\xf6ver kan du <b><a href=\\"#\\" data-action=\\"verify-email#changeEmail\\">\xe4ndra e-postadressen</a></b> som du anv\xe4nder f\xf6r ditt {{company_name}}-konto.","verify-email-button-1.1":"Kontrollera verifieringsstatus","verify-email-button-1.2":"Verifierar ...","verify-email-button-1.3":"E-post ej verifierad","verify-email-button-2.1":"Skicka e-post igen","verify-email-button-2.2":"Skickar igen ...","verify-email-button-2.3":"Email har skickats","verify-email-verification-error-message":"Din e-postadress \xe4r \xe4nnu inte verifierad.","verify-email-toast":"Ha t\xe5lamod, det kan ta n\xe5gra minuter innan e-postmeddelandet visas i din inkorg.","change-email-title":"\xc4ndra e-post","change-email-text":"Ange din e-postadress s\xe5 att vi kan skicka ett e-postmeddelande f\xf6r att verifiera.","change-email-placeholder":"Ny e-post","change-email-button-1.1":"\xc4ndra e-post","change-email-button-1.2":"\xc4ndrar ...","reset-password-title":"\xc5terst\xe4ll l\xf6senord","reset-password-text":"Ange din e-postadress f\xf6r att f\xe5 <br/> instruktioner om hur du \xe5terst\xe4ller ditt l\xf6senord.","reset-password-placeholder":"E-postadress","reset-password-button-text":"Forts\xe4tt","reset-password-success":"Kontrollera e-postadressen {{email}} <br/> d\xe4r du har f\xe5tt instruktioner om <br/> hur du \xe5terst\xe4ller ditt l\xf6senord.","reset-password-retry":"Skicka e-postmeddelandet igen"}');


var $0db1c10508cf4d6c$exports = {};
$0db1c10508cf4d6c$exports = JSON.parse('{"success-page-sub-logo-text":"Uygulamalar\u0131n\u0131z i\xe7in bir {{company_name}} Hesab\u0131.","success-page-text":"Kuruluma devam etmek i\xe7in uygulamaya geri d\xf6n\xfcn.","return-to-app-button-text":"{{app}} \xf6\u011Fesine geri d\xf6n","error-page-title":"Eyvah!","error-page-text":"Hesab\u0131n\u0131z\u0131 ba\u011Flarken bir sorunla kar\u015F\u0131la\u015Ft\u0131k.","error-page-two-factor-code-expired-error":"\u0130ki fakt\xf6rl\xfc do\u011Frulama kodunun s\xfcresi doldu","error-page-need-help-text":"Yard\u0131ma m\u0131 ihtiyac\u0131n\u0131z var? <a href=\\"https://support.wdc.com\\" target=\\"_blank\\" rel=\\"noopener noreferrer\\">\xc7evrimi\xe7i yard\u0131m sitemizi ziyaret edin</a>","error-page-try-again-button":"Tekrar deneyin","error-page-blocked-user-error":"Verilerinizi korumak i\xe7in hesab\u0131n\u0131z devre d\u0131\u015F\u0131 b\u0131rak\u0131ld\u0131. Hesab\u0131n\u0131za yeniden eri\u015Fim kazanmak i\xe7in parolan\u0131z\u0131 s\u0131f\u0131rlaman\u0131z gerekir. Daha \xf6nce kullanmad\u0131\u011F\u0131n\u0131z g\xfc\xe7l\xfc, benzersiz bir parola se\xe7menizi \xf6neriyoruz.","error-page-blocked-user-error2":"Hesab\u0131n\u0131za eri\u015Fim devre d\u0131\u015F\u0131 b\u0131rak\u0131ld\u0131.","error-user-exists":"Bu e-posta adresi zaten kullan\u0131l\u0131yor","back":"Geri","inline-error":"Bir \u015Feyler ters gitti. Tekrar deneyin.","footer-1":"Uygulamalar\u0131n\u0131z i\xe7in bir {{company_name}} Hesab\u0131.","footer-2":"\xa9 2026 {{company_name}} Corporation veya i\u015Ftriakleri. T\xfcm haklar\u0131 sakl\u0131d\u0131r.","verify-email-title":"E-postan\u0131z\u0131 do\u011Frulay\u0131n","verify-email-text-1":"Hesab\u0131n\u0131z olu\u015Fturuldu. {{company_name}} Hesab\u0131n\u0131z\u0131 daha iyi korumak i\xe7in e-posta adresinizi do\u011Frulamam\u0131z gerekiyor. {{company_name}} \u015Firketinden <b>{{email}}</b> adresine e-posta gelip gelmedi\u011Fini kontrol edin. E-postadaki talimatlar\u0131 uygulay\u0131n, sonras\u0131nda buraya geri d\xf6nerek <b>Do\u011Frulama durumunu kontrol et</b> \xf6\u011Fesine t\u0131klay\u0131n.","verify-email-text-2":"\u0130htiya\xe7 duyarsan\u0131z, {{company_name}} hesab\u0131n\u0131z i\xe7in kulland\u0131\u011F\u0131n\u0131z <b><a href=\\"#\\" data-action=\\"verify-email#changeEmail\\">e-posta adresini de\u011Fi\u015Ftirebilirsiniz</a></b>.","verify-email-button-1.1":"Do\u011Frulama durumunu kontrol et","verify-email-button-1.2":"Do\u011Frulan\u0131yor...","verify-email-button-1.3":"E-posta do\u011Frulanmad\u0131","verify-email-button-2.1":"E-postay\u0131 yeniden g\xf6nder","verify-email-button-2.2":"Yeniden g\xf6nderiliyor...","verify-email-button-2.3":"E-posta g\xf6nderildi","verify-email-verification-error-message":"E-posta adresiniz hen\xfcz do\u011Frulanmad\u0131.","verify-email-toast":"Sab\u0131rl\u0131 olun, e-postan\u0131n gelen kutunuza d\xfc\u015Fmesi birka\xe7 dakika s\xfcrebilir.","change-email-title":"E-postay\u0131 de\u011Fi\u015Ftir","change-email-text":"Size do\u011Frulama e-postas\u0131 g\xf6nderebilmemiz i\xe7in e-posta adresinizi girin.","change-email-placeholder":"Yeni e-posta","change-email-button-1.1":"E-postay\u0131 de\u011Fi\u015Ftir","change-email-button-1.2":"De\u011Fi\u015Ftiriliyor...","reset-password-title":"\u015Eifreyi S\u0131f\u0131rla","reset-password-text":"E-posta adresinizi girin, <br/> parolan\u0131z\u0131 s\u0131f\u0131rlamak i\xe7in size <br/> talimatlar g\xf6nderece\u011Fiz.","reset-password-placeholder":"E-posta adresi","reset-password-button-text":"Devam","reset-password-success":"Parolan\u0131z\u0131 s\u0131f\u0131rlama talimatlar\u0131 i\xe7in <br/> l\xfctfen {{email}} e-posta adresini kontrol edin.","reset-password-retry":"E-postay\u0131 yeniden g\xf6nder"}');


var $e7aec43c64d9a34e$exports = {};
$e7aec43c64d9a34e$exports = JSON.parse('{"success-page-sub-logo-text":"\u7528\u4E8E\u60A8\u7684\u5E94\u7528\u7A0B\u5E8F\u7684\u4E00\u4E2A {{company_name}} \u5E10\u6237\u3002","success-page-text":"\u8FD4\u56DE\u5E94\u7528\u7A0B\u5E8F\u4EE5\u7EE7\u7EED\u8BBE\u7F6E\u3002","return-to-app-button-text":"\u8FD4\u56DE {{app}}","error-page-title":"\u7CDF\u7CD5\uFF01","error-page-text":"\u6211\u4EEC\u5728\u8FDE\u63A5\u60A8\u7684\u5E10\u6237\u65F6\u9047\u5230\u95EE\u9898\u3002","error-page-two-factor-code-expired-error":"\u53CC\u56E0\u7D20\u8EAB\u4EFD\u9A8C\u8BC1\u4EE3\u7801\u5DF2\u8FC7\u671F","error-page-need-help-text":"\u9700\u8981\u5E2E\u52A9\uFF1F <a href=\\"https://support.wdc.com\\" target=\\"_blank\\" rel=\\"noopener noreferrer\\">\u8BBF\u95EE\u5728\u7EBF\u5E2E\u52A9\u7F51\u7AD9</a>","error-page-try-again-button":"\u91CD\u8BD5","error-page-blocked-user-error":"\u4E3A\u4FDD\u62A4\u6570\u636E\uFF0C\u5BF9\u60A8\u5E10\u6237\u7684\u8BBF\u95EE\u5DF2\u88AB\u7981\u6B62\u3002\u8981\u91CD\u65B0\u8BBF\u95EE\u5E10\u6237\uFF0C\u60A8\u5FC5\u987B\u91CD\u7F6E\u5BC6\u7801\u3002\u6211\u4EEC\u5EFA\u8BAE\u60A8\u9009\u62E9\u4E00\u4E2A\u4ECE\u672A\u4F7F\u7528\u8FC7\u3001\u5F3A\u5EA6\u9AD8\u4E14\u5355\u72EC\u4F7F\u7528\u7684\u5BC6\u7801\u3002","error-page-blocked-user-error2":"\u5BF9\u60A8\u5E10\u6237\u7684\u8BBF\u95EE\u5DF2\u7981\u6B62\u3002","error-user-exists":"\u6B64\u7535\u5B50\u90AE\u4EF6\u5730\u5740\u5DF2\u88AB\u4F7F\u7528","back":"\u8FD4\u56DE","inline-error":"\u51FA\u73B0\u95EE\u9898\u3002\u8BF7\u91CD\u8BD5\u3002","footer-1":"\u7528\u4E8E\u60A8\u7684\u5E94\u7528\u7A0B\u5E8F\u7684\u4E00\u4E2A {{company_name}} \u5E10\u6237\u3002","footer-2":"\xa9 2026 {{company_name}} Corporation \u6216\u5176\u9644\u5C5E\u516C\u53F8\u3002\u4FDD\u7559\u6240\u6709\u6743\u5229\u3002","verify-email-title":"\u9A8C\u8BC1\u60A8\u7684\u7535\u5B50\u90AE\u4EF6","verify-email-text-1":"\u60A8\u7684\u5E10\u6237\u5DF2\u521B\u5EFA\u3002\u4E3A\u4E86\u66F4\u597D\u5730\u4FDD\u62A4\u60A8\u7684 {{company_name}} \u5E10\u6237\uFF0C\u60A8\u5FC5\u987B\u9A8C\u8BC1\u60A8\u7684\u7535\u5B50\u90AE\u4EF6\u5730\u5740\u3002\u68C0\u67E5\u4ECE {{company_name}} \u53D1\u9001\u5230 <b>{{email}}</b> \u7684\u7535\u5B50\u90AE\u4EF6\u3002\u8BF7\u6309\u7167\u7535\u5B50\u90AE\u4EF6\u4E2D\u7684\u8BF4\u660E\u8FDB\u884C\u64CD\u4F5C\uFF0C\u7136\u540E\u8FD4\u56DE\u6B64\u5904\u5355\u51FB<b>\u68C0\u67E5\u9A8C\u8BC1\u72B6\u6001</b>\u3002","verify-email-text-2":"\u5982\u679C\u9700\u8981\uFF0C\u60A8\u53EF\u4EE5<b><a href=\\"#\\" data-action=\\"verify-email#changeEmail\\">\u66F4\u6539\u7528\u4E8E {{company_name}} \u5E10\u6237\u7684\u7535\u5B50\u90AE\u4EF6\u5730\u5740</a></b>\u3002","verify-email-button-1.1":"\u68C0\u67E5\u9A8C\u8BC1\u72B6\u6001","verify-email-button-1.2":"\u6B63\u5728\u9A8C\u8BC1...","verify-email-button-1.3":"\u7535\u5B50\u90AE\u4EF6\u672A\u9A8C\u8BC1","verify-email-button-2.1":"\u91CD\u65B0\u53D1\u9001\u7535\u5B50\u90AE\u4EF6","verify-email-button-2.2":"\u6B63\u5728\u91CD\u65B0\u53D1\u9001...","verify-email-button-2.3":"\u7535\u5B50\u90AE\u4EF6\u5DF2\u53D1\u9001","verify-email-verification-error-message":"\u60A8\u7684\u7535\u5B50\u90AE\u4EF6\u5730\u5740\u5C1A\u672A\u9A8C\u8BC1\u3002","verify-email-toast":"\u8BF7\u8010\u5FC3\u7B49\u5F85\uFF0C\u7535\u5B50\u90AE\u4EF6\u53EF\u80FD\u9700\u8981\u51E0\u5206\u949F\u624D\u4F1A\u51FA\u73B0\u5728\u60A8\u7684\u6536\u4EF6\u7BB1\u4E2D\u3002","change-email-title":"\u66F4\u6539\u7535\u5B50\u90AE\u4EF6","change-email-text":"\u8BF7\u8F93\u5165\u60A8\u7684\u7535\u5B50\u90AE\u4EF6\u5730\u5740\uFF0C\u4EE5\u4FBF\u6211\u4EEC\u5411\u60A8\u53D1\u9001\u9A8C\u8BC1\u7535\u5B50\u90AE\u4EF6\u3002","change-email-placeholder":"\u65B0\u7535\u5B50\u90AE\u4EF6","change-email-button-1.1":"\u66F4\u6539\u7535\u5B50\u90AE\u4EF6","change-email-button-1.2":"\u6B63\u5728\u66F4\u6539...","reset-password-title":"\u91CD\u8BBE\u5BC6\u7801","reset-password-text":"\u8BF7\u8F93\u5165\u60A8\u7684\u7535\u5B50\u90AE\u4EF6\u5730\u5740\uFF0C\u6211\u4EEC\u5C06\u5411\u60A8\u53D1\u9001\u91CD\u7F6E\u5BC6\u7801\u7684\u8BF4\u660E\u3002","reset-password-placeholder":"\u7535\u5B50\u90AE\u4EF6\u5730\u5740","reset-password-button-text":"\u7EE7\u7EED","reset-password-success":"\u8BF7\u68C0\u67E5\u7535\u5B50\u90AE\u4EF6\u5730\u5740 {{email}}\uFF0C<br/> \u4E86\u89E3\u91CD\u7F6E\u5BC6\u7801\u7684\u8BF4\u660E\u3002","reset-password-retry":"\u91CD\u65B0\u53D1\u9001\u7535\u5B50\u90AE\u4EF6"}');


var $7144144b8405608f$exports = {};
$7144144b8405608f$exports = JSON.parse('{"success-page-sub-logo-text":"\u4E00\u500B {{company_name}} \u5E33\u6236\uFF0C\u9069\u7528\u65BC\u60A8\u7684\u6240\u6709\u61C9\u7528\u7A0B\u5F0F\u3002","success-page-text":"\u8FD4\u56DE\u61C9\u7528\u7A0B\u5F0F\uFF0C\u4EE5\u7E7C\u7E8C\u9032\u884C\u8A2D\u5B9A\u3002","return-to-app-button-text":"\u8FD4\u56DE {{app}}","error-page-title":"\u7CDF\u7CD5\uFF01","error-page-text":"\u9023\u7DDA\u81F3\u60A8\u7684\u5E33\u6236\u6642\u9047\u5230\u554F\u984C\u3002","error-page-two-factor-code-expired-error":"\u96D9\u56E0\u7D20\u9A57\u8B49\u4EE3\u78BC\u904E\u671F","error-page-need-help-text":"\u9700\u8981\u5354\u52A9\u55CE\uFF1F <a href=\\"https://support.wdc.com\\" target=\\"_blank\\" rel=\\"noopener noreferrer\\">\u8A2A\u554F\u7DDA\u4E0A\u8AAA\u660E\u7DB2\u7AD9</a>","error-page-try-again-button":"\u91CD\u8A66","error-page-blocked-user-error":"\u70BA\u4FDD\u8B77\u60A8\u7684\u8CC7\u6599\uFF0C\u5C0D\u60A8\u5E33\u6236\u7684\u5B58\u53D6\u6B0A\u9650\u5DF2\u88AB\u505C\u7528\u3002\u8981\u91CD\u65B0\u5B58\u53D6\u60A8\u7684\u5E33\u6236\uFF0C\u60A8\u5FC5\u9808\u91CD\u8A2D\u5BC6\u78BC\u3002\u6211\u5011\u5EFA\u8B70\u60A8\u9078\u64C7\u4E00\u500B\u4EE5\u524D\u5F9E\u672A\u4F7F\u7528\u904E\u7684\uFF0C\u5B89\u5168\u6027\u8F03\u9AD8\u7684\u552F\u4E00\u5BC6\u78BC\u3002","error-page-blocked-user-error2":"\u5C0D\u60A8\u5E33\u6236\u7684\u5B58\u53D6\u6B0A\u9650\u5DF2\u88AB\u505C\u7528\u3002","error-user-exists":"\u6B64\u96FB\u5B50\u90F5\u4EF6\u5730\u5740\u5DF2\u4F7F\u7528","back":"\u8FD4\u56DE","inline-error":"\u51FA\u73FE\u554F\u984C\u3002\u91CD\u8A66\u3002","footer-1":"\u4E00\u500B {{company_name}} \u5E33\u6236\uFF0C\u9069\u7528\u65BC\u60A8\u7684\u6240\u6709\u61C9\u7528\u7A0B\u5F0F\u3002","footer-2":"\xa9 2026 {{company_name}} Corporation \u6216\u5176\u95DC\u4FC2\u4F01\u696D\u3002\u7248\u6B0A\u6240\u6709\u3002","verify-email-title":"\u9A57\u8B49\u60A8\u7684\u96FB\u5B50\u90F5\u4EF6","verify-email-text-1":"\u5DF2\u5EFA\u7ACB\u60A8\u7684\u5E33\u6236\u3002\u70BA\u4FDD\u8B77\u60A8\u7684 {{company_name}} \u5E33\u6236\uFF0C\u60A8\u5FC5\u9808\u9A57\u8B49\u60A8\u7684\u96FB\u5B50\u90F5\u4EF6\u5730\u5740\u3002\u6AA2\u67E5\u5F9E {{company_name}} \u50B3\u9001\u81F3 <b>{{email}}</b> \u7684\u96FB\u5B50\u90F5\u4EF6\u3002\u6309\u7167\u96FB\u5B50\u90F5\u4EF6\u4E2D\u7684\u8AAA\u660E\u64CD\u4F5C\u5F8C\uFF0C\u56DE\u5230\u6B64\u8655\u6309\u4E00\u4E0B<b>\u6AA2\u8996\u9A57\u8B49\u72C0\u614B</b>\u3002","verify-email-text-2":"\u5982\u60A8\u9700\u8981\uFF0C\u60A8\u53EF\u4EE5<b><a href=\\"#\\" data-action=\\"verify-email#changeEmail\\">\u8B8A\u66F4\u96FB\u5B50\u90F5\u4EF6\u5730\u5740</a></b>\u4EE5\u4FBF\u7528\u65BC\u81EA\u5DF1\u7684 {{company_name}} \u5E33\u6236\u3002","verify-email-button-1.1":"\u6AA2\u8996\u9A57\u8B49\u72C0\u614B","verify-email-button-1.2":"\u9A57\u8B49...","verify-email-button-1.3":"\u96FB\u5B50\u90F5\u4EF6\u672A\u9A57\u8B49","verify-email-button-2.1":"\u91CD\u65B0\u50B3\u9001\u96FB\u5B50\u90F5\u4EF6","verify-email-button-2.2":"\u91CD\u65B0\u50B3\u9001...","verify-email-button-2.3":"\u96FB\u5B50\u90F5\u4EF6\u5DF2\u50B3\u9001","verify-email-verification-error-message":"\u60A8\u7684\u96FB\u5B50\u90F5\u4EF6\u5C1A\u672A\u9A57\u8B49\u3002","verify-email-toast":"\u8ACB\u8010\u5FC3\u7B49\u5019\uFF0C\u96FB\u5B50\u90F5\u4EF6\u53EF\u80FD\u9700\u8981\u5E7E\u5206\u9418\u624D\u80FD\u51FA\u73FE\u5728\u60A8\u7684\u6536\u4EF6\u5323\u4E2D\u3002","change-email-title":"\u8B8A\u66F4\u96FB\u5B50\u90F5\u4EF6","change-email-text":"\u8F38\u5165\u60A8\u7684\u96FB\u5B50\u90F5\u4EF6\u5730\u5740\uFF0C\u4EE5\u4FBF\u6211\u5011\u5411\u60A8\u50B3\u9001\u96FB\u5B50\u90F5\u4EF6\u4EE5\u9032\u884C\u9A57\u8B49\u3002","change-email-placeholder":"\u65B0\u96FB\u5B50\u90F5\u4EF6","change-email-button-1.1":"\u8B8A\u66F4\u96FB\u5B50\u90F5\u4EF6","change-email-button-1.2":"\u8B8A\u66F4...","reset-password-title":"\u91CD\u8A2D\u5BC6\u78BC","reset-password-text":"\u8ACB\u8F38\u5165\u60A8\u7684\u96FB\u5B50\u90F5\u4EF6\u5730\u5740\uFF0C\u6211\u5011\u5C07\u6703\u50B3\u9001\u6307\u793A\u7D66\u60A8\u4EE5\u4FBF\u91CD\u8A2D\u60A8\u7684\u5BC6\u78BC\u3002","reset-password-placeholder":"\u96FB\u5B50\u90F5\u4EF6\u5730\u5740","reset-password-button-text":"\u7E7C\u7E8C","reset-password-success":"\u8ACB\u67E5\u770B\u96FB\u5B50\u90F5\u4EF6\u5730\u5740\uFF1A{{email}}\uFF0C<br/> \u4EE5\u53D6\u5F97\u91CD\u8A2D\u60A8\u5BC6\u78BC\u7684\u6307\u793A\u3002","reset-password-retry":"\u91CD\u65B0\u50B3\u9001\u96FB\u5B50\u90F5\u4EF6"}');


var $1521e8c4c0232360$export$2e2bcd8739ae039 = {
    cs: (/*@__PURE__*/$parcel$interopDefault($b3e28066947b9fe1$exports)),
    da: (/*@__PURE__*/$parcel$interopDefault($ae7908dc6063fdc7$exports)),
    de: (/*@__PURE__*/$parcel$interopDefault($578dd4c2dfdedf29$exports)),
    el: (/*@__PURE__*/$parcel$interopDefault($288fb4462e10fb6f$exports)),
    en: (/*@__PURE__*/$parcel$interopDefault($3d464347f9f3a992$exports)),
    es: (/*@__PURE__*/$parcel$interopDefault($de6dba7c8e8a8f85$exports)),
    fi: (/*@__PURE__*/$parcel$interopDefault($aa7533656934a9e9$exports)),
    fr: (/*@__PURE__*/$parcel$interopDefault($640cefc443ccf9c9$exports)),
    hu: (/*@__PURE__*/$parcel$interopDefault($217f7e685d0c4b7e$exports)),
    it: (/*@__PURE__*/$parcel$interopDefault($431880d11ebddbb4$exports)),
    ja: (/*@__PURE__*/$parcel$interopDefault($92d9a57e5b734060$exports)),
    ko: (/*@__PURE__*/$parcel$interopDefault($2bf28c51bb668546$exports)),
    nb: (/*@__PURE__*/$parcel$interopDefault($f68d446659acf1fc$exports)),
    nl: (/*@__PURE__*/$parcel$interopDefault($90317269451af2df$exports)),
    pl: (/*@__PURE__*/$parcel$interopDefault($7094030991333075$exports)),
    'pt-BR': (0, (/*@__PURE__*/$parcel$interopDefault($eef01ff82f89d720$exports))),
    ru: (/*@__PURE__*/$parcel$interopDefault($9c7f0c8424cb6f59$exports)),
    sk: (/*@__PURE__*/$parcel$interopDefault($27420302afe287db$exports)),
    sv: (/*@__PURE__*/$parcel$interopDefault($ab2d101383674107$exports)),
    tr: (/*@__PURE__*/$parcel$interopDefault($0db1c10508cf4d6c$exports)),
    'zh-CN': (0, (/*@__PURE__*/$parcel$interopDefault($e7aec43c64d9a34e$exports))),
    'zh-TW': (0, (/*@__PURE__*/$parcel$interopDefault($7144144b8405608f$exports)))
};


const $56b308b684bb3a7c$export$f533e92afa8097ff = (localeCode)=>{
    // return early if no localeCode is set
    if (!localeCode) return false;
    const longCodeMatch = Object.keys((0, $1521e8c4c0232360$export$2e2bcd8739ae039)).find((l)=>l === localeCode.replace('_', '-'));
    if (longCodeMatch) return longCodeMatch;
    return Object.keys((0, $1521e8c4c0232360$export$2e2bcd8739ae039)).find((l)=>l.split('-')[0] === localeCode.replace('_', '-').split('-')[0]);
};
const $56b308b684bb3a7c$export$97aac956da55dae9 = $56b308b684bb3a7c$export$f533e92afa8097ff((0, $2f1387074b88af05$export$ca000e230c0caa3e).get('ui_locales')) || $56b308b684bb3a7c$export$f533e92afa8097ff((0, $2f1387074b88af05$export$ca000e230c0caa3e).get('locale')) || $56b308b684bb3a7c$export$f533e92afa8097ff(navigator.language || navigator.browserLanguage) || 'en';
var $56b308b684bb3a7c$export$2e2bcd8739ae039 = (0, $1521e8c4c0232360$export$2e2bcd8739ae039);



var // Falling back to 'en' in case the `locale` passed in `state`
// is not supported for a specific string:
$07298ebac3ba71d2$export$2e2bcd8739ae039 = (key, options = {})=>{
    const opts = {
        ...options,
        // predefined variables
        app: (0, $2f1387074b88af05$export$ca000e230c0caa3e).get('app'),
        company_name: 'Western Digital'
    };
    // eslint-disable-next-line import/no-named-as-default-member
    const string = (0, $56b308b684bb3a7c$export$2e2bcd8739ae039)[0, $56b308b684bb3a7c$export$97aac956da55dae9]?.[key] || (0, $56b308b684bb3a7c$export$2e2bcd8739ae039).en[key] || `[missing translation: ${key}]`;
    return string.replace(/\{{(.+?)}}/g, (_, match)=>opts[match]);
};


const $ddfd49b8c61c6cd2$export$20c28856b6c1341a = {
    DEFAULT: 'DEFAULT',
    REQUEST: 'REQUEST',
    REQUEST_DONE: 'REQUEST_DONE'
};


/* eslint-disable import/no-unresolved */ // .ejs templates:
var $c80176b663f805c9$exports = {};
$c80176b663f805c9$exports = "<p><%- t('success-page-sub-logo-text') %></p>\n\n<br>\n\n<%- include('loader', { r: 15, w: 2 }) %>\n";


var $fd4ac07aa6811e12$exports = {};
$fd4ac07aa6811e12$exports = "<div class=\"graphics-container graphics-container--smaller\">\n  <img src=\"/verification.4a499786.svg\" alt=\"\">\n</div>\n\n<h1><%- t('verify-email-title') %></h1>\n\n<p class=\"text-align-center\"><%- t('verify-email-text-1', { email }) %></p>\n\n<p class=\"text-align-center\"><%- t('verify-email-text-2', { email }) %></p>\n\n<%\n  text1 = checkButtonState === BUTTON_STATES.REQUEST && t('verify-email-button-1.2')\n    || checkButtonState === BUTTON_STATES.REQUEST_DONE && t('verify-email-button-1.3')\n    || t('verify-email-button-1.1');\n%>\n\n<%- include('button-primary', { action: a('checkUser'), text: text1, state: checkButtonState }) %>\n\n<br>\n\n<%\n  text2 = resendButtonState === BUTTON_STATES.REQUEST && t('verify-email-button-2.2')\n    || resendButtonState === BUTTON_STATES.REQUEST_DONE && t('verify-email-button-2.3')\n    || t('verify-email-button-2.1');\n%>\n\n<%- include('button-secondary', { action: a('resendEmail'), text: text2, state: resendButtonState }) %>\n\n<br>\n\n<% if (toastMessage) { %>\n  <p class=\"toast\">\n    <%- include('info') %>\n    <%- toastMessage %>\n  </p>\n<% } %>\n\n<% if (error) { %>\n  <p class=\"error\">\n    <%- include('info') %>\n    <%- t('inline-error') %>\n  </p>\n<% } %>\n\n<% if (isRechecked) { %>\n  <p class=\"error\">\n    <%- include('info') %>\n    <%- t('verify-email-verification-error-message') %>\n  </p>\n<% } %>\n";


var $554d368f656a3a2b$exports = {};
$554d368f656a3a2b$exports = "<a href=\"#\" data-action=\"<%- a('goBack') %>\" class=\"back-button\">← <%- t('back') %></a>\n\n<h1><%- t('change-email-title') %></h1>\n\n<p class=\"text-align-center\"><%- t('change-email-text') %></p>\n\n<form action=\"#\" data-action=\"<%- a('submit') %>\">\n  <input name=\"email\" type=\"email\" placeholder=\"<%- t('change-email-placeholder') %>\" required=\"\" pattern=\"^[a-zA-Z0-9_\\-]+(\\.[a-zA-Z0-9_\\-]+){0,}(\\+[a-zA-Z0-9_\\-]+(\\.[a-zA-Z0-9_\\-]+){0,})?@([a-zA-Z0-9_\\-]+\\.)+[a-zA-Z]{2,}$\" data-action=\"<%- a('onInputChange') %>\" value=\"<%- value %>\">\n\n  <!--\n    pattern in the input above mathes this group:\n\n    ```\n    a1sd.as1d@gmail.com\n    a1sd+as1d@gmail.com\n    a1sd+as1d.asd@gmail.com\n    a1sd.a1sd+a1sd.a1sd@gmail.com\n    a1sdasd@gmail.com\n    a1s@gmail.com\n    a@gmail.com\n    ```\n\n    ...and does not match this group:\n\n    ```\n    .asd@gmail.com\n    asd.@gmail.com\n    asd.+as1d@gmail.com\n    asd+.as1d@gmail.com\n    asd+as1d.asd.@gmail.com\n    asd+as1d+asd@gmail.com\n    asd..as1d@gmail.com\n    asd+as1d..asd@gmail.com\n    as1d@gmail..com\n    as1d@gmail+gmail.com\n    ```\n  -->\n\n  <br>\n\n  <%\n    text = submitButtonState === BUTTON_STATES.DEFAULT && t('change-email-button-1.1')\n      || t('change-email-button-1.2')\n  %>\n\n  <%- include('button-primary', { text, state: submitButtonState }) %>\n\n  <% if (error) { %>\n    <p class=\"error\">\n      <%- include('info') %>\n      <%- error %>\n    </p>\n  <% } %>\n</form>\n";


var $9db403260ccc30a4$exports = {};
$9db403260ccc30a4$exports = "<h1><%- t('error-page-title') %></h1>\n\n<p><%- t('error-page-text') %></p>\n\n<p><%- description %></p>\n\n<div class=\"graphics-container\">\n  <img src=\"/error.2eda618f.svg\" width=\"80\" height=\"80\" alt=\"\">\n</div>\n\n<p><%- t('error-page-need-help-text') %></p>\n\n<% if (showButtons) { %>\n\n  <%- include('button-primary', { action: a('onLinkClick'), text: t('error-page-try-again-button') }) %>\n\n  <br>\n\n  <%- include('button-secondary', { action: a('onLinkClick'), text: t('return-to-app-button-text') }) %>\n\n<% } %>\n";


var $dfa982266a1b3771$exports = {};
$dfa982266a1b3771$exports = "<img height=\"25\" width=\"180\" src=\"/logo@2x.cf83b63b.png\">\n\n<p class=\"text-sublogo\"><%- t('success-page-sub-logo-text') %></p>\n\n<div class=\"graphics-container\">\n  <img src=\"/graphics@2x.2abe93fc.png\" width=\"330\" height=\"200\" alt=\"\" data-target=\"image\">\n</div>\n\n<p><%- t('success-page-text') %></p>\n\n<a class=\"button button--primary\" href=\"<%- href %>\"><%- t('return-to-app-button-text') %></a>\n";


var $38005a5e99c31b8e$exports = {};
$38005a5e99c31b8e$exports = "<svg class=\"check <% locals.className || '' %>\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M7 15.875L13.25 22.125L25.125 9\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path>\n</svg>\n";


var $64bc5704628acb37$exports = {};
$64bc5704628acb37$exports = "<% size = r * 2 + 10 %>\n\n<div class=\"loader <%- locals.className || '' %>\">\n  <svg class=\"loader__svg\" view-box=\"0 0 <%- size %> <%- size %>\" width=\"<%- size %>\" height=\"<%- size %>\">\n    <circle class=\"path\" cx=\"<%- size / 2 %>\" cy=\"<%- size / 2 %>\" r=\"<%- r %>\" fill=\"none\" stroke-width=\"<%- w %>\" stroke=\"currentColor\"></circle>\n  </svg>\n</div>\n";


var $f1958a77d0420f1f$exports = {};
$f1958a77d0420f1f$exports = "<%- include('button', { ...locals, type: 'primary' }) %>\n";


var $b6bc9c56032cd36b$exports = {};
$b6bc9c56032cd36b$exports = "<%- include('button', { ...locals, type: 'secondary' }) %>\n";


var $adbaaec0bcf126a9$exports = {};
$adbaaec0bcf126a9$exports = "<div class=\"footer\">\n  <p><%- t('footer-1') %></p>\n  <ul class=\"footer__logos\">\n    <li><img src=\"/logo-wd-2.bde460ff.svg\" alt=\"\"></li>\n    <li><img src=\"/logo-wd.2490f4af.svg\" alt=\"\"></li>\n  </ul>\n  <p><%- t('footer-2') %></p>\n</div>\n";


var $56e17ec329c0f5d7$exports = {};
$56e17ec329c0f5d7$exports = "<% hasLoader = locals.state === BUTTON_STATES.REQUEST %>\n<% hasCheck = locals.state === BUTTON_STATES.REQUEST_DONE %>\n<%\n  className = hasLoader && 'button--loading button--disabled'\n    || hasCheck && 'button--loading-done'\n    || ''\n%>\n\n<button class=\"button button--<%- type %> <%- className %>\" data-action=\"<%- locals.action || '' %>\">\n  <%- hasLoader && include('loader', { r: 10, w: 2, className: 'button__loader' }) || '' %>\n  <%- hasCheck && include('check', { className: 'button__check' }) || '' %>\n  <%- text %>\n</button>\n";


var $cedb29b32e855b49$exports = {};
$cedb29b32e855b49$exports = "<svg width=\"32\" height=\"32\" viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16 8C11.5817 8 8 11.5817 8 16C8 20.4183 11.5817 24 16 24C20.4183 24 24 20.4183 24 16C24 11.5817 20.4183 8 16 8ZM6 16C6 10.4772 10.4772 6 16 6C21.5228 6 26 10.4772 26 16C26 21.5228 21.5228 26 16 26C10.4772 26 6 21.5228 6 16ZM17 12C17 12.5523 16.5523 13 16 13C15.4477 13 15 12.5523 15 12C15 11.4477 15.4477 11 16 11C16.5523 11 17 11.4477 17 12ZM15 19V17V15H17V17V19V21H15V19Z\" fill=\"currentColor\"></path>\n</svg>\n";


var $9817fd2198fd630c$exports = {};
$9817fd2198fd630c$exports = "<% if (submitState !== BUTTON_STATES.REQUEST_DONE) { %>\n  <img height=\"25\" width=\"180\" src=\"/logo@2x.cf83b63b.png\">\n  <h1> <%- t('reset-password-title') %> </h1>\n\n  <p class=\"text-align-center\"> <%-t ('reset-password-text') %> </p>\n\n  <form action=\"#\" data-action=\"<%- a('submit') %>\">\n    <input name=\"email\" type=\"email\" placeholder=\"<%- t('reset-password-placeholder') %>\" required=\"\" pattern=\"^[a-zA-Z0-9_\\-]+(\\.[a-zA-Z0-9_\\-]+){0,}(\\+[a-zA-Z0-9_\\-]+(\\.[a-zA-Z0-9_\\-]+){0,})?@([a-zA-Z0-9_\\-]+\\.)+[a-zA-Z]{2,}$\" data-action=\"<%- a('onInputChange') %>\" value=\"<%- value %>\">\n\n    <%- include('button-primary', { text: t('reset-password-button-text'), state: submitState }) %>\n\n    <% if (error) { %>\n      <p class=\"error\">\n        <%- include('info') %>\n        <%- error %>\n      </p>\n    <% } %>\n\n  <% } else { %>\n\n    <div class=\"graphics-container graphics-container--smaller\">\n      <img src=\"/verification.4a499786.svg\" alt=\"\">\n    </div>\n\n    <p class=\"toast\">\n      <%- t('reset-password-success', { email: value }) %>\n    </p>\n\n    <br>\n\n    <%- include('button-secondary', { action: a('resetForm'), text: t('reset-password-retry')}) %>\n  <% } %>\n</form>\n";


var $141e82884fafa80e$exports = {};
(function(global, factory) {
    $141e82884fafa80e$exports = factory();
})($141e82884fafa80e$exports, function() {
    'use strict';
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === 'undefined' || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var value = parts.slice(1).join('=');
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, '', assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: '/'
    });
    /* eslint-enable no-var */ return api;
});


/*
Stimulus 3.2.1
Copyright © 2023 Basecamp, LLC
 */ class $96e1daa2ad7e58e4$var$EventListener {
    constructor(eventTarget, eventName, eventOptions){
        this.eventTarget = eventTarget;
        this.eventName = eventName;
        this.eventOptions = eventOptions;
        this.unorderedBindings = new Set();
    }
    connect() {
        this.eventTarget.addEventListener(this.eventName, this, this.eventOptions);
    }
    disconnect() {
        this.eventTarget.removeEventListener(this.eventName, this, this.eventOptions);
    }
    bindingConnected(binding) {
        this.unorderedBindings.add(binding);
    }
    bindingDisconnected(binding) {
        this.unorderedBindings.delete(binding);
    }
    handleEvent(event) {
        const extendedEvent = $96e1daa2ad7e58e4$var$extendEvent(event);
        for (const binding of this.bindings){
            if (extendedEvent.immediatePropagationStopped) break;
            else binding.handleEvent(extendedEvent);
        }
    }
    hasBindings() {
        return this.unorderedBindings.size > 0;
    }
    get bindings() {
        return Array.from(this.unorderedBindings).sort((left, right)=>{
            const leftIndex = left.index, rightIndex = right.index;
            return leftIndex < rightIndex ? -1 : leftIndex > rightIndex ? 1 : 0;
        });
    }
}
function $96e1daa2ad7e58e4$var$extendEvent(event) {
    if ("immediatePropagationStopped" in event) return event;
    else {
        const { stopImmediatePropagation: stopImmediatePropagation } = event;
        return Object.assign(event, {
            immediatePropagationStopped: false,
            stopImmediatePropagation () {
                this.immediatePropagationStopped = true;
                stopImmediatePropagation.call(this);
            }
        });
    }
}
class $96e1daa2ad7e58e4$var$Dispatcher {
    constructor(application){
        this.application = application;
        this.eventListenerMaps = new Map();
        this.started = false;
    }
    start() {
        if (!this.started) {
            this.started = true;
            this.eventListeners.forEach((eventListener)=>eventListener.connect());
        }
    }
    stop() {
        if (this.started) {
            this.started = false;
            this.eventListeners.forEach((eventListener)=>eventListener.disconnect());
        }
    }
    get eventListeners() {
        return Array.from(this.eventListenerMaps.values()).reduce((listeners, map)=>listeners.concat(Array.from(map.values())), []);
    }
    bindingConnected(binding) {
        this.fetchEventListenerForBinding(binding).bindingConnected(binding);
    }
    bindingDisconnected(binding, clearEventListeners = false) {
        this.fetchEventListenerForBinding(binding).bindingDisconnected(binding);
        if (clearEventListeners) this.clearEventListenersForBinding(binding);
    }
    handleError(error, message, detail = {}) {
        this.application.handleError(error, `Error ${message}`, detail);
    }
    clearEventListenersForBinding(binding) {
        const eventListener = this.fetchEventListenerForBinding(binding);
        if (!eventListener.hasBindings()) {
            eventListener.disconnect();
            this.removeMappedEventListenerFor(binding);
        }
    }
    removeMappedEventListenerFor(binding) {
        const { eventTarget: eventTarget, eventName: eventName, eventOptions: eventOptions } = binding;
        const eventListenerMap = this.fetchEventListenerMapForEventTarget(eventTarget);
        const cacheKey = this.cacheKey(eventName, eventOptions);
        eventListenerMap.delete(cacheKey);
        if (eventListenerMap.size == 0) this.eventListenerMaps.delete(eventTarget);
    }
    fetchEventListenerForBinding(binding) {
        const { eventTarget: eventTarget, eventName: eventName, eventOptions: eventOptions } = binding;
        return this.fetchEventListener(eventTarget, eventName, eventOptions);
    }
    fetchEventListener(eventTarget, eventName, eventOptions) {
        const eventListenerMap = this.fetchEventListenerMapForEventTarget(eventTarget);
        const cacheKey = this.cacheKey(eventName, eventOptions);
        let eventListener = eventListenerMap.get(cacheKey);
        if (!eventListener) {
            eventListener = this.createEventListener(eventTarget, eventName, eventOptions);
            eventListenerMap.set(cacheKey, eventListener);
        }
        return eventListener;
    }
    createEventListener(eventTarget, eventName, eventOptions) {
        const eventListener = new $96e1daa2ad7e58e4$var$EventListener(eventTarget, eventName, eventOptions);
        if (this.started) eventListener.connect();
        return eventListener;
    }
    fetchEventListenerMapForEventTarget(eventTarget) {
        let eventListenerMap = this.eventListenerMaps.get(eventTarget);
        if (!eventListenerMap) {
            eventListenerMap = new Map();
            this.eventListenerMaps.set(eventTarget, eventListenerMap);
        }
        return eventListenerMap;
    }
    cacheKey(eventName, eventOptions) {
        const parts = [
            eventName
        ];
        Object.keys(eventOptions).sort().forEach((key)=>{
            parts.push(`${eventOptions[key] ? "" : "!"}${key}`);
        });
        return parts.join(":");
    }
}
const $96e1daa2ad7e58e4$var$defaultActionDescriptorFilters = {
    stop ({ event: event, value: value }) {
        if (value) event.stopPropagation();
        return true;
    },
    prevent ({ event: event, value: value }) {
        if (value) event.preventDefault();
        return true;
    },
    self ({ event: event, value: value, element: element }) {
        if (value) return element === event.target;
        else return true;
    }
};
const $96e1daa2ad7e58e4$var$descriptorPattern = /^(?:(?:([^.]+?)\+)?(.+?)(?:\.(.+?))?(?:@(window|document))?->)?(.+?)(?:#([^:]+?))(?::(.+))?$/;
function $96e1daa2ad7e58e4$var$parseActionDescriptorString(descriptorString) {
    const source = descriptorString.trim();
    const matches = source.match($96e1daa2ad7e58e4$var$descriptorPattern) || [];
    let eventName = matches[2];
    let keyFilter = matches[3];
    if (keyFilter && ![
        "keydown",
        "keyup",
        "keypress"
    ].includes(eventName)) {
        eventName += `.${keyFilter}`;
        keyFilter = "";
    }
    return {
        eventTarget: $96e1daa2ad7e58e4$var$parseEventTarget(matches[4]),
        eventName: eventName,
        eventOptions: matches[7] ? $96e1daa2ad7e58e4$var$parseEventOptions(matches[7]) : {},
        identifier: matches[5],
        methodName: matches[6],
        keyFilter: matches[1] || keyFilter
    };
}
function $96e1daa2ad7e58e4$var$parseEventTarget(eventTargetName) {
    if (eventTargetName == "window") return window;
    else if (eventTargetName == "document") return document;
}
function $96e1daa2ad7e58e4$var$parseEventOptions(eventOptions) {
    return eventOptions.split(":").reduce((options, token)=>Object.assign(options, {
            [token.replace(/^!/, "")]: !/^!/.test(token)
        }), {});
}
function $96e1daa2ad7e58e4$var$stringifyEventTarget(eventTarget) {
    if (eventTarget == window) return "window";
    else if (eventTarget == document) return "document";
}
function $96e1daa2ad7e58e4$var$camelize(value) {
    return value.replace(/(?:[_-])([a-z0-9])/g, (_, char)=>char.toUpperCase());
}
function $96e1daa2ad7e58e4$var$namespaceCamelize(value) {
    return $96e1daa2ad7e58e4$var$camelize(value.replace(/--/g, "-").replace(/__/g, "_"));
}
function $96e1daa2ad7e58e4$var$capitalize(value) {
    return value.charAt(0).toUpperCase() + value.slice(1);
}
function $96e1daa2ad7e58e4$var$dasherize(value) {
    return value.replace(/([A-Z])/g, (_, char)=>`-${char.toLowerCase()}`);
}
function $96e1daa2ad7e58e4$var$tokenize(value) {
    return value.match(/[^\s]+/g) || [];
}
function $96e1daa2ad7e58e4$var$isSomething(object) {
    return object !== null && object !== undefined;
}
function $96e1daa2ad7e58e4$var$hasProperty(object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
}
const $96e1daa2ad7e58e4$var$allModifiers = [
    "meta",
    "ctrl",
    "alt",
    "shift"
];
class $96e1daa2ad7e58e4$var$Action {
    constructor(element, index, descriptor, schema){
        this.element = element;
        this.index = index;
        this.eventTarget = descriptor.eventTarget || element;
        this.eventName = descriptor.eventName || $96e1daa2ad7e58e4$var$getDefaultEventNameForElement(element) || $96e1daa2ad7e58e4$var$error("missing event name");
        this.eventOptions = descriptor.eventOptions || {};
        this.identifier = descriptor.identifier || $96e1daa2ad7e58e4$var$error("missing identifier");
        this.methodName = descriptor.methodName || $96e1daa2ad7e58e4$var$error("missing method name");
        this.keyFilter = descriptor.keyFilter || "";
        this.schema = schema;
    }
    static forToken(token, schema) {
        return new this(token.element, token.index, $96e1daa2ad7e58e4$var$parseActionDescriptorString(token.content), schema);
    }
    toString() {
        const eventFilter = this.keyFilter ? `.${this.keyFilter}` : "";
        const eventTarget = this.eventTargetName ? `@${this.eventTargetName}` : "";
        return `${this.eventName}${eventFilter}${eventTarget}->${this.identifier}#${this.methodName}`;
    }
    shouldIgnoreKeyboardEvent(event) {
        if (!this.keyFilter) return false;
        const filters = this.keyFilter.split("+");
        if (this.keyFilterDissatisfied(event, filters)) return true;
        const standardFilter = filters.filter((key)=>!$96e1daa2ad7e58e4$var$allModifiers.includes(key))[0];
        if (!standardFilter) return false;
        if (!$96e1daa2ad7e58e4$var$hasProperty(this.keyMappings, standardFilter)) $96e1daa2ad7e58e4$var$error(`contains unknown key filter: ${this.keyFilter}`);
        return this.keyMappings[standardFilter].toLowerCase() !== event.key.toLowerCase();
    }
    shouldIgnoreMouseEvent(event) {
        if (!this.keyFilter) return false;
        const filters = [
            this.keyFilter
        ];
        if (this.keyFilterDissatisfied(event, filters)) return true;
        return false;
    }
    get params() {
        const params = {};
        const pattern = new RegExp(`^data-${this.identifier}-(.+)-param$`, "i");
        for (const { name: name, value: value } of Array.from(this.element.attributes)){
            const match = name.match(pattern);
            const key = match && match[1];
            if (key) params[$96e1daa2ad7e58e4$var$camelize(key)] = $96e1daa2ad7e58e4$var$typecast(value);
        }
        return params;
    }
    get eventTargetName() {
        return $96e1daa2ad7e58e4$var$stringifyEventTarget(this.eventTarget);
    }
    get keyMappings() {
        return this.schema.keyMappings;
    }
    keyFilterDissatisfied(event, filters) {
        const [meta, ctrl, alt, shift] = $96e1daa2ad7e58e4$var$allModifiers.map((modifier)=>filters.includes(modifier));
        return event.metaKey !== meta || event.ctrlKey !== ctrl || event.altKey !== alt || event.shiftKey !== shift;
    }
}
const $96e1daa2ad7e58e4$var$defaultEventNames = {
    a: ()=>"click",
    button: ()=>"click",
    form: ()=>"submit",
    details: ()=>"toggle",
    input: (e)=>e.getAttribute("type") == "submit" ? "click" : "input",
    select: ()=>"change",
    textarea: ()=>"input"
};
function $96e1daa2ad7e58e4$var$getDefaultEventNameForElement(element) {
    const tagName = element.tagName.toLowerCase();
    if (tagName in $96e1daa2ad7e58e4$var$defaultEventNames) return $96e1daa2ad7e58e4$var$defaultEventNames[tagName](element);
}
function $96e1daa2ad7e58e4$var$error(message) {
    throw new Error(message);
}
function $96e1daa2ad7e58e4$var$typecast(value) {
    try {
        return JSON.parse(value);
    } catch (o_O) {
        return value;
    }
}
class $96e1daa2ad7e58e4$var$Binding {
    constructor(context, action){
        this.context = context;
        this.action = action;
    }
    get index() {
        return this.action.index;
    }
    get eventTarget() {
        return this.action.eventTarget;
    }
    get eventOptions() {
        return this.action.eventOptions;
    }
    get identifier() {
        return this.context.identifier;
    }
    handleEvent(event) {
        const actionEvent = this.prepareActionEvent(event);
        if (this.willBeInvokedByEvent(event) && this.applyEventModifiers(actionEvent)) this.invokeWithEvent(actionEvent);
    }
    get eventName() {
        return this.action.eventName;
    }
    get method() {
        const method = this.controller[this.methodName];
        if (typeof method == "function") return method;
        throw new Error(`Action "${this.action}" references undefined method "${this.methodName}"`);
    }
    applyEventModifiers(event) {
        const { element: element } = this.action;
        const { actionDescriptorFilters: actionDescriptorFilters } = this.context.application;
        const { controller: controller } = this.context;
        let passes = true;
        for (const [name, value] of Object.entries(this.eventOptions)){
            if (name in actionDescriptorFilters) {
                const filter = actionDescriptorFilters[name];
                passes = passes && filter({
                    name: name,
                    value: value,
                    event: event,
                    element: element,
                    controller: controller
                });
            } else continue;
        }
        return passes;
    }
    prepareActionEvent(event) {
        return Object.assign(event, {
            params: this.action.params
        });
    }
    invokeWithEvent(event) {
        const { target: target, currentTarget: currentTarget } = event;
        try {
            this.method.call(this.controller, event);
            this.context.logDebugActivity(this.methodName, {
                event: event,
                target: target,
                currentTarget: currentTarget,
                action: this.methodName
            });
        } catch (error) {
            const { identifier: identifier, controller: controller, element: element, index: index } = this;
            const detail = {
                identifier: identifier,
                controller: controller,
                element: element,
                index: index,
                event: event
            };
            this.context.handleError(error, `invoking action "${this.action}"`, detail);
        }
    }
    willBeInvokedByEvent(event) {
        const eventTarget = event.target;
        if (event instanceof KeyboardEvent && this.action.shouldIgnoreKeyboardEvent(event)) return false;
        if (event instanceof MouseEvent && this.action.shouldIgnoreMouseEvent(event)) return false;
        if (this.element === eventTarget) return true;
        else if (eventTarget instanceof Element && this.element.contains(eventTarget)) return this.scope.containsElement(eventTarget);
        else return this.scope.containsElement(this.action.element);
    }
    get controller() {
        return this.context.controller;
    }
    get methodName() {
        return this.action.methodName;
    }
    get element() {
        return this.scope.element;
    }
    get scope() {
        return this.context.scope;
    }
}
class $96e1daa2ad7e58e4$export$12e07a2a9f87578a {
    constructor(element, delegate){
        this.mutationObserverInit = {
            attributes: true,
            childList: true,
            subtree: true
        };
        this.element = element;
        this.started = false;
        this.delegate = delegate;
        this.elements = new Set();
        this.mutationObserver = new MutationObserver((mutations)=>this.processMutations(mutations));
    }
    start() {
        if (!this.started) {
            this.started = true;
            this.mutationObserver.observe(this.element, this.mutationObserverInit);
            this.refresh();
        }
    }
    pause(callback) {
        if (this.started) {
            this.mutationObserver.disconnect();
            this.started = false;
        }
        callback();
        if (!this.started) {
            this.mutationObserver.observe(this.element, this.mutationObserverInit);
            this.started = true;
        }
    }
    stop() {
        if (this.started) {
            this.mutationObserver.takeRecords();
            this.mutationObserver.disconnect();
            this.started = false;
        }
    }
    refresh() {
        if (this.started) {
            const matches = new Set(this.matchElementsInTree());
            for (const element of Array.from(this.elements))if (!matches.has(element)) this.removeElement(element);
            for (const element of Array.from(matches))this.addElement(element);
        }
    }
    processMutations(mutations) {
        if (this.started) for (const mutation of mutations)this.processMutation(mutation);
    }
    processMutation(mutation) {
        if (mutation.type == "attributes") this.processAttributeChange(mutation.target, mutation.attributeName);
        else if (mutation.type == "childList") {
            this.processRemovedNodes(mutation.removedNodes);
            this.processAddedNodes(mutation.addedNodes);
        }
    }
    processAttributeChange(element, attributeName) {
        if (this.elements.has(element)) {
            if (this.delegate.elementAttributeChanged && this.matchElement(element)) this.delegate.elementAttributeChanged(element, attributeName);
            else this.removeElement(element);
        } else if (this.matchElement(element)) this.addElement(element);
    }
    processRemovedNodes(nodes) {
        for (const node of Array.from(nodes)){
            const element = this.elementFromNode(node);
            if (element) this.processTree(element, this.removeElement);
        }
    }
    processAddedNodes(nodes) {
        for (const node of Array.from(nodes)){
            const element = this.elementFromNode(node);
            if (element && this.elementIsActive(element)) this.processTree(element, this.addElement);
        }
    }
    matchElement(element) {
        return this.delegate.matchElement(element);
    }
    matchElementsInTree(tree = this.element) {
        return this.delegate.matchElementsInTree(tree);
    }
    processTree(tree, processor) {
        for (const element of this.matchElementsInTree(tree))processor.call(this, element);
    }
    elementFromNode(node) {
        if (node.nodeType == Node.ELEMENT_NODE) return node;
    }
    elementIsActive(element) {
        if (element.isConnected != this.element.isConnected) return false;
        else return this.element.contains(element);
    }
    addElement(element) {
        if (!this.elements.has(element)) {
            if (this.elementIsActive(element)) {
                this.elements.add(element);
                if (this.delegate.elementMatched) this.delegate.elementMatched(element);
            }
        }
    }
    removeElement(element) {
        if (this.elements.has(element)) {
            this.elements.delete(element);
            if (this.delegate.elementUnmatched) this.delegate.elementUnmatched(element);
        }
    }
}
class $96e1daa2ad7e58e4$export$fe68319d413d05cb {
    constructor(element, attributeName, delegate){
        this.attributeName = attributeName;
        this.delegate = delegate;
        this.elementObserver = new $96e1daa2ad7e58e4$export$12e07a2a9f87578a(element, this);
    }
    get element() {
        return this.elementObserver.element;
    }
    get selector() {
        return `[${this.attributeName}]`;
    }
    start() {
        this.elementObserver.start();
    }
    pause(callback) {
        this.elementObserver.pause(callback);
    }
    stop() {
        this.elementObserver.stop();
    }
    refresh() {
        this.elementObserver.refresh();
    }
    get started() {
        return this.elementObserver.started;
    }
    matchElement(element) {
        return element.hasAttribute(this.attributeName);
    }
    matchElementsInTree(tree) {
        const match = this.matchElement(tree) ? [
            tree
        ] : [];
        const matches = Array.from(tree.querySelectorAll(this.selector));
        return match.concat(matches);
    }
    elementMatched(element) {
        if (this.delegate.elementMatchedAttribute) this.delegate.elementMatchedAttribute(element, this.attributeName);
    }
    elementUnmatched(element) {
        if (this.delegate.elementUnmatchedAttribute) this.delegate.elementUnmatchedAttribute(element, this.attributeName);
    }
    elementAttributeChanged(element, attributeName) {
        if (this.delegate.elementAttributeValueChanged && this.attributeName == attributeName) this.delegate.elementAttributeValueChanged(element, attributeName);
    }
}
function $96e1daa2ad7e58e4$export$e16d8520af44a096(map, key, value) {
    $96e1daa2ad7e58e4$export$e7aa7bc5c1b3cfb3(map, key).add(value);
}
function $96e1daa2ad7e58e4$export$1d2f21e549771e67(map, key, value) {
    $96e1daa2ad7e58e4$export$e7aa7bc5c1b3cfb3(map, key).delete(value);
    $96e1daa2ad7e58e4$export$d6cf75919f12ca5a(map, key);
}
function $96e1daa2ad7e58e4$export$e7aa7bc5c1b3cfb3(map, key) {
    let values = map.get(key);
    if (!values) {
        values = new Set();
        map.set(key, values);
    }
    return values;
}
function $96e1daa2ad7e58e4$export$d6cf75919f12ca5a(map, key) {
    const values = map.get(key);
    if (values != null && values.size == 0) map.delete(key);
}
class $96e1daa2ad7e58e4$export$8bd4ad37b76db6ba {
    constructor(){
        this.valuesByKey = new Map();
    }
    get keys() {
        return Array.from(this.valuesByKey.keys());
    }
    get values() {
        const sets = Array.from(this.valuesByKey.values());
        return sets.reduce((values, set)=>values.concat(Array.from(set)), []);
    }
    get size() {
        const sets = Array.from(this.valuesByKey.values());
        return sets.reduce((size, set)=>size + set.size, 0);
    }
    add(key, value) {
        $96e1daa2ad7e58e4$export$e16d8520af44a096(this.valuesByKey, key, value);
    }
    delete(key, value) {
        $96e1daa2ad7e58e4$export$1d2f21e549771e67(this.valuesByKey, key, value);
    }
    has(key, value) {
        const values = this.valuesByKey.get(key);
        return values != null && values.has(value);
    }
    hasKey(key) {
        return this.valuesByKey.has(key);
    }
    hasValue(value) {
        const sets = Array.from(this.valuesByKey.values());
        return sets.some((set)=>set.has(value));
    }
    getValuesForKey(key) {
        const values = this.valuesByKey.get(key);
        return values ? Array.from(values) : [];
    }
    getKeysForValue(value) {
        return Array.from(this.valuesByKey).filter(([_key, values])=>values.has(value)).map(([key, _values])=>key);
    }
}
class $96e1daa2ad7e58e4$export$a7c3d2c2552a674d extends $96e1daa2ad7e58e4$export$8bd4ad37b76db6ba {
    constructor(){
        super();
        this.keysByValue = new Map();
    }
    get values() {
        return Array.from(this.keysByValue.keys());
    }
    add(key, value) {
        super.add(key, value);
        $96e1daa2ad7e58e4$export$e16d8520af44a096(this.keysByValue, value, key);
    }
    delete(key, value) {
        super.delete(key, value);
        $96e1daa2ad7e58e4$export$1d2f21e549771e67(this.keysByValue, value, key);
    }
    hasValue(value) {
        return this.keysByValue.has(value);
    }
    getKeysForValue(value) {
        const set = this.keysByValue.get(value);
        return set ? Array.from(set) : [];
    }
}
class $96e1daa2ad7e58e4$export$116e0b48509995b {
    constructor(element, selector, delegate, details){
        this._selector = selector;
        this.details = details;
        this.elementObserver = new $96e1daa2ad7e58e4$export$12e07a2a9f87578a(element, this);
        this.delegate = delegate;
        this.matchesByElement = new $96e1daa2ad7e58e4$export$8bd4ad37b76db6ba();
    }
    get started() {
        return this.elementObserver.started;
    }
    get selector() {
        return this._selector;
    }
    set selector(selector) {
        this._selector = selector;
        this.refresh();
    }
    start() {
        this.elementObserver.start();
    }
    pause(callback) {
        this.elementObserver.pause(callback);
    }
    stop() {
        this.elementObserver.stop();
    }
    refresh() {
        this.elementObserver.refresh();
    }
    get element() {
        return this.elementObserver.element;
    }
    matchElement(element) {
        const { selector: selector } = this;
        if (selector) {
            const matches = element.matches(selector);
            if (this.delegate.selectorMatchElement) return matches && this.delegate.selectorMatchElement(element, this.details);
            return matches;
        } else return false;
    }
    matchElementsInTree(tree) {
        const { selector: selector } = this;
        if (selector) {
            const match = this.matchElement(tree) ? [
                tree
            ] : [];
            const matches = Array.from(tree.querySelectorAll(selector)).filter((match)=>this.matchElement(match));
            return match.concat(matches);
        } else return [];
    }
    elementMatched(element) {
        const { selector: selector } = this;
        if (selector) this.selectorMatched(element, selector);
    }
    elementUnmatched(element) {
        const selectors = this.matchesByElement.getKeysForValue(element);
        for (const selector of selectors)this.selectorUnmatched(element, selector);
    }
    elementAttributeChanged(element, _attributeName) {
        const { selector: selector } = this;
        if (selector) {
            const matches = this.matchElement(element);
            const matchedBefore = this.matchesByElement.has(selector, element);
            if (matches && !matchedBefore) this.selectorMatched(element, selector);
            else if (!matches && matchedBefore) this.selectorUnmatched(element, selector);
        }
    }
    selectorMatched(element, selector) {
        this.delegate.selectorMatched(element, selector, this.details);
        this.matchesByElement.add(selector, element);
    }
    selectorUnmatched(element, selector) {
        this.delegate.selectorUnmatched(element, selector, this.details);
        this.matchesByElement.delete(selector, element);
    }
}
class $96e1daa2ad7e58e4$export$da226bebbf7f6caa {
    constructor(element, delegate){
        this.element = element;
        this.delegate = delegate;
        this.started = false;
        this.stringMap = new Map();
        this.mutationObserver = new MutationObserver((mutations)=>this.processMutations(mutations));
    }
    start() {
        if (!this.started) {
            this.started = true;
            this.mutationObserver.observe(this.element, {
                attributes: true,
                attributeOldValue: true
            });
            this.refresh();
        }
    }
    stop() {
        if (this.started) {
            this.mutationObserver.takeRecords();
            this.mutationObserver.disconnect();
            this.started = false;
        }
    }
    refresh() {
        if (this.started) for (const attributeName of this.knownAttributeNames)this.refreshAttribute(attributeName, null);
    }
    processMutations(mutations) {
        if (this.started) for (const mutation of mutations)this.processMutation(mutation);
    }
    processMutation(mutation) {
        const attributeName = mutation.attributeName;
        if (attributeName) this.refreshAttribute(attributeName, mutation.oldValue);
    }
    refreshAttribute(attributeName, oldValue) {
        const key = this.delegate.getStringMapKeyForAttribute(attributeName);
        if (key != null) {
            if (!this.stringMap.has(attributeName)) this.stringMapKeyAdded(key, attributeName);
            const value = this.element.getAttribute(attributeName);
            if (this.stringMap.get(attributeName) != value) this.stringMapValueChanged(value, key, oldValue);
            if (value == null) {
                const oldValue = this.stringMap.get(attributeName);
                this.stringMap.delete(attributeName);
                if (oldValue) this.stringMapKeyRemoved(key, attributeName, oldValue);
            } else this.stringMap.set(attributeName, value);
        }
    }
    stringMapKeyAdded(key, attributeName) {
        if (this.delegate.stringMapKeyAdded) this.delegate.stringMapKeyAdded(key, attributeName);
    }
    stringMapValueChanged(value, key, oldValue) {
        if (this.delegate.stringMapValueChanged) this.delegate.stringMapValueChanged(value, key, oldValue);
    }
    stringMapKeyRemoved(key, attributeName, oldValue) {
        if (this.delegate.stringMapKeyRemoved) this.delegate.stringMapKeyRemoved(key, attributeName, oldValue);
    }
    get knownAttributeNames() {
        return Array.from(new Set(this.currentAttributeNames.concat(this.recordedAttributeNames)));
    }
    get currentAttributeNames() {
        return Array.from(this.element.attributes).map((attribute)=>attribute.name);
    }
    get recordedAttributeNames() {
        return Array.from(this.stringMap.keys());
    }
}
class $96e1daa2ad7e58e4$export$3aa21c2f03ef6b3b {
    constructor(element, attributeName, delegate){
        this.attributeObserver = new $96e1daa2ad7e58e4$export$fe68319d413d05cb(element, attributeName, this);
        this.delegate = delegate;
        this.tokensByElement = new $96e1daa2ad7e58e4$export$8bd4ad37b76db6ba();
    }
    get started() {
        return this.attributeObserver.started;
    }
    start() {
        this.attributeObserver.start();
    }
    pause(callback) {
        this.attributeObserver.pause(callback);
    }
    stop() {
        this.attributeObserver.stop();
    }
    refresh() {
        this.attributeObserver.refresh();
    }
    get element() {
        return this.attributeObserver.element;
    }
    get attributeName() {
        return this.attributeObserver.attributeName;
    }
    elementMatchedAttribute(element) {
        this.tokensMatched(this.readTokensForElement(element));
    }
    elementAttributeValueChanged(element) {
        const [unmatchedTokens, matchedTokens] = this.refreshTokensForElement(element);
        this.tokensUnmatched(unmatchedTokens);
        this.tokensMatched(matchedTokens);
    }
    elementUnmatchedAttribute(element) {
        this.tokensUnmatched(this.tokensByElement.getValuesForKey(element));
    }
    tokensMatched(tokens) {
        tokens.forEach((token)=>this.tokenMatched(token));
    }
    tokensUnmatched(tokens) {
        tokens.forEach((token)=>this.tokenUnmatched(token));
    }
    tokenMatched(token) {
        this.delegate.tokenMatched(token);
        this.tokensByElement.add(token.element, token);
    }
    tokenUnmatched(token) {
        this.delegate.tokenUnmatched(token);
        this.tokensByElement.delete(token.element, token);
    }
    refreshTokensForElement(element) {
        const previousTokens = this.tokensByElement.getValuesForKey(element);
        const currentTokens = this.readTokensForElement(element);
        const firstDifferingIndex = $96e1daa2ad7e58e4$var$zip(previousTokens, currentTokens).findIndex(([previousToken, currentToken])=>!$96e1daa2ad7e58e4$var$tokensAreEqual(previousToken, currentToken));
        if (firstDifferingIndex == -1) return [
            [],
            []
        ];
        else return [
            previousTokens.slice(firstDifferingIndex),
            currentTokens.slice(firstDifferingIndex)
        ];
    }
    readTokensForElement(element) {
        const attributeName = this.attributeName;
        const tokenString = element.getAttribute(attributeName) || "";
        return $96e1daa2ad7e58e4$var$parseTokenString(tokenString, element, attributeName);
    }
}
function $96e1daa2ad7e58e4$var$parseTokenString(tokenString, element, attributeName) {
    return tokenString.trim().split(/\s+/).filter((content)=>content.length).map((content, index)=>({
            element: element,
            attributeName: attributeName,
            content: content,
            index: index
        }));
}
function $96e1daa2ad7e58e4$var$zip(left, right) {
    const length = Math.max(left.length, right.length);
    return Array.from({
        length: length
    }, (_, index)=>[
            left[index],
            right[index]
        ]);
}
function $96e1daa2ad7e58e4$var$tokensAreEqual(left, right) {
    return left && right && left.index == right.index && left.content == right.content;
}
class $96e1daa2ad7e58e4$export$d27fa4c7330a452e {
    constructor(element, attributeName, delegate){
        this.tokenListObserver = new $96e1daa2ad7e58e4$export$3aa21c2f03ef6b3b(element, attributeName, this);
        this.delegate = delegate;
        this.parseResultsByToken = new WeakMap();
        this.valuesByTokenByElement = new WeakMap();
    }
    get started() {
        return this.tokenListObserver.started;
    }
    start() {
        this.tokenListObserver.start();
    }
    stop() {
        this.tokenListObserver.stop();
    }
    refresh() {
        this.tokenListObserver.refresh();
    }
    get element() {
        return this.tokenListObserver.element;
    }
    get attributeName() {
        return this.tokenListObserver.attributeName;
    }
    tokenMatched(token) {
        const { element: element } = token;
        const { value: value } = this.fetchParseResultForToken(token);
        if (value) {
            this.fetchValuesByTokenForElement(element).set(token, value);
            this.delegate.elementMatchedValue(element, value);
        }
    }
    tokenUnmatched(token) {
        const { element: element } = token;
        const { value: value } = this.fetchParseResultForToken(token);
        if (value) {
            this.fetchValuesByTokenForElement(element).delete(token);
            this.delegate.elementUnmatchedValue(element, value);
        }
    }
    fetchParseResultForToken(token) {
        let parseResult = this.parseResultsByToken.get(token);
        if (!parseResult) {
            parseResult = this.parseToken(token);
            this.parseResultsByToken.set(token, parseResult);
        }
        return parseResult;
    }
    fetchValuesByTokenForElement(element) {
        let valuesByToken = this.valuesByTokenByElement.get(element);
        if (!valuesByToken) {
            valuesByToken = new Map();
            this.valuesByTokenByElement.set(element, valuesByToken);
        }
        return valuesByToken;
    }
    parseToken(token) {
        try {
            const value = this.delegate.parseValueForToken(token);
            return {
                value: value
            };
        } catch (error) {
            return {
                error: error
            };
        }
    }
}
class $96e1daa2ad7e58e4$var$BindingObserver {
    constructor(context, delegate){
        this.context = context;
        this.delegate = delegate;
        this.bindingsByAction = new Map();
    }
    start() {
        if (!this.valueListObserver) {
            this.valueListObserver = new $96e1daa2ad7e58e4$export$d27fa4c7330a452e(this.element, this.actionAttribute, this);
            this.valueListObserver.start();
        }
    }
    stop() {
        if (this.valueListObserver) {
            this.valueListObserver.stop();
            delete this.valueListObserver;
            this.disconnectAllActions();
        }
    }
    get element() {
        return this.context.element;
    }
    get identifier() {
        return this.context.identifier;
    }
    get actionAttribute() {
        return this.schema.actionAttribute;
    }
    get schema() {
        return this.context.schema;
    }
    get bindings() {
        return Array.from(this.bindingsByAction.values());
    }
    connectAction(action) {
        const binding = new $96e1daa2ad7e58e4$var$Binding(this.context, action);
        this.bindingsByAction.set(action, binding);
        this.delegate.bindingConnected(binding);
    }
    disconnectAction(action) {
        const binding = this.bindingsByAction.get(action);
        if (binding) {
            this.bindingsByAction.delete(action);
            this.delegate.bindingDisconnected(binding);
        }
    }
    disconnectAllActions() {
        this.bindings.forEach((binding)=>this.delegate.bindingDisconnected(binding, true));
        this.bindingsByAction.clear();
    }
    parseValueForToken(token) {
        const action = $96e1daa2ad7e58e4$var$Action.forToken(token, this.schema);
        if (action.identifier == this.identifier) return action;
    }
    elementMatchedValue(element, action) {
        this.connectAction(action);
    }
    elementUnmatchedValue(element, action) {
        this.disconnectAction(action);
    }
}
class $96e1daa2ad7e58e4$var$ValueObserver {
    constructor(context, receiver){
        this.context = context;
        this.receiver = receiver;
        this.stringMapObserver = new $96e1daa2ad7e58e4$export$da226bebbf7f6caa(this.element, this);
        this.valueDescriptorMap = this.controller.valueDescriptorMap;
    }
    start() {
        this.stringMapObserver.start();
        this.invokeChangedCallbacksForDefaultValues();
    }
    stop() {
        this.stringMapObserver.stop();
    }
    get element() {
        return this.context.element;
    }
    get controller() {
        return this.context.controller;
    }
    getStringMapKeyForAttribute(attributeName) {
        if (attributeName in this.valueDescriptorMap) return this.valueDescriptorMap[attributeName].name;
    }
    stringMapKeyAdded(key, attributeName) {
        const descriptor = this.valueDescriptorMap[attributeName];
        if (!this.hasValue(key)) this.invokeChangedCallback(key, descriptor.writer(this.receiver[key]), descriptor.writer(descriptor.defaultValue));
    }
    stringMapValueChanged(value, name, oldValue) {
        const descriptor = this.valueDescriptorNameMap[name];
        if (value === null) return;
        if (oldValue === null) oldValue = descriptor.writer(descriptor.defaultValue);
        this.invokeChangedCallback(name, value, oldValue);
    }
    stringMapKeyRemoved(key, attributeName, oldValue) {
        const descriptor = this.valueDescriptorNameMap[key];
        if (this.hasValue(key)) this.invokeChangedCallback(key, descriptor.writer(this.receiver[key]), oldValue);
        else this.invokeChangedCallback(key, descriptor.writer(descriptor.defaultValue), oldValue);
    }
    invokeChangedCallbacksForDefaultValues() {
        for (const { key: key, name: name, defaultValue: defaultValue, writer: writer } of this.valueDescriptors)if (defaultValue != undefined && !this.controller.data.has(key)) this.invokeChangedCallback(name, writer(defaultValue), undefined);
    }
    invokeChangedCallback(name, rawValue, rawOldValue) {
        const changedMethodName = `${name}Changed`;
        const changedMethod = this.receiver[changedMethodName];
        if (typeof changedMethod == "function") {
            const descriptor = this.valueDescriptorNameMap[name];
            try {
                const value = descriptor.reader(rawValue);
                let oldValue = rawOldValue;
                if (rawOldValue) oldValue = descriptor.reader(rawOldValue);
                changedMethod.call(this.receiver, value, oldValue);
            } catch (error) {
                if (error instanceof TypeError) error.message = `Stimulus Value "${this.context.identifier}.${descriptor.name}" - ${error.message}`;
                throw error;
            }
        }
    }
    get valueDescriptors() {
        const { valueDescriptorMap: valueDescriptorMap } = this;
        return Object.keys(valueDescriptorMap).map((key)=>valueDescriptorMap[key]);
    }
    get valueDescriptorNameMap() {
        const descriptors = {};
        Object.keys(this.valueDescriptorMap).forEach((key)=>{
            const descriptor = this.valueDescriptorMap[key];
            descriptors[descriptor.name] = descriptor;
        });
        return descriptors;
    }
    hasValue(attributeName) {
        const descriptor = this.valueDescriptorNameMap[attributeName];
        const hasMethodName = `has${$96e1daa2ad7e58e4$var$capitalize(descriptor.name)}`;
        return this.receiver[hasMethodName];
    }
}
class $96e1daa2ad7e58e4$var$TargetObserver {
    constructor(context, delegate){
        this.context = context;
        this.delegate = delegate;
        this.targetsByName = new $96e1daa2ad7e58e4$export$8bd4ad37b76db6ba();
    }
    start() {
        if (!this.tokenListObserver) {
            this.tokenListObserver = new $96e1daa2ad7e58e4$export$3aa21c2f03ef6b3b(this.element, this.attributeName, this);
            this.tokenListObserver.start();
        }
    }
    stop() {
        if (this.tokenListObserver) {
            this.disconnectAllTargets();
            this.tokenListObserver.stop();
            delete this.tokenListObserver;
        }
    }
    tokenMatched({ element: element, content: name }) {
        if (this.scope.containsElement(element)) this.connectTarget(element, name);
    }
    tokenUnmatched({ element: element, content: name }) {
        this.disconnectTarget(element, name);
    }
    connectTarget(element, name) {
        var _a;
        if (!this.targetsByName.has(name, element)) {
            this.targetsByName.add(name, element);
            (_a = this.tokenListObserver) === null || _a === void 0 || _a.pause(()=>this.delegate.targetConnected(element, name));
        }
    }
    disconnectTarget(element, name) {
        var _a;
        if (this.targetsByName.has(name, element)) {
            this.targetsByName.delete(name, element);
            (_a = this.tokenListObserver) === null || _a === void 0 || _a.pause(()=>this.delegate.targetDisconnected(element, name));
        }
    }
    disconnectAllTargets() {
        for (const name of this.targetsByName.keys)for (const element of this.targetsByName.getValuesForKey(name))this.disconnectTarget(element, name);
    }
    get attributeName() {
        return `data-${this.context.identifier}-target`;
    }
    get element() {
        return this.context.element;
    }
    get scope() {
        return this.context.scope;
    }
}
function $96e1daa2ad7e58e4$var$readInheritableStaticArrayValues(constructor, propertyName) {
    const ancestors = $96e1daa2ad7e58e4$var$getAncestorsForConstructor(constructor);
    return Array.from(ancestors.reduce((values, constructor)=>{
        $96e1daa2ad7e58e4$var$getOwnStaticArrayValues(constructor, propertyName).forEach((name)=>values.add(name));
        return values;
    }, new Set()));
}
function $96e1daa2ad7e58e4$var$readInheritableStaticObjectPairs(constructor, propertyName) {
    const ancestors = $96e1daa2ad7e58e4$var$getAncestorsForConstructor(constructor);
    return ancestors.reduce((pairs, constructor)=>{
        pairs.push(...$96e1daa2ad7e58e4$var$getOwnStaticObjectPairs(constructor, propertyName));
        return pairs;
    }, []);
}
function $96e1daa2ad7e58e4$var$getAncestorsForConstructor(constructor) {
    const ancestors = [];
    while(constructor){
        ancestors.push(constructor);
        constructor = Object.getPrototypeOf(constructor);
    }
    return ancestors.reverse();
}
function $96e1daa2ad7e58e4$var$getOwnStaticArrayValues(constructor, propertyName) {
    const definition = constructor[propertyName];
    return Array.isArray(definition) ? definition : [];
}
function $96e1daa2ad7e58e4$var$getOwnStaticObjectPairs(constructor, propertyName) {
    const definition = constructor[propertyName];
    return definition ? Object.keys(definition).map((key)=>[
            key,
            definition[key]
        ]) : [];
}
class $96e1daa2ad7e58e4$var$OutletObserver {
    constructor(context, delegate){
        this.started = false;
        this.context = context;
        this.delegate = delegate;
        this.outletsByName = new $96e1daa2ad7e58e4$export$8bd4ad37b76db6ba();
        this.outletElementsByName = new $96e1daa2ad7e58e4$export$8bd4ad37b76db6ba();
        this.selectorObserverMap = new Map();
        this.attributeObserverMap = new Map();
    }
    start() {
        if (!this.started) {
            this.outletDefinitions.forEach((outletName)=>{
                this.setupSelectorObserverForOutlet(outletName);
                this.setupAttributeObserverForOutlet(outletName);
            });
            this.started = true;
            this.dependentContexts.forEach((context)=>context.refresh());
        }
    }
    refresh() {
        this.selectorObserverMap.forEach((observer)=>observer.refresh());
        this.attributeObserverMap.forEach((observer)=>observer.refresh());
    }
    stop() {
        if (this.started) {
            this.started = false;
            this.disconnectAllOutlets();
            this.stopSelectorObservers();
            this.stopAttributeObservers();
        }
    }
    stopSelectorObservers() {
        if (this.selectorObserverMap.size > 0) {
            this.selectorObserverMap.forEach((observer)=>observer.stop());
            this.selectorObserverMap.clear();
        }
    }
    stopAttributeObservers() {
        if (this.attributeObserverMap.size > 0) {
            this.attributeObserverMap.forEach((observer)=>observer.stop());
            this.attributeObserverMap.clear();
        }
    }
    selectorMatched(element, _selector, { outletName: outletName }) {
        const outlet = this.getOutlet(element, outletName);
        if (outlet) this.connectOutlet(outlet, element, outletName);
    }
    selectorUnmatched(element, _selector, { outletName: outletName }) {
        const outlet = this.getOutletFromMap(element, outletName);
        if (outlet) this.disconnectOutlet(outlet, element, outletName);
    }
    selectorMatchElement(element, { outletName: outletName }) {
        const selector = this.selector(outletName);
        const hasOutlet = this.hasOutlet(element, outletName);
        const hasOutletController = element.matches(`[${this.schema.controllerAttribute}~=${outletName}]`);
        if (selector) return hasOutlet && hasOutletController && element.matches(selector);
        else return false;
    }
    elementMatchedAttribute(_element, attributeName) {
        const outletName = this.getOutletNameFromOutletAttributeName(attributeName);
        if (outletName) this.updateSelectorObserverForOutlet(outletName);
    }
    elementAttributeValueChanged(_element, attributeName) {
        const outletName = this.getOutletNameFromOutletAttributeName(attributeName);
        if (outletName) this.updateSelectorObserverForOutlet(outletName);
    }
    elementUnmatchedAttribute(_element, attributeName) {
        const outletName = this.getOutletNameFromOutletAttributeName(attributeName);
        if (outletName) this.updateSelectorObserverForOutlet(outletName);
    }
    connectOutlet(outlet, element, outletName) {
        var _a;
        if (!this.outletElementsByName.has(outletName, element)) {
            this.outletsByName.add(outletName, outlet);
            this.outletElementsByName.add(outletName, element);
            (_a = this.selectorObserverMap.get(outletName)) === null || _a === void 0 || _a.pause(()=>this.delegate.outletConnected(outlet, element, outletName));
        }
    }
    disconnectOutlet(outlet, element, outletName) {
        var _a;
        if (this.outletElementsByName.has(outletName, element)) {
            this.outletsByName.delete(outletName, outlet);
            this.outletElementsByName.delete(outletName, element);
            (_a = this.selectorObserverMap.get(outletName)) === null || _a === void 0 || _a.pause(()=>this.delegate.outletDisconnected(outlet, element, outletName));
        }
    }
    disconnectAllOutlets() {
        for (const outletName of this.outletElementsByName.keys){
            for (const element of this.outletElementsByName.getValuesForKey(outletName))for (const outlet of this.outletsByName.getValuesForKey(outletName))this.disconnectOutlet(outlet, element, outletName);
        }
    }
    updateSelectorObserverForOutlet(outletName) {
        const observer = this.selectorObserverMap.get(outletName);
        if (observer) observer.selector = this.selector(outletName);
    }
    setupSelectorObserverForOutlet(outletName) {
        const selector = this.selector(outletName);
        const selectorObserver = new $96e1daa2ad7e58e4$export$116e0b48509995b(document.body, selector, this, {
            outletName: outletName
        });
        this.selectorObserverMap.set(outletName, selectorObserver);
        selectorObserver.start();
    }
    setupAttributeObserverForOutlet(outletName) {
        const attributeName = this.attributeNameForOutletName(outletName);
        const attributeObserver = new $96e1daa2ad7e58e4$export$fe68319d413d05cb(this.scope.element, attributeName, this);
        this.attributeObserverMap.set(outletName, attributeObserver);
        attributeObserver.start();
    }
    selector(outletName) {
        return this.scope.outlets.getSelectorForOutletName(outletName);
    }
    attributeNameForOutletName(outletName) {
        return this.scope.schema.outletAttributeForScope(this.identifier, outletName);
    }
    getOutletNameFromOutletAttributeName(attributeName) {
        return this.outletDefinitions.find((outletName)=>this.attributeNameForOutletName(outletName) === attributeName);
    }
    get outletDependencies() {
        const dependencies = new $96e1daa2ad7e58e4$export$8bd4ad37b76db6ba();
        this.router.modules.forEach((module)=>{
            const constructor = module.definition.controllerConstructor;
            const outlets = $96e1daa2ad7e58e4$var$readInheritableStaticArrayValues(constructor, "outlets");
            outlets.forEach((outlet)=>dependencies.add(outlet, module.identifier));
        });
        return dependencies;
    }
    get outletDefinitions() {
        return this.outletDependencies.getKeysForValue(this.identifier);
    }
    get dependentControllerIdentifiers() {
        return this.outletDependencies.getValuesForKey(this.identifier);
    }
    get dependentContexts() {
        const identifiers = this.dependentControllerIdentifiers;
        return this.router.contexts.filter((context)=>identifiers.includes(context.identifier));
    }
    hasOutlet(element, outletName) {
        return !!this.getOutlet(element, outletName) || !!this.getOutletFromMap(element, outletName);
    }
    getOutlet(element, outletName) {
        return this.application.getControllerForElementAndIdentifier(element, outletName);
    }
    getOutletFromMap(element, outletName) {
        return this.outletsByName.getValuesForKey(outletName).find((outlet)=>outlet.element === element);
    }
    get scope() {
        return this.context.scope;
    }
    get schema() {
        return this.context.schema;
    }
    get identifier() {
        return this.context.identifier;
    }
    get application() {
        return this.context.application;
    }
    get router() {
        return this.application.router;
    }
}
class $96e1daa2ad7e58e4$export$841858b892ce1f4c {
    constructor(module, scope){
        this.logDebugActivity = (functionName, detail = {})=>{
            const { identifier: identifier, controller: controller, element: element } = this;
            detail = Object.assign({
                identifier: identifier,
                controller: controller,
                element: element
            }, detail);
            this.application.logDebugActivity(this.identifier, functionName, detail);
        };
        this.module = module;
        this.scope = scope;
        this.controller = new module.controllerConstructor(this);
        this.bindingObserver = new $96e1daa2ad7e58e4$var$BindingObserver(this, this.dispatcher);
        this.valueObserver = new $96e1daa2ad7e58e4$var$ValueObserver(this, this.controller);
        this.targetObserver = new $96e1daa2ad7e58e4$var$TargetObserver(this, this);
        this.outletObserver = new $96e1daa2ad7e58e4$var$OutletObserver(this, this);
        try {
            this.controller.initialize();
            this.logDebugActivity("initialize");
        } catch (error) {
            this.handleError(error, "initializing controller");
        }
    }
    connect() {
        this.bindingObserver.start();
        this.valueObserver.start();
        this.targetObserver.start();
        this.outletObserver.start();
        try {
            this.controller.connect();
            this.logDebugActivity("connect");
        } catch (error) {
            this.handleError(error, "connecting controller");
        }
    }
    refresh() {
        this.outletObserver.refresh();
    }
    disconnect() {
        try {
            this.controller.disconnect();
            this.logDebugActivity("disconnect");
        } catch (error) {
            this.handleError(error, "disconnecting controller");
        }
        this.outletObserver.stop();
        this.targetObserver.stop();
        this.valueObserver.stop();
        this.bindingObserver.stop();
    }
    get application() {
        return this.module.application;
    }
    get identifier() {
        return this.module.identifier;
    }
    get schema() {
        return this.application.schema;
    }
    get dispatcher() {
        return this.application.dispatcher;
    }
    get element() {
        return this.scope.element;
    }
    get parentElement() {
        return this.element.parentElement;
    }
    handleError(error, message, detail = {}) {
        const { identifier: identifier, controller: controller, element: element } = this;
        detail = Object.assign({
            identifier: identifier,
            controller: controller,
            element: element
        }, detail);
        this.application.handleError(error, `Error ${message}`, detail);
    }
    targetConnected(element, name) {
        this.invokeControllerMethod(`${name}TargetConnected`, element);
    }
    targetDisconnected(element, name) {
        this.invokeControllerMethod(`${name}TargetDisconnected`, element);
    }
    outletConnected(outlet, element, name) {
        this.invokeControllerMethod(`${$96e1daa2ad7e58e4$var$namespaceCamelize(name)}OutletConnected`, outlet, element);
    }
    outletDisconnected(outlet, element, name) {
        this.invokeControllerMethod(`${$96e1daa2ad7e58e4$var$namespaceCamelize(name)}OutletDisconnected`, outlet, element);
    }
    invokeControllerMethod(methodName, ...args) {
        const controller = this.controller;
        if (typeof controller[methodName] == "function") controller[methodName](...args);
    }
}
function $96e1daa2ad7e58e4$var$bless(constructor) {
    return $96e1daa2ad7e58e4$var$shadow(constructor, $96e1daa2ad7e58e4$var$getBlessedProperties(constructor));
}
function $96e1daa2ad7e58e4$var$shadow(constructor, properties) {
    const shadowConstructor = $96e1daa2ad7e58e4$var$extend(constructor);
    const shadowProperties = $96e1daa2ad7e58e4$var$getShadowProperties(constructor.prototype, properties);
    Object.defineProperties(shadowConstructor.prototype, shadowProperties);
    return shadowConstructor;
}
function $96e1daa2ad7e58e4$var$getBlessedProperties(constructor) {
    const blessings = $96e1daa2ad7e58e4$var$readInheritableStaticArrayValues(constructor, "blessings");
    return blessings.reduce((blessedProperties, blessing)=>{
        const properties = blessing(constructor);
        for(const key in properties){
            const descriptor = blessedProperties[key] || {};
            blessedProperties[key] = Object.assign(descriptor, properties[key]);
        }
        return blessedProperties;
    }, {});
}
function $96e1daa2ad7e58e4$var$getShadowProperties(prototype, properties) {
    return $96e1daa2ad7e58e4$var$getOwnKeys(properties).reduce((shadowProperties, key)=>{
        const descriptor = $96e1daa2ad7e58e4$var$getShadowedDescriptor(prototype, properties, key);
        if (descriptor) Object.assign(shadowProperties, {
            [key]: descriptor
        });
        return shadowProperties;
    }, {});
}
function $96e1daa2ad7e58e4$var$getShadowedDescriptor(prototype, properties, key) {
    const shadowingDescriptor = Object.getOwnPropertyDescriptor(prototype, key);
    const shadowedByValue = shadowingDescriptor && "value" in shadowingDescriptor;
    if (!shadowedByValue) {
        const descriptor = Object.getOwnPropertyDescriptor(properties, key).value;
        if (shadowingDescriptor) {
            descriptor.get = shadowingDescriptor.get || descriptor.get;
            descriptor.set = shadowingDescriptor.set || descriptor.set;
        }
        return descriptor;
    }
}
const $96e1daa2ad7e58e4$var$getOwnKeys = (()=>{
    if (typeof Object.getOwnPropertySymbols == "function") return (object)=>[
            ...Object.getOwnPropertyNames(object),
            ...Object.getOwnPropertySymbols(object)
        ];
    else return Object.getOwnPropertyNames;
})();
const $96e1daa2ad7e58e4$var$extend = (()=>{
    function extendWithReflect(constructor) {
        function extended() {
            return Reflect.construct(constructor, arguments, new.target);
        }
        extended.prototype = Object.create(constructor.prototype, {
            constructor: {
                value: extended
            }
        });
        Reflect.setPrototypeOf(extended, constructor);
        return extended;
    }
    function testReflectExtension() {
        const a = function() {
            this.a.call(this);
        };
        const b = extendWithReflect(a);
        b.prototype.a = function() {};
        return new b();
    }
    try {
        testReflectExtension();
        return extendWithReflect;
    } catch (error) {
        return (constructor)=>class extended extends constructor {
            };
    }
})();
function $96e1daa2ad7e58e4$var$blessDefinition(definition) {
    return {
        identifier: definition.identifier,
        controllerConstructor: $96e1daa2ad7e58e4$var$bless(definition.controllerConstructor)
    };
}
class $96e1daa2ad7e58e4$var$Module {
    constructor(application, definition){
        this.application = application;
        this.definition = $96e1daa2ad7e58e4$var$blessDefinition(definition);
        this.contextsByScope = new WeakMap();
        this.connectedContexts = new Set();
    }
    get identifier() {
        return this.definition.identifier;
    }
    get controllerConstructor() {
        return this.definition.controllerConstructor;
    }
    get contexts() {
        return Array.from(this.connectedContexts);
    }
    connectContextForScope(scope) {
        const context = this.fetchContextForScope(scope);
        this.connectedContexts.add(context);
        context.connect();
    }
    disconnectContextForScope(scope) {
        const context = this.contextsByScope.get(scope);
        if (context) {
            this.connectedContexts.delete(context);
            context.disconnect();
        }
    }
    fetchContextForScope(scope) {
        let context = this.contextsByScope.get(scope);
        if (!context) {
            context = new $96e1daa2ad7e58e4$export$841858b892ce1f4c(this, scope);
            this.contextsByScope.set(scope, context);
        }
        return context;
    }
}
class $96e1daa2ad7e58e4$var$ClassMap {
    constructor(scope){
        this.scope = scope;
    }
    has(name) {
        return this.data.has(this.getDataKey(name));
    }
    get(name) {
        return this.getAll(name)[0];
    }
    getAll(name) {
        const tokenString = this.data.get(this.getDataKey(name)) || "";
        return $96e1daa2ad7e58e4$var$tokenize(tokenString);
    }
    getAttributeName(name) {
        return this.data.getAttributeNameForKey(this.getDataKey(name));
    }
    getDataKey(name) {
        return `${name}-class`;
    }
    get data() {
        return this.scope.data;
    }
}
class $96e1daa2ad7e58e4$var$DataMap {
    constructor(scope){
        this.scope = scope;
    }
    get element() {
        return this.scope.element;
    }
    get identifier() {
        return this.scope.identifier;
    }
    get(key) {
        const name = this.getAttributeNameForKey(key);
        return this.element.getAttribute(name);
    }
    set(key, value) {
        const name = this.getAttributeNameForKey(key);
        this.element.setAttribute(name, value);
        return this.get(key);
    }
    has(key) {
        const name = this.getAttributeNameForKey(key);
        return this.element.hasAttribute(name);
    }
    delete(key) {
        if (this.has(key)) {
            const name = this.getAttributeNameForKey(key);
            this.element.removeAttribute(name);
            return true;
        } else return false;
    }
    getAttributeNameForKey(key) {
        return `data-${this.identifier}-${$96e1daa2ad7e58e4$var$dasherize(key)}`;
    }
}
class $96e1daa2ad7e58e4$var$Guide {
    constructor(logger){
        this.warnedKeysByObject = new WeakMap();
        this.logger = logger;
    }
    warn(object, key, message) {
        let warnedKeys = this.warnedKeysByObject.get(object);
        if (!warnedKeys) {
            warnedKeys = new Set();
            this.warnedKeysByObject.set(object, warnedKeys);
        }
        if (!warnedKeys.has(key)) {
            warnedKeys.add(key);
            this.logger.warn(message, object);
        }
    }
}
function $96e1daa2ad7e58e4$var$attributeValueContainsToken(attributeName, token) {
    return `[${attributeName}~="${token}"]`;
}
class $96e1daa2ad7e58e4$var$TargetSet {
    constructor(scope){
        this.scope = scope;
    }
    get element() {
        return this.scope.element;
    }
    get identifier() {
        return this.scope.identifier;
    }
    get schema() {
        return this.scope.schema;
    }
    has(targetName) {
        return this.find(targetName) != null;
    }
    find(...targetNames) {
        return targetNames.reduce((target, targetName)=>target || this.findTarget(targetName) || this.findLegacyTarget(targetName), undefined);
    }
    findAll(...targetNames) {
        return targetNames.reduce((targets, targetName)=>[
                ...targets,
                ...this.findAllTargets(targetName),
                ...this.findAllLegacyTargets(targetName)
            ], []);
    }
    findTarget(targetName) {
        const selector = this.getSelectorForTargetName(targetName);
        return this.scope.findElement(selector);
    }
    findAllTargets(targetName) {
        const selector = this.getSelectorForTargetName(targetName);
        return this.scope.findAllElements(selector);
    }
    getSelectorForTargetName(targetName) {
        const attributeName = this.schema.targetAttributeForScope(this.identifier);
        return $96e1daa2ad7e58e4$var$attributeValueContainsToken(attributeName, targetName);
    }
    findLegacyTarget(targetName) {
        const selector = this.getLegacySelectorForTargetName(targetName);
        return this.deprecate(this.scope.findElement(selector), targetName);
    }
    findAllLegacyTargets(targetName) {
        const selector = this.getLegacySelectorForTargetName(targetName);
        return this.scope.findAllElements(selector).map((element)=>this.deprecate(element, targetName));
    }
    getLegacySelectorForTargetName(targetName) {
        const targetDescriptor = `${this.identifier}.${targetName}`;
        return $96e1daa2ad7e58e4$var$attributeValueContainsToken(this.schema.targetAttribute, targetDescriptor);
    }
    deprecate(element, targetName) {
        if (element) {
            const { identifier: identifier } = this;
            const attributeName = this.schema.targetAttribute;
            const revisedAttributeName = this.schema.targetAttributeForScope(identifier);
            this.guide.warn(element, `target:${targetName}`, `Please replace ${attributeName}="${identifier}.${targetName}" with ${revisedAttributeName}="${targetName}". ` + `The ${attributeName} attribute is deprecated and will be removed in a future version of Stimulus.`);
        }
        return element;
    }
    get guide() {
        return this.scope.guide;
    }
}
class $96e1daa2ad7e58e4$var$OutletSet {
    constructor(scope, controllerElement){
        this.scope = scope;
        this.controllerElement = controllerElement;
    }
    get element() {
        return this.scope.element;
    }
    get identifier() {
        return this.scope.identifier;
    }
    get schema() {
        return this.scope.schema;
    }
    has(outletName) {
        return this.find(outletName) != null;
    }
    find(...outletNames) {
        return outletNames.reduce((outlet, outletName)=>outlet || this.findOutlet(outletName), undefined);
    }
    findAll(...outletNames) {
        return outletNames.reduce((outlets, outletName)=>[
                ...outlets,
                ...this.findAllOutlets(outletName)
            ], []);
    }
    getSelectorForOutletName(outletName) {
        const attributeName = this.schema.outletAttributeForScope(this.identifier, outletName);
        return this.controllerElement.getAttribute(attributeName);
    }
    findOutlet(outletName) {
        const selector = this.getSelectorForOutletName(outletName);
        if (selector) return this.findElement(selector, outletName);
    }
    findAllOutlets(outletName) {
        const selector = this.getSelectorForOutletName(outletName);
        return selector ? this.findAllElements(selector, outletName) : [];
    }
    findElement(selector, outletName) {
        const elements = this.scope.queryElements(selector);
        return elements.filter((element)=>this.matchesElement(element, selector, outletName))[0];
    }
    findAllElements(selector, outletName) {
        const elements = this.scope.queryElements(selector);
        return elements.filter((element)=>this.matchesElement(element, selector, outletName));
    }
    matchesElement(element, selector, outletName) {
        const controllerAttribute = element.getAttribute(this.scope.schema.controllerAttribute) || "";
        return element.matches(selector) && controllerAttribute.split(" ").includes(outletName);
    }
}
class $96e1daa2ad7e58e4$var$Scope {
    constructor(schema, element, identifier, logger){
        this.targets = new $96e1daa2ad7e58e4$var$TargetSet(this);
        this.classes = new $96e1daa2ad7e58e4$var$ClassMap(this);
        this.data = new $96e1daa2ad7e58e4$var$DataMap(this);
        this.containsElement = (element)=>{
            return element.closest(this.controllerSelector) === this.element;
        };
        this.schema = schema;
        this.element = element;
        this.identifier = identifier;
        this.guide = new $96e1daa2ad7e58e4$var$Guide(logger);
        this.outlets = new $96e1daa2ad7e58e4$var$OutletSet(this.documentScope, element);
    }
    findElement(selector) {
        return this.element.matches(selector) ? this.element : this.queryElements(selector).find(this.containsElement);
    }
    findAllElements(selector) {
        return [
            ...this.element.matches(selector) ? [
                this.element
            ] : [],
            ...this.queryElements(selector).filter(this.containsElement)
        ];
    }
    queryElements(selector) {
        return Array.from(this.element.querySelectorAll(selector));
    }
    get controllerSelector() {
        return $96e1daa2ad7e58e4$var$attributeValueContainsToken(this.schema.controllerAttribute, this.identifier);
    }
    get isDocumentScope() {
        return this.element === document.documentElement;
    }
    get documentScope() {
        return this.isDocumentScope ? this : new $96e1daa2ad7e58e4$var$Scope(this.schema, document.documentElement, this.identifier, this.guide.logger);
    }
}
class $96e1daa2ad7e58e4$var$ScopeObserver {
    constructor(element, schema, delegate){
        this.element = element;
        this.schema = schema;
        this.delegate = delegate;
        this.valueListObserver = new $96e1daa2ad7e58e4$export$d27fa4c7330a452e(this.element, this.controllerAttribute, this);
        this.scopesByIdentifierByElement = new WeakMap();
        this.scopeReferenceCounts = new WeakMap();
    }
    start() {
        this.valueListObserver.start();
    }
    stop() {
        this.valueListObserver.stop();
    }
    get controllerAttribute() {
        return this.schema.controllerAttribute;
    }
    parseValueForToken(token) {
        const { element: element, content: identifier } = token;
        return this.parseValueForElementAndIdentifier(element, identifier);
    }
    parseValueForElementAndIdentifier(element, identifier) {
        const scopesByIdentifier = this.fetchScopesByIdentifierForElement(element);
        let scope = scopesByIdentifier.get(identifier);
        if (!scope) {
            scope = this.delegate.createScopeForElementAndIdentifier(element, identifier);
            scopesByIdentifier.set(identifier, scope);
        }
        return scope;
    }
    elementMatchedValue(element, value) {
        const referenceCount = (this.scopeReferenceCounts.get(value) || 0) + 1;
        this.scopeReferenceCounts.set(value, referenceCount);
        if (referenceCount == 1) this.delegate.scopeConnected(value);
    }
    elementUnmatchedValue(element, value) {
        const referenceCount = this.scopeReferenceCounts.get(value);
        if (referenceCount) {
            this.scopeReferenceCounts.set(value, referenceCount - 1);
            if (referenceCount == 1) this.delegate.scopeDisconnected(value);
        }
    }
    fetchScopesByIdentifierForElement(element) {
        let scopesByIdentifier = this.scopesByIdentifierByElement.get(element);
        if (!scopesByIdentifier) {
            scopesByIdentifier = new Map();
            this.scopesByIdentifierByElement.set(element, scopesByIdentifier);
        }
        return scopesByIdentifier;
    }
}
class $96e1daa2ad7e58e4$var$Router {
    constructor(application){
        this.application = application;
        this.scopeObserver = new $96e1daa2ad7e58e4$var$ScopeObserver(this.element, this.schema, this);
        this.scopesByIdentifier = new $96e1daa2ad7e58e4$export$8bd4ad37b76db6ba();
        this.modulesByIdentifier = new Map();
    }
    get element() {
        return this.application.element;
    }
    get schema() {
        return this.application.schema;
    }
    get logger() {
        return this.application.logger;
    }
    get controllerAttribute() {
        return this.schema.controllerAttribute;
    }
    get modules() {
        return Array.from(this.modulesByIdentifier.values());
    }
    get contexts() {
        return this.modules.reduce((contexts, module)=>contexts.concat(module.contexts), []);
    }
    start() {
        this.scopeObserver.start();
    }
    stop() {
        this.scopeObserver.stop();
    }
    loadDefinition(definition) {
        this.unloadIdentifier(definition.identifier);
        const module = new $96e1daa2ad7e58e4$var$Module(this.application, definition);
        this.connectModule(module);
        const afterLoad = definition.controllerConstructor.afterLoad;
        if (afterLoad) afterLoad.call(definition.controllerConstructor, definition.identifier, this.application);
    }
    unloadIdentifier(identifier) {
        const module = this.modulesByIdentifier.get(identifier);
        if (module) this.disconnectModule(module);
    }
    getContextForElementAndIdentifier(element, identifier) {
        const module = this.modulesByIdentifier.get(identifier);
        if (module) return module.contexts.find((context)=>context.element == element);
    }
    proposeToConnectScopeForElementAndIdentifier(element, identifier) {
        const scope = this.scopeObserver.parseValueForElementAndIdentifier(element, identifier);
        if (scope) this.scopeObserver.elementMatchedValue(scope.element, scope);
        else console.error(`Couldn't find or create scope for identifier: "${identifier}" and element:`, element);
    }
    handleError(error, message, detail) {
        this.application.handleError(error, message, detail);
    }
    createScopeForElementAndIdentifier(element, identifier) {
        return new $96e1daa2ad7e58e4$var$Scope(this.schema, element, identifier, this.logger);
    }
    scopeConnected(scope) {
        this.scopesByIdentifier.add(scope.identifier, scope);
        const module = this.modulesByIdentifier.get(scope.identifier);
        if (module) module.connectContextForScope(scope);
    }
    scopeDisconnected(scope) {
        this.scopesByIdentifier.delete(scope.identifier, scope);
        const module = this.modulesByIdentifier.get(scope.identifier);
        if (module) module.disconnectContextForScope(scope);
    }
    connectModule(module) {
        this.modulesByIdentifier.set(module.identifier, module);
        const scopes = this.scopesByIdentifier.getValuesForKey(module.identifier);
        scopes.forEach((scope)=>module.connectContextForScope(scope));
    }
    disconnectModule(module) {
        this.modulesByIdentifier.delete(module.identifier);
        const scopes = this.scopesByIdentifier.getValuesForKey(module.identifier);
        scopes.forEach((scope)=>module.disconnectContextForScope(scope));
    }
}
const $96e1daa2ad7e58e4$export$1db618b7b2275ea1 = {
    controllerAttribute: "data-controller",
    actionAttribute: "data-action",
    targetAttribute: "data-target",
    targetAttributeForScope: (identifier)=>`data-${identifier}-target`,
    outletAttributeForScope: (identifier, outlet)=>`data-${identifier}-${outlet}-outlet`,
    keyMappings: Object.assign(Object.assign({
        enter: "Enter",
        tab: "Tab",
        esc: "Escape",
        space: " ",
        up: "ArrowUp",
        down: "ArrowDown",
        left: "ArrowLeft",
        right: "ArrowRight",
        home: "Home",
        end: "End",
        page_up: "PageUp",
        page_down: "PageDown"
    }, $96e1daa2ad7e58e4$var$objectFromEntries("abcdefghijklmnopqrstuvwxyz".split("").map((c)=>[
            c,
            c
        ]))), $96e1daa2ad7e58e4$var$objectFromEntries("0123456789".split("").map((n)=>[
            n,
            n
        ])))
};
function $96e1daa2ad7e58e4$var$objectFromEntries(array) {
    return array.reduce((memo, [k, v])=>Object.assign(Object.assign({}, memo), {
            [k]: v
        }), {});
}
class $96e1daa2ad7e58e4$export$16975c34e60e1e61 {
    constructor(element = document.documentElement, schema = $96e1daa2ad7e58e4$export$1db618b7b2275ea1){
        this.logger = console;
        this.debug = false;
        this.logDebugActivity = (identifier, functionName, detail = {})=>{
            if (this.debug) this.logFormattedMessage(identifier, functionName, detail);
        };
        this.element = element;
        this.schema = schema;
        this.dispatcher = new $96e1daa2ad7e58e4$var$Dispatcher(this);
        this.router = new $96e1daa2ad7e58e4$var$Router(this);
        this.actionDescriptorFilters = Object.assign({}, $96e1daa2ad7e58e4$var$defaultActionDescriptorFilters);
    }
    static start(element, schema) {
        const application = new this(element, schema);
        application.start();
        return application;
    }
    async start() {
        await $96e1daa2ad7e58e4$var$domReady();
        this.logDebugActivity("application", "starting");
        this.dispatcher.start();
        this.router.start();
        this.logDebugActivity("application", "start");
    }
    stop() {
        this.logDebugActivity("application", "stopping");
        this.dispatcher.stop();
        this.router.stop();
        this.logDebugActivity("application", "stop");
    }
    register(identifier, controllerConstructor) {
        this.load({
            identifier: identifier,
            controllerConstructor: controllerConstructor
        });
    }
    registerActionOption(name, filter) {
        this.actionDescriptorFilters[name] = filter;
    }
    load(head, ...rest) {
        const definitions = Array.isArray(head) ? head : [
            head,
            ...rest
        ];
        definitions.forEach((definition)=>{
            if (definition.controllerConstructor.shouldLoad) this.router.loadDefinition(definition);
        });
    }
    unload(head, ...rest) {
        const identifiers = Array.isArray(head) ? head : [
            head,
            ...rest
        ];
        identifiers.forEach((identifier)=>this.router.unloadIdentifier(identifier));
    }
    get controllers() {
        return this.router.contexts.map((context)=>context.controller);
    }
    getControllerForElementAndIdentifier(element, identifier) {
        const context = this.router.getContextForElementAndIdentifier(element, identifier);
        return context ? context.controller : null;
    }
    handleError(error, message, detail) {
        var _a;
        this.logger.error(`%s\n\n%o\n\n%o`, message, error, detail);
        (_a = window.onerror) === null || _a === void 0 || _a.call(window, message, "", 0, 0, error);
    }
    logFormattedMessage(identifier, functionName, detail = {}) {
        detail = Object.assign({
            application: this
        }, detail);
        this.logger.groupCollapsed(`${identifier} #${functionName}`);
        this.logger.log("details:", Object.assign({}, detail));
        this.logger.groupEnd();
    }
}
function $96e1daa2ad7e58e4$var$domReady() {
    return new Promise((resolve)=>{
        if (document.readyState == "loading") document.addEventListener("DOMContentLoaded", ()=>resolve());
        else resolve();
    });
}
function $96e1daa2ad7e58e4$var$ClassPropertiesBlessing(constructor) {
    const classes = $96e1daa2ad7e58e4$var$readInheritableStaticArrayValues(constructor, "classes");
    return classes.reduce((properties, classDefinition)=>{
        return Object.assign(properties, $96e1daa2ad7e58e4$var$propertiesForClassDefinition(classDefinition));
    }, {});
}
function $96e1daa2ad7e58e4$var$propertiesForClassDefinition(key) {
    return {
        [`${key}Class`]: {
            get () {
                const { classes: classes } = this;
                if (classes.has(key)) return classes.get(key);
                else {
                    const attribute = classes.getAttributeName(key);
                    throw new Error(`Missing attribute "${attribute}"`);
                }
            }
        },
        [`${key}Classes`]: {
            get () {
                return this.classes.getAll(key);
            }
        },
        [`has${$96e1daa2ad7e58e4$var$capitalize(key)}Class`]: {
            get () {
                return this.classes.has(key);
            }
        }
    };
}
function $96e1daa2ad7e58e4$var$OutletPropertiesBlessing(constructor) {
    const outlets = $96e1daa2ad7e58e4$var$readInheritableStaticArrayValues(constructor, "outlets");
    return outlets.reduce((properties, outletDefinition)=>{
        return Object.assign(properties, $96e1daa2ad7e58e4$var$propertiesForOutletDefinition(outletDefinition));
    }, {});
}
function $96e1daa2ad7e58e4$var$getOutletController(controller, element, identifier) {
    return controller.application.getControllerForElementAndIdentifier(element, identifier);
}
function $96e1daa2ad7e58e4$var$getControllerAndEnsureConnectedScope(controller, element, outletName) {
    let outletController = $96e1daa2ad7e58e4$var$getOutletController(controller, element, outletName);
    if (outletController) return outletController;
    controller.application.router.proposeToConnectScopeForElementAndIdentifier(element, outletName);
    outletController = $96e1daa2ad7e58e4$var$getOutletController(controller, element, outletName);
    if (outletController) return outletController;
}
function $96e1daa2ad7e58e4$var$propertiesForOutletDefinition(name) {
    const camelizedName = $96e1daa2ad7e58e4$var$namespaceCamelize(name);
    return {
        [`${camelizedName}Outlet`]: {
            get () {
                const outletElement = this.outlets.find(name);
                const selector = this.outlets.getSelectorForOutletName(name);
                if (outletElement) {
                    const outletController = $96e1daa2ad7e58e4$var$getControllerAndEnsureConnectedScope(this, outletElement, name);
                    if (outletController) return outletController;
                    throw new Error(`The provided outlet element is missing an outlet controller "${name}" instance for host controller "${this.identifier}"`);
                }
                throw new Error(`Missing outlet element "${name}" for host controller "${this.identifier}". Stimulus couldn't find a matching outlet element using selector "${selector}".`);
            }
        },
        [`${camelizedName}Outlets`]: {
            get () {
                const outlets = this.outlets.findAll(name);
                if (outlets.length > 0) return outlets.map((outletElement)=>{
                    const outletController = $96e1daa2ad7e58e4$var$getControllerAndEnsureConnectedScope(this, outletElement, name);
                    if (outletController) return outletController;
                    console.warn(`The provided outlet element is missing an outlet controller "${name}" instance for host controller "${this.identifier}"`, outletElement);
                }).filter((controller)=>controller);
                return [];
            }
        },
        [`${camelizedName}OutletElement`]: {
            get () {
                const outletElement = this.outlets.find(name);
                const selector = this.outlets.getSelectorForOutletName(name);
                if (outletElement) return outletElement;
                else throw new Error(`Missing outlet element "${name}" for host controller "${this.identifier}". Stimulus couldn't find a matching outlet element using selector "${selector}".`);
            }
        },
        [`${camelizedName}OutletElements`]: {
            get () {
                return this.outlets.findAll(name);
            }
        },
        [`has${$96e1daa2ad7e58e4$var$capitalize(camelizedName)}Outlet`]: {
            get () {
                return this.outlets.has(name);
            }
        }
    };
}
function $96e1daa2ad7e58e4$var$TargetPropertiesBlessing(constructor) {
    const targets = $96e1daa2ad7e58e4$var$readInheritableStaticArrayValues(constructor, "targets");
    return targets.reduce((properties, targetDefinition)=>{
        return Object.assign(properties, $96e1daa2ad7e58e4$var$propertiesForTargetDefinition(targetDefinition));
    }, {});
}
function $96e1daa2ad7e58e4$var$propertiesForTargetDefinition(name) {
    return {
        [`${name}Target`]: {
            get () {
                const target = this.targets.find(name);
                if (target) return target;
                else throw new Error(`Missing target element "${name}" for "${this.identifier}" controller`);
            }
        },
        [`${name}Targets`]: {
            get () {
                return this.targets.findAll(name);
            }
        },
        [`has${$96e1daa2ad7e58e4$var$capitalize(name)}Target`]: {
            get () {
                return this.targets.has(name);
            }
        }
    };
}
function $96e1daa2ad7e58e4$var$ValuePropertiesBlessing(constructor) {
    const valueDefinitionPairs = $96e1daa2ad7e58e4$var$readInheritableStaticObjectPairs(constructor, "values");
    const propertyDescriptorMap = {
        valueDescriptorMap: {
            get () {
                return valueDefinitionPairs.reduce((result, valueDefinitionPair)=>{
                    const valueDescriptor = $96e1daa2ad7e58e4$var$parseValueDefinitionPair(valueDefinitionPair, this.identifier);
                    const attributeName = this.data.getAttributeNameForKey(valueDescriptor.key);
                    return Object.assign(result, {
                        [attributeName]: valueDescriptor
                    });
                }, {});
            }
        }
    };
    return valueDefinitionPairs.reduce((properties, valueDefinitionPair)=>{
        return Object.assign(properties, $96e1daa2ad7e58e4$var$propertiesForValueDefinitionPair(valueDefinitionPair));
    }, propertyDescriptorMap);
}
function $96e1daa2ad7e58e4$var$propertiesForValueDefinitionPair(valueDefinitionPair, controller) {
    const definition = $96e1daa2ad7e58e4$var$parseValueDefinitionPair(valueDefinitionPair, controller);
    const { key: key, name: name, reader: read, writer: write } = definition;
    return {
        [name]: {
            get () {
                const value = this.data.get(key);
                if (value !== null) return read(value);
                else return definition.defaultValue;
            },
            set (value) {
                if (value === undefined) this.data.delete(key);
                else this.data.set(key, write(value));
            }
        },
        [`has${$96e1daa2ad7e58e4$var$capitalize(name)}`]: {
            get () {
                return this.data.has(key) || definition.hasCustomDefaultValue;
            }
        }
    };
}
function $96e1daa2ad7e58e4$var$parseValueDefinitionPair([token, typeDefinition], controller) {
    return $96e1daa2ad7e58e4$var$valueDescriptorForTokenAndTypeDefinition({
        controller: controller,
        token: token,
        typeDefinition: typeDefinition
    });
}
function $96e1daa2ad7e58e4$var$parseValueTypeConstant(constant) {
    switch(constant){
        case Array:
            return "array";
        case Boolean:
            return "boolean";
        case Number:
            return "number";
        case Object:
            return "object";
        case String:
            return "string";
    }
}
function $96e1daa2ad7e58e4$var$parseValueTypeDefault(defaultValue) {
    switch(typeof defaultValue){
        case "boolean":
            return "boolean";
        case "number":
            return "number";
        case "string":
            return "string";
    }
    if (Array.isArray(defaultValue)) return "array";
    if (Object.prototype.toString.call(defaultValue) === "[object Object]") return "object";
}
function $96e1daa2ad7e58e4$var$parseValueTypeObject(payload) {
    const { controller: controller, token: token, typeObject: typeObject } = payload;
    const hasType = $96e1daa2ad7e58e4$var$isSomething(typeObject.type);
    const hasDefault = $96e1daa2ad7e58e4$var$isSomething(typeObject.default);
    const fullObject = hasType && hasDefault;
    const onlyType = hasType && !hasDefault;
    const onlyDefault = !hasType && hasDefault;
    const typeFromObject = $96e1daa2ad7e58e4$var$parseValueTypeConstant(typeObject.type);
    const typeFromDefaultValue = $96e1daa2ad7e58e4$var$parseValueTypeDefault(payload.typeObject.default);
    if (onlyType) return typeFromObject;
    if (onlyDefault) return typeFromDefaultValue;
    if (typeFromObject !== typeFromDefaultValue) {
        const propertyPath = controller ? `${controller}.${token}` : token;
        throw new Error(`The specified default value for the Stimulus Value "${propertyPath}" must match the defined type "${typeFromObject}". The provided default value of "${typeObject.default}" is of type "${typeFromDefaultValue}".`);
    }
    if (fullObject) return typeFromObject;
}
function $96e1daa2ad7e58e4$var$parseValueTypeDefinition(payload) {
    const { controller: controller, token: token, typeDefinition: typeDefinition } = payload;
    const typeObject = {
        controller: controller,
        token: token,
        typeObject: typeDefinition
    };
    const typeFromObject = $96e1daa2ad7e58e4$var$parseValueTypeObject(typeObject);
    const typeFromDefaultValue = $96e1daa2ad7e58e4$var$parseValueTypeDefault(typeDefinition);
    const typeFromConstant = $96e1daa2ad7e58e4$var$parseValueTypeConstant(typeDefinition);
    const type = typeFromObject || typeFromDefaultValue || typeFromConstant;
    if (type) return type;
    const propertyPath = controller ? `${controller}.${typeDefinition}` : token;
    throw new Error(`Unknown value type "${propertyPath}" for "${token}" value`);
}
function $96e1daa2ad7e58e4$var$defaultValueForDefinition(typeDefinition) {
    const constant = $96e1daa2ad7e58e4$var$parseValueTypeConstant(typeDefinition);
    if (constant) return $96e1daa2ad7e58e4$var$defaultValuesByType[constant];
    const hasDefault = $96e1daa2ad7e58e4$var$hasProperty(typeDefinition, "default");
    const hasType = $96e1daa2ad7e58e4$var$hasProperty(typeDefinition, "type");
    const typeObject = typeDefinition;
    if (hasDefault) return typeObject.default;
    if (hasType) {
        const { type: type } = typeObject;
        const constantFromType = $96e1daa2ad7e58e4$var$parseValueTypeConstant(type);
        if (constantFromType) return $96e1daa2ad7e58e4$var$defaultValuesByType[constantFromType];
    }
    return typeDefinition;
}
function $96e1daa2ad7e58e4$var$valueDescriptorForTokenAndTypeDefinition(payload) {
    const { token: token, typeDefinition: typeDefinition } = payload;
    const key = `${$96e1daa2ad7e58e4$var$dasherize(token)}-value`;
    const type = $96e1daa2ad7e58e4$var$parseValueTypeDefinition(payload);
    return {
        type: type,
        key: key,
        name: $96e1daa2ad7e58e4$var$camelize(key),
        get defaultValue () {
            return $96e1daa2ad7e58e4$var$defaultValueForDefinition(typeDefinition);
        },
        get hasCustomDefaultValue () {
            return $96e1daa2ad7e58e4$var$parseValueTypeDefault(typeDefinition) !== undefined;
        },
        reader: $96e1daa2ad7e58e4$var$readers[type],
        writer: $96e1daa2ad7e58e4$var$writers[type] || $96e1daa2ad7e58e4$var$writers.default
    };
}
const $96e1daa2ad7e58e4$var$defaultValuesByType = {
    get array () {
        return [];
    },
    boolean: false,
    number: 0,
    get object () {
        return {};
    },
    string: ""
};
const $96e1daa2ad7e58e4$var$readers = {
    array (value) {
        const array = JSON.parse(value);
        if (!Array.isArray(array)) throw new TypeError(`expected value of type "array" but instead got value "${value}" of type "${$96e1daa2ad7e58e4$var$parseValueTypeDefault(array)}"`);
        return array;
    },
    boolean (value) {
        return !(value == "0" || String(value).toLowerCase() == "false");
    },
    number (value) {
        return Number(value.replace(/_/g, ""));
    },
    object (value) {
        const object = JSON.parse(value);
        if (object === null || typeof object != "object" || Array.isArray(object)) throw new TypeError(`expected value of type "object" but instead got value "${value}" of type "${$96e1daa2ad7e58e4$var$parseValueTypeDefault(object)}"`);
        return object;
    },
    string (value) {
        return value;
    }
};
const $96e1daa2ad7e58e4$var$writers = {
    default: $96e1daa2ad7e58e4$var$writeString,
    array: $96e1daa2ad7e58e4$var$writeJSON,
    object: $96e1daa2ad7e58e4$var$writeJSON
};
function $96e1daa2ad7e58e4$var$writeJSON(value) {
    return JSON.stringify(value);
}
function $96e1daa2ad7e58e4$var$writeString(value) {
    return `${value}`;
}
class $96e1daa2ad7e58e4$export$bd0bf19f25da8474 {
    constructor(context){
        this.context = context;
    }
    static get shouldLoad() {
        return true;
    }
    static afterLoad(_identifier, _application) {
        return;
    }
    get application() {
        return this.context.application;
    }
    get scope() {
        return this.context.scope;
    }
    get element() {
        return this.scope.element;
    }
    get identifier() {
        return this.scope.identifier;
    }
    get targets() {
        return this.scope.targets;
    }
    get outlets() {
        return this.scope.outlets;
    }
    get classes() {
        return this.scope.classes;
    }
    get data() {
        return this.scope.data;
    }
    initialize() {}
    connect() {}
    disconnect() {}
    dispatch(eventName, { target: target = this.element, detail: detail = {}, prefix: prefix = this.identifier, bubbles: bubbles = true, cancelable: cancelable = true } = {}) {
        const type = prefix ? `${prefix}:${eventName}` : eventName;
        const event = new CustomEvent(type, {
            detail: detail,
            bubbles: bubbles,
            cancelable: cancelable
        });
        target.dispatchEvent(event);
        return event;
    }
}
$96e1daa2ad7e58e4$export$bd0bf19f25da8474.blessings = [
    $96e1daa2ad7e58e4$var$ClassPropertiesBlessing,
    $96e1daa2ad7e58e4$var$TargetPropertiesBlessing,
    $96e1daa2ad7e58e4$var$ValuePropertiesBlessing,
    $96e1daa2ad7e58e4$var$OutletPropertiesBlessing
];
$96e1daa2ad7e58e4$export$bd0bf19f25da8474.targets = [];
$96e1daa2ad7e58e4$export$bd0bf19f25da8474.outlets = [];
$96e1daa2ad7e58e4$export$bd0bf19f25da8474.values = {};


class $a26e9f1c012cb7c3$export$2e2bcd8739ae039 extends (0, $96e1daa2ad7e58e4$export$bd0bf19f25da8474) {
    get APP() {
        return {
            ROUTES: this.constructor.ROUTES,
            go: this.constructor.GO,
            t: this.constructor.T
        };
    }
    render = (args, options = {})=>{
        const renderedHTML = this.constructor.COMPILED_TEMPLATE(args);
        if (options.replace) {
            const node = new DOMParser().parseFromString(renderedHTML, 'text/html').body.firstElementChild;
            this.element.replaceWith(node);
        } else this.element.innerHTML = renderedHTML;
    };
    initialize() {
        // update page title based on the `title` controller instance property
        const title = document.querySelector('title');
        title.innerHTML = this.title || this.APP.t('return-to-app-button-text');
    }
    connect() {
        this.render();
    }
}





const $2023bda356194f22$export$cac357e6a6e470d8 = ({ skipVerification: skipVerification })=>{
    if ((0, $85b18de75239c237$export$f4b2f34c9ce2f292) && skipVerification) (0, (/*@__PURE__*/$parcel$interopDefault($141e82884fafa80e$exports))).set('skipVerification', (0, $2f1387074b88af05$export$ca000e230c0caa3e).get('state'));
    window.location.replace((0, $2f1387074b88af05$export$18943cbb6279ee9e)({
        skipVerification: skipVerification
    }));
};




// data coming from env
const $721e1f2a24448cbd$var$CONFIG_URL = "https://config.wdckeystone.com/config/v1/config";
const $721e1f2a24448cbd$var$getConfigItem = (key)=>{
    // return if present
    if ((0, $2f1387074b88af05$export$ca000e230c0caa3e).get(key)) return Promise.resolve((0, $2f1387074b88af05$export$ca000e230c0caa3e).get(key));
    // if it's missing and it's a cloud endpoint config key -
    // fetch config file, set to config and return
    if (key.match('service.')) return fetch($721e1f2a24448cbd$var$CONFIG_URL).then((r)=>r.json()).then((r)=>{
        // set the whole set of urls to config
        Object.entries(r.data.componentMap['cloud.service.urls']).forEach(([k, v])=>(0, $2f1387074b88af05$export$ca000e230c0caa3e).set(k, v));
        // return the value
        return (0, $2f1387074b88af05$export$ca000e230c0caa3e).get(key);
    });
    // reject otherwise
    return Promise.reject(new Error(`Config key ${key} is missing`));
};
const $721e1f2a24448cbd$export$1512182a095696a1 = (base, path, options)=>$721e1f2a24448cbd$var$getConfigItem(base).then((baseUrl)=>{
        const url = `${baseUrl}${path}`;
        return fetch(url, {
            ...options,
            headers: {
                ...options.headers,
                'content-type': 'application/json'
            }
        }).then((resp)=>{
            const status = {
                _status: resp.status
            };
            if (options.ignoreResponseBody) return status;
            return resp.json().then((r)=>({
                    ...r,
                    ...status
                }));
        });
    });


const $0f28ebd3bafeb56a$var$base = 'service.account.login.url';
const $0f28ebd3bafeb56a$export$6f39c04db542b34b = ({ code: code, clientId: clientId, audience: audience })=>{
    const path = '/oauth/token';
    return (0, $721e1f2a24448cbd$export$1512182a095696a1)($0f28ebd3bafeb56a$var$base, path, {
        method: 'POST',
        body: JSON.stringify({
            grant_type: 'authorization_code',
            code: code,
            // use current URL as a redirect URL
            redirect_uri: window.location.origin,
            audience: audience,
            scope: 'openid offline_access',
            client_id: clientId
        })
    });
};
const $0f28ebd3bafeb56a$export$22d27e03c482dc19 = ({ accessToken: accessToken })=>{
    const path = `/userinfo?access_token=${accessToken}`;
    return (0, $721e1f2a24448cbd$export$1512182a095696a1)($0f28ebd3bafeb56a$var$base, path, {
        method: 'GET'
    });
};
const $0f28ebd3bafeb56a$export$dc726c8e334dd814 = ({ email: email, clientId: clientId })=>{
    const path = '/dbconnections/change_password';
    return (0, $721e1f2a24448cbd$export$1512182a095696a1)($0f28ebd3bafeb56a$var$base, path, {
        method: 'POST',
        body: JSON.stringify({
            email: email,
            client_id: clientId,
            connection: 'Username-Password-Authentication'
        }),
        ignoreResponseBody: true
    });
};



class $b55fae1d15557878$export$2e2bcd8739ae039 extends (0, $a26e9f1c012cb7c3$export$2e2bcd8739ae039) {
    connect() {
        this.render();
        if ((0, $2f1387074b88af05$export$e5c18469ad8c5a41)()) return this.APP.go(this.APP.ROUTES.PASSWORD_RESET);
        // return early if redirect_uri is not in the list of "Allowed Callback URLs"
        // in auth0 management panel.
        if ((0, $85b18de75239c237$export$ab1569362331cdaf) && !(0, $2f1387074b88af05$export$4365e79c2c6c6867)()) return this.APP.go(this.APP.ROUTES.ERROR_AUTH0);
        // return early if error in query params
        if ((0, $2f1387074b88af05$export$ca000e230c0caa3e).get('error')) return this.APP.go(this.APP.ROUTES.ERROR_AUTH0);
        // return early if email verification feature is disabled
        if (!(0, $85b18de75239c237$export$1c940ca0480630d9)) return this.APP.go(this.APP.ROUTES.SUCCESS_GO_TO_APP);
        const cookie = (0, (/*@__PURE__*/$parcel$interopDefault($141e82884fafa80e$exports))).get('skipVerification');
        // return early if no verification needed
        if (// query-params based skip
        (0, $2f1387074b88af05$export$ca000e230c0caa3e).get('skipVerification') && !(0, $85b18de75239c237$export$f4b2f34c9ce2f292) || (0, $2f1387074b88af05$export$ca000e230c0caa3e).get('state') === cookie && (0, $85b18de75239c237$export$f4b2f34c9ce2f292)) return this.APP.go(this.APP.ROUTES.SUCCESS_GO_TO_APP);
        // return early for old client apps that do not provide the clientId
        if (!(0, $2f1387074b88af05$export$ca000e230c0caa3e).get('clientId')) return this.APP.go(this.APP.ROUTES.SUCCESS_GO_TO_APP);
        // get token + userinfo otherwise
        return (0, $0f28ebd3bafeb56a$export$6f39c04db542b34b)({
            code: (0, $2f1387074b88af05$export$ca000e230c0caa3e).get('code'),
            clientId: (0, $2f1387074b88af05$export$ca000e230c0caa3e).get('clientId'),
            audience: (0, $2f1387074b88af05$export$ca000e230c0caa3e).get('audience')
        }).then((r)=>{
            if (r._status !== 200) throw new Error('INVALID_CODE');
            (0, $2f1387074b88af05$export$ca000e230c0caa3e).set('access_token', r.access_token);
        }).then(()=>{
            return (0, $0f28ebd3bafeb56a$export$22d27e03c482dc19)({
                accessToken: (0, $2f1387074b88af05$export$ca000e230c0caa3e).get('access_token')
            }).then((resp)=>{
                if (resp._status !== 200) throw new Error(resp._status);
                // set udpated user info
                (0, $2f1387074b88af05$export$ca000e230c0caa3e).set('user', resp);
                const { email_verified: email_verified } = resp;
                // check email verified.
                // if it is - push the user back to /authorize to re-authorize
                if (email_verified) return (0, $2023bda356194f22$export$cac357e6a6e470d8)({
                    skipVerification: true
                });
                // go to verify email otherwise
                return this.APP.go(this.APP.ROUTES.VERIFY_EMAIL);
            });
        }).catch(()=>{
            this.APP.go(this.APP.ROUTES.ERROR_AUTH0);
        });
    }
}




class $481fb5617d601326$export$2e2bcd8739ae039 extends (0, $a26e9f1c012cb7c3$export$2e2bcd8739ae039) {
    onLinkClick() {
        window.location.href = (0, $2f1387074b88af05$export$fcd377fc623480d5)();
    }
    connect() {
        // error_description -> translation key mapping:
        const description = {
            'The transaction has expired': this.APP.t('error-page-two-factor-code-expired-error'),
            'user is blocked, please change your password': this.APP.t('error-page-blocked-user-error'),
            'user is blocked': this.APP.t('error-page-blocked-user-error2')
        }[(0, $2f1387074b88af05$export$ca000e230c0caa3e).get('error_description')] || (0, $2f1387074b88af05$export$ca000e230c0caa3e).get('error_description') || '';
        this.render({
            description: description,
            showButtons: ![
                'Sonos'
            ].includes((0, $2f1387074b88af05$export$ca000e230c0caa3e).get('app'))
        });
    }
}






const $ffbeb562f4f68396$var$open = ()=>window.location.replace((0, $2f1387074b88af05$export$936cdf5afafe81ea)());
class $ffbeb562f4f68396$export$2e2bcd8739ae039 extends (0, $a26e9f1c012cb7c3$export$2e2bcd8739ae039) {
    static targets = [
        'image'
    ];
    connect() {
        const cookie = (0, (/*@__PURE__*/$parcel$interopDefault($141e82884fafa80e$exports))).get('skipVerification');
        if ((0, $85b18de75239c237$export$f4b2f34c9ce2f292) && cookie === (0, $2f1387074b88af05$export$ca000e230c0caa3e).get('state')) // as it's a final step in the flow,
        // we remove `skipVerification` cookies.
        (0, (/*@__PURE__*/$parcel$interopDefault($141e82884fafa80e$exports))).remove('skipVerification');
        if ((0, $2f1387074b88af05$export$ca000e230c0caa3e).get('url')) // if we redirect back to the web app (no deeplink)
        // we don't need to render this page -
        // we just need to redirect the user to the url provided in `state` query param:
        $ffbeb562f4f68396$var$open();
        else {
            // if we are about to push the user to deeplink -
            // we need to render the contents in a first place.
            this.render({
                href: (0, $2f1387074b88af05$export$936cdf5afafe81ea)()
            });
            if (this.imageTarget.complete) // if image is already rendered - open deeplink
            $ffbeb562f4f68396$var$open();
            else {
                // wait for imare to be rendered an then open deeplink
                this.imageTarget.addEventListener('load', $ffbeb562f4f68396$var$open);
                this.imageTarget.addEventListener('error', $ffbeb562f4f68396$var$open);
            }
        }
    }
}






const $1324af18541a536a$var$base = 'service.auth.url';
const $1324af18541a536a$export$794c747ace225d95 = ({ userId: userId, email: email, token: token })=>{
    const path = `/authservice/v2/auth0/users/${encodeURIComponent(userId)}?avoidTokenInvalidation=true`;
    return (0, $721e1f2a24448cbd$export$1512182a095696a1)($1324af18541a536a$var$base, path, {
        method: 'PUT',
        headers: {
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
            email: email
        })
    });
};
const $1324af18541a536a$export$4cedc5ba9e15b997 = ({ userId: userId, token: token })=>{
    const path = `/authservice/v2/user/${encodeURIComponent(userId)}/email/verification`;
    return (0, $721e1f2a24448cbd$export$1512182a095696a1)($1324af18541a536a$var$base, path, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
};




const $01b7bb4b0476acce$var$REQUEST_DONE_STATE_BUTTON_DELAY = 2000;
const $01b7bb4b0476acce$var$TOAST_MESSAGE_TIMEOUT = 2000;
const $01b7bb4b0476acce$var$MINUTE = 60000;
class $01b7bb4b0476acce$export$2e2bcd8739ae039 extends (0, $a26e9f1c012cb7c3$export$2e2bcd8739ae039) {
    static values = {
        resendButtonState: {
            type: String,
            default: (0, $ddfd49b8c61c6cd2$export$20c28856b6c1341a).DEFAULT
        },
        checkButtonState: {
            type: String,
            default: (0, $ddfd49b8c61c6cd2$export$20c28856b6c1341a).DEFAULT
        },
        error: {
            type: Boolean,
            default: false
        },
        isRechecked: {
            type: Boolean,
            default: false
        },
        toastMessage: {
            type: String,
            default: ''
        },
        resendTime: {
            type: Number,
            default: 0
        }
    };
    _render() {
        const user = (0, $2f1387074b88af05$export$ca000e230c0caa3e).get('user');
        const existing = user['https://wdc.com/brand'] !== undefined;
        this.render({
            email: user.email,
            existing: existing,
            resendButtonState: this.resendButtonStateValue,
            checkButtonState: this.checkButtonStateValue,
            error: this.errorValue,
            isRechecked: this.isRecheckedValue,
            toastMessage: this.toastMessageValue
        });
    }
    connect() {
        this._render();
    }
    resendButtonStateValueChanged() {
        this._render();
    }
    checkButtonStateValueChanged() {
        this._render();
    }
    toastMessageValueChanged() {
        this._render();
    }
    changeEmail = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        this.APP.go(this.APP.ROUTES.CHANGE_EMAIL);
    };
    resendEmail = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        if (this.resendTimeout) clearTimeout(this.resendTimeout);
        this.isRecheckedValue = false;
        this.errorValue = false;
        this.resendButtonStateValue = (0, $ddfd49b8c61c6cd2$export$20c28856b6c1341a).DEFAULT;
        const n = Date.now();
        if (this.resendTimeValue + $01b7bb4b0476acce$var$MINUTE > n) {
            if (this.resendToastTimeout) clearTimeout(this.resendToastTimeout);
            this.toastMessageValue = this.APP.t('verify-email-toast');
            this.resendToastTimeout = setTimeout(()=>{
                this.toastMessageValue = '';
            }, $01b7bb4b0476acce$var$TOAST_MESSAGE_TIMEOUT);
            return;
        }
        this.resendTimeValue = n;
        this.resendButtonStateValue = (0, $ddfd49b8c61c6cd2$export$20c28856b6c1341a).REQUEST;
        (0, $1324af18541a536a$export$4cedc5ba9e15b997)({
            token: (0, $2f1387074b88af05$export$ca000e230c0caa3e).get('access_token'),
            userId: (0, $2f1387074b88af05$export$ca000e230c0caa3e).get('user').sub
        }).then((resp)=>{
            if (resp._status !== 201) throw new Error(resp._status);
            // change button state right after getting response
            this.resendButtonStateValue = (0, $ddfd49b8c61c6cd2$export$20c28856b6c1341a).REQUEST_DONE;
            // change button state to default after a delay
            this.resendTimeout = setTimeout(()=>{
                this.resendButtonStateValue = (0, $ddfd49b8c61c6cd2$export$20c28856b6c1341a).DEFAULT;
            }, $01b7bb4b0476acce$var$REQUEST_DONE_STATE_BUTTON_DELAY);
        }).catch(()=>{
            this.errorValue = true;
            this.resendButtonStateValue = (0, $ddfd49b8c61c6cd2$export$20c28856b6c1341a).DEFAULT;
        });
    };
    checkUser = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        if (this.checkTimeout) clearTimeout(this.checkTimeout);
        this.isRecheckedValue = false;
        this.errorValue = false;
        this.checkButtonStateValue = (0, $ddfd49b8c61c6cd2$export$20c28856b6c1341a).REQUEST;
        (0, $0f28ebd3bafeb56a$export$22d27e03c482dc19)({
            accessToken: (0, $2f1387074b88af05$export$ca000e230c0caa3e).get('access_token')
        }).then((resp)=>{
            if (resp._status !== 200) throw new Error(resp._status);
            // set udpated user info
            (0, $2f1387074b88af05$export$ca000e230c0caa3e).set('user', resp);
            const { email_verified: email_verified } = resp;
            // check email verified.
            // if it is - push the user back to /authorize to re-authorize
            if (email_verified) (0, $2023bda356194f22$export$cac357e6a6e470d8)({
                skipVerification: true
            });
            else {
                // change button state right after getting response
                this.checkButtonStateValue = (0, $ddfd49b8c61c6cd2$export$20c28856b6c1341a).REQUEST_DONE;
                this.isRecheckedValue = true;
                // change button state to default after a delay
                this.checkTimeout = setTimeout(()=>{
                    this.checkButtonStateValue = (0, $ddfd49b8c61c6cd2$export$20c28856b6c1341a).DEFAULT;
                }, $01b7bb4b0476acce$var$REQUEST_DONE_STATE_BUTTON_DELAY);
            }
        }).catch(()=>{
            this.errorValue = true;
            this.checkButtonStateValue = (0, $ddfd49b8c61c6cd2$export$20c28856b6c1341a).DEFAULT;
        });
    };
}







class $f9032a9751931db8$export$2e2bcd8739ae039 extends (0, $a26e9f1c012cb7c3$export$2e2bcd8739ae039) {
    static values = {
        submitButtonState: {
            type: String,
            default: (0, $ddfd49b8c61c6cd2$export$20c28856b6c1341a).DEFAULT
        },
        input: {
            type: String,
            default: ''
        },
        error: {
            type: String,
            default: ''
        }
    };
    _render() {
        this.render({
            submitButtonState: this.submitButtonStateValue,
            value: this.inputValue,
            error: this.errorValue
        });
    }
    connect() {
        this._render();
    }
    submitButtonStateValueChanged() {
        this._render();
    }
    onInputChange = (e)=>{
        this.inputValue = e.target.value;
    };
    submit = (e)=>{
        const formData = new FormData(e.target);
        const user = (0, $2f1387074b88af05$export$ca000e230c0caa3e).get('user');
        const token = (0, $2f1387074b88af05$export$ca000e230c0caa3e).get('access_token');
        e.preventDefault();
        e.stopPropagation();
        this.errorValue = '';
        this.submitButtonStateValue = (0, $ddfd49b8c61c6cd2$export$20c28856b6c1341a).REQUEST;
        (0, $1324af18541a536a$export$794c747ace225d95)({
            email: formData.get('email'),
            userId: user.sub,
            token: token
        }).then((r)=>{
            const desc = 'The specified new email already exists';
            if (r._status === 400 && (r.error_description === desc || JSON.parse(r.error_description) === desc)) throw new Error('USER_WITH_SUCH_EMAIL_EXISTS');
            if (r._status !== 200) throw new Error(r._status);
            // store udpated user
            (0, $2f1387074b88af05$export$ca000e230c0caa3e).set('user', {
                ...(0, $2f1387074b88af05$export$ca000e230c0caa3e).get('user'),
                ...r.data
            });
            return r;
        }).then(()=>{
            return (0, $1324af18541a536a$export$4cedc5ba9e15b997)({
                token: (0, $2f1387074b88af05$export$ca000e230c0caa3e).get('access_token'),
                userId: (0, $2f1387074b88af05$export$ca000e230c0caa3e).get('user').sub
            }).then((resp)=>{
                if (resp._status !== 201) throw new Error(resp._status);
                // go to verify email if everything is good
                return this.APP.go(this.APP.ROUTES.VERIFY_EMAIL);
            });
        }).catch((err)=>{
            if (err.message === 'USER_WITH_SUCH_EMAIL_EXISTS') {
                this.errorValue = this.APP.t('error-user-exists');
                this.submitButtonStateValue = (0, $ddfd49b8c61c6cd2$export$20c28856b6c1341a).DEFAULT;
            } else if (err.message === '401') // handling the 401 for email change gracefully
            // by pushing the user to /authorize
            (0, $2023bda356194f22$export$cac357e6a6e470d8)({
                skipVerification: false
            });
            else {
                // show error otherwise
                this.errorValue = this.APP.t('inline-error');
                this.submitButtonStateValue = (0, $ddfd49b8c61c6cd2$export$20c28856b6c1341a).DEFAULT;
            }
        });
    };
    goBack = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        this.APP.go(this.APP.ROUTES.VERIFY_EMAIL);
    };
}



class $8b46a3cfff82cd6a$export$2e2bcd8739ae039 extends (0, $a26e9f1c012cb7c3$export$2e2bcd8739ae039) {
    connect() {
        this.render(null, {
            replace: true
        });
    }
}






class $46f93185c56cfbf0$export$2e2bcd8739ae039 extends (0, $a26e9f1c012cb7c3$export$2e2bcd8739ae039) {
    title = this.APP.t('reset-password-title');
    static values = {
        submitState: {
            type: String,
            default: (0, $ddfd49b8c61c6cd2$export$20c28856b6c1341a).DEFAULT
        },
        input: {
            type: String,
            default: ''
        },
        error: {
            type: String,
            default: ''
        }
    };
    _render() {
        this.render({
            submitState: this.submitStateValue,
            value: this.inputValue,
            error: this.errorValue
        });
    }
    connect() {
        this._render();
    }
    onInputChange = (e)=>{
        this.inputValue = e.target.value;
    };
    submitStateValueChanged() {
        this._render();
    }
    resetForm() {
        this.submitStateValue = (0, $ddfd49b8c61c6cd2$export$20c28856b6c1341a).DEFAULT;
        this.errorValue = '';
    }
    submit = (e)=>{
        const formData = new FormData(e.target);
        const clientId = (0, $2f1387074b88af05$export$ca000e230c0caa3e).get('clientId');
        e.preventDefault();
        e.stopPropagation();
        this.errorValue = '';
        this.submitStateValue = (0, $ddfd49b8c61c6cd2$export$20c28856b6c1341a).REQUEST;
        (0, $0f28ebd3bafeb56a$export$dc726c8e334dd814)({
            email: formData.get('email'),
            clientId: clientId
        }).then((r)=>{
            if (r._status !== 200) throw new Error(r._status);
            // success message on 200
            this.submitStateValue = (0, $ddfd49b8c61c6cd2$export$20c28856b6c1341a).REQUEST_DONE;
        }).catch(()=>{
            this.errorValue = this.APP.t('inline-error');
            // return to default message to prompt a retry
            this.submitStateValue = (0, $ddfd49b8c61c6cd2$export$20c28856b6c1341a).DEFAULT;
        });
    };
}


var $8c34544ec33d008d$export$2e2bcd8739ae039 = {
    // page-level components (with associated controller):
    'change-email': {
        template: (0, (/*@__PURE__*/$parcel$interopDefault($554d368f656a3a2b$exports))),
        controller: (0, $f9032a9751931db8$export$2e2bcd8739ae039)
    },
    'error-auth0': {
        template: (0, (/*@__PURE__*/$parcel$interopDefault($9db403260ccc30a4$exports))),
        controller: (0, $481fb5617d601326$export$2e2bcd8739ae039)
    },
    'footer': {
        template: (0, (/*@__PURE__*/$parcel$interopDefault($adbaaec0bcf126a9$exports))),
        controller: (0, $8b46a3cfff82cd6a$export$2e2bcd8739ae039)
    },
    'password-reset': {
        template: (0, (/*@__PURE__*/$parcel$interopDefault($9817fd2198fd630c$exports))),
        controller: (0, $46f93185c56cfbf0$export$2e2bcd8739ae039)
    },
    'root': {
        template: (0, (/*@__PURE__*/$parcel$interopDefault($c80176b663f805c9$exports))),
        controller: (0, $b55fae1d15557878$export$2e2bcd8739ae039)
    },
    'success-go-to-app': {
        template: (0, (/*@__PURE__*/$parcel$interopDefault($dfa982266a1b3771$exports))),
        controller: (0, $ffbeb562f4f68396$export$2e2bcd8739ae039)
    },
    'verify-email': {
        template: (0, (/*@__PURE__*/$parcel$interopDefault($fd4ac07aa6811e12$exports))),
        controller: (0, $01b7bb4b0476acce$export$2e2bcd8739ae039)
    },
    // shared components (without associated controller):
    'loader': {
        template: (0, (/*@__PURE__*/$parcel$interopDefault($64bc5704628acb37$exports)))
    },
    'check': {
        template: (0, (/*@__PURE__*/$parcel$interopDefault($38005a5e99c31b8e$exports)))
    },
    'button-primary': {
        template: (0, (/*@__PURE__*/$parcel$interopDefault($f1958a77d0420f1f$exports)))
    },
    'button-secondary': {
        template: (0, (/*@__PURE__*/$parcel$interopDefault($b6bc9c56032cd36b$exports)))
    },
    'button': {
        template: (0, (/*@__PURE__*/$parcel$interopDefault($56e17ec329c0f5d7$exports)))
    },
    'info': {
        template: (0, (/*@__PURE__*/$parcel$interopDefault($cedb29b32e855b49$exports)))
    }
};



var $7b643aa0373da987$exports = {};
/*
 * EJS Embedded JavaScript templates
 * Copyright 2112 Matthew Eernisse (mde@fleegix.org)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
*/ 'use strict';
var $e802116379683780$exports = {};
"use strict";


var $256a03aa568b6949$exports = {};
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var $20b919983ffe8121$exports = {};
// shim for using process in browser
var $20b919983ffe8121$var$process = $20b919983ffe8121$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $20b919983ffe8121$var$cachedSetTimeout;
var $20b919983ffe8121$var$cachedClearTimeout;
function $20b919983ffe8121$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $20b919983ffe8121$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $20b919983ffe8121$var$cachedSetTimeout = setTimeout;
        else $20b919983ffe8121$var$cachedSetTimeout = $20b919983ffe8121$var$defaultSetTimout;
    } catch (e) {
        $20b919983ffe8121$var$cachedSetTimeout = $20b919983ffe8121$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $20b919983ffe8121$var$cachedClearTimeout = clearTimeout;
        else $20b919983ffe8121$var$cachedClearTimeout = $20b919983ffe8121$var$defaultClearTimeout;
    } catch (e) {
        $20b919983ffe8121$var$cachedClearTimeout = $20b919983ffe8121$var$defaultClearTimeout;
    }
})();
function $20b919983ffe8121$var$runTimeout(fun) {
    if ($20b919983ffe8121$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($20b919983ffe8121$var$cachedSetTimeout === $20b919983ffe8121$var$defaultSetTimout || !$20b919983ffe8121$var$cachedSetTimeout) && setTimeout) {
        $20b919983ffe8121$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $20b919983ffe8121$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $20b919983ffe8121$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $20b919983ffe8121$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $20b919983ffe8121$var$runClearTimeout(marker) {
    if ($20b919983ffe8121$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($20b919983ffe8121$var$cachedClearTimeout === $20b919983ffe8121$var$defaultClearTimeout || !$20b919983ffe8121$var$cachedClearTimeout) && clearTimeout) {
        $20b919983ffe8121$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $20b919983ffe8121$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $20b919983ffe8121$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $20b919983ffe8121$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $20b919983ffe8121$var$queue = [];
var $20b919983ffe8121$var$draining = false;
var $20b919983ffe8121$var$currentQueue;
var $20b919983ffe8121$var$queueIndex = -1;
function $20b919983ffe8121$var$cleanUpNextTick() {
    if (!$20b919983ffe8121$var$draining || !$20b919983ffe8121$var$currentQueue) return;
    $20b919983ffe8121$var$draining = false;
    if ($20b919983ffe8121$var$currentQueue.length) $20b919983ffe8121$var$queue = $20b919983ffe8121$var$currentQueue.concat($20b919983ffe8121$var$queue);
    else $20b919983ffe8121$var$queueIndex = -1;
    if ($20b919983ffe8121$var$queue.length) $20b919983ffe8121$var$drainQueue();
}
function $20b919983ffe8121$var$drainQueue() {
    if ($20b919983ffe8121$var$draining) return;
    var timeout = $20b919983ffe8121$var$runTimeout($20b919983ffe8121$var$cleanUpNextTick);
    $20b919983ffe8121$var$draining = true;
    var len = $20b919983ffe8121$var$queue.length;
    while(len){
        $20b919983ffe8121$var$currentQueue = $20b919983ffe8121$var$queue;
        $20b919983ffe8121$var$queue = [];
        while(++$20b919983ffe8121$var$queueIndex < len)if ($20b919983ffe8121$var$currentQueue) $20b919983ffe8121$var$currentQueue[$20b919983ffe8121$var$queueIndex].run();
        $20b919983ffe8121$var$queueIndex = -1;
        len = $20b919983ffe8121$var$queue.length;
    }
    $20b919983ffe8121$var$currentQueue = null;
    $20b919983ffe8121$var$draining = false;
    $20b919983ffe8121$var$runClearTimeout(timeout);
}
$20b919983ffe8121$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $20b919983ffe8121$var$queue.push(new $20b919983ffe8121$var$Item(fun, args));
    if ($20b919983ffe8121$var$queue.length === 1 && !$20b919983ffe8121$var$draining) $20b919983ffe8121$var$runTimeout($20b919983ffe8121$var$drainQueue);
};
// v8 likes predictible objects
function $20b919983ffe8121$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$20b919983ffe8121$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$20b919983ffe8121$var$process.title = 'browser';
$20b919983ffe8121$var$process.browser = true;
$20b919983ffe8121$var$process.env = {};
$20b919983ffe8121$var$process.argv = [];
$20b919983ffe8121$var$process.version = ''; // empty string to avoid regexp issues
$20b919983ffe8121$var$process.versions = {};
function $20b919983ffe8121$var$noop() {}
$20b919983ffe8121$var$process.on = $20b919983ffe8121$var$noop;
$20b919983ffe8121$var$process.addListener = $20b919983ffe8121$var$noop;
$20b919983ffe8121$var$process.once = $20b919983ffe8121$var$noop;
$20b919983ffe8121$var$process.off = $20b919983ffe8121$var$noop;
$20b919983ffe8121$var$process.removeListener = $20b919983ffe8121$var$noop;
$20b919983ffe8121$var$process.removeAllListeners = $20b919983ffe8121$var$noop;
$20b919983ffe8121$var$process.emit = $20b919983ffe8121$var$noop;
$20b919983ffe8121$var$process.prependListener = $20b919983ffe8121$var$noop;
$20b919983ffe8121$var$process.prependOnceListener = $20b919983ffe8121$var$noop;
$20b919983ffe8121$var$process.listeners = function(name) {
    return [];
};
$20b919983ffe8121$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$20b919983ffe8121$var$process.cwd = function() {
    return '/';
};
$20b919983ffe8121$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$20b919983ffe8121$var$process.umask = function() {
    return 0;
};


'use strict';
function $256a03aa568b6949$var$assertPath(path) {
    if (typeof path !== 'string') throw new TypeError('Path must be a string. Received ' + JSON.stringify(path));
}
// Resolves . and .. elements in a path with directory names
function $256a03aa568b6949$var$normalizeStringPosix(path, allowAboveRoot) {
    var res = '';
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var code;
    for(var i = 0; i <= path.length; ++i){
        if (i < path.length) code = path.charCodeAt(i);
        else if (code === 47 /*/*/ ) break;
        else code = 47 /*/*/ ;
        if (code === 47 /*/*/ ) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/  || res.charCodeAt(res.length - 2) !== 46 /*.*/ ) {
                    if (res.length > 2) {
                        var lastSlashIndex = res.lastIndexOf('/');
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = '';
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf('/');
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = '';
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += '/..';
                    else res = '..';
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += '/' + path.slice(lastSlash + 1, i);
                else res = path.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 /*.*/  && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
function $256a03aa568b6949$var$_format(sep, pathObject) {
    var dir = pathObject.dir || pathObject.root;
    var base = pathObject.base || (pathObject.name || '') + (pathObject.ext || '');
    if (!dir) return base;
    if (dir === pathObject.root) return dir + base;
    return dir + sep + base;
}
var $256a03aa568b6949$var$posix = {
    // path.resolve([from ...], to)
    resolve: function resolve() {
        var resolvedPath = '';
        var resolvedAbsolute = false;
        var cwd;
        for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
            var path;
            if (i >= 0) path = arguments[i];
            else {
                if (cwd === undefined) cwd = $20b919983ffe8121$exports.cwd();
                path = cwd;
            }
            $256a03aa568b6949$var$assertPath(path);
            // Skip empty entries
            if (path.length === 0) continue;
            resolvedPath = path + '/' + resolvedPath;
            resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        }
        // At this point the path should be resolved to a full absolute path, but
        // handle relative paths to be safe (might happen when process.cwd() fails)
        // Normalize the path
        resolvedPath = $256a03aa568b6949$var$normalizeStringPosix(resolvedPath, !resolvedAbsolute);
        if (resolvedAbsolute) {
            if (resolvedPath.length > 0) return '/' + resolvedPath;
            else return '/';
        } else if (resolvedPath.length > 0) return resolvedPath;
        else return '.';
    },
    normalize: function normalize(path) {
        $256a03aa568b6949$var$assertPath(path);
        if (path.length === 0) return '.';
        var isAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/ ;
        // Normalize the path
        path = $256a03aa568b6949$var$normalizeStringPosix(path, !isAbsolute);
        if (path.length === 0 && !isAbsolute) path = '.';
        if (path.length > 0 && trailingSeparator) path += '/';
        if (isAbsolute) return '/' + path;
        return path;
    },
    isAbsolute: function isAbsolute(path) {
        $256a03aa568b6949$var$assertPath(path);
        return path.length > 0 && path.charCodeAt(0) === 47 /*/*/ ;
    },
    join: function join() {
        if (arguments.length === 0) return '.';
        var joined;
        for(var i = 0; i < arguments.length; ++i){
            var arg = arguments[i];
            $256a03aa568b6949$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === undefined) joined = arg;
                else joined += '/' + arg;
            }
        }
        if (joined === undefined) return '.';
        return $256a03aa568b6949$var$posix.normalize(joined);
    },
    relative: function relative(from, to) {
        $256a03aa568b6949$var$assertPath(from);
        $256a03aa568b6949$var$assertPath(to);
        if (from === to) return '';
        from = $256a03aa568b6949$var$posix.resolve(from);
        to = $256a03aa568b6949$var$posix.resolve(to);
        if (from === to) return '';
        // Trim any leading backslashes
        var fromStart = 1;
        for(; fromStart < from.length; ++fromStart){
            if (from.charCodeAt(fromStart) !== 47 /*/*/ ) break;
        }
        var fromEnd = from.length;
        var fromLen = fromEnd - fromStart;
        // Trim any leading backslashes
        var toStart = 1;
        for(; toStart < to.length; ++toStart){
            if (to.charCodeAt(toStart) !== 47 /*/*/ ) break;
        }
        var toEnd = to.length;
        var toLen = toEnd - toStart;
        // Compare paths to find the longest common path from root
        var length = fromLen < toLen ? fromLen : toLen;
        var lastCommonSep = -1;
        var i = 0;
        for(; i <= length; ++i){
            if (i === length) {
                if (toLen > length) {
                    if (to.charCodeAt(toStart + i) === 47 /*/*/ ) // We get here if `from` is the exact base path for `to`.
                    // For example: from='/foo/bar'; to='/foo/bar/baz'
                    return to.slice(toStart + i + 1);
                    else if (i === 0) // We get here if `from` is the root
                    // For example: from='/'; to='/foo'
                    return to.slice(toStart + i);
                } else if (fromLen > length) {
                    if (from.charCodeAt(fromStart + i) === 47 /*/*/ ) // We get here if `to` is the exact base path for `from`.
                    // For example: from='/foo/bar/baz'; to='/foo/bar'
                    lastCommonSep = i;
                    else if (i === 0) // We get here if `to` is the root.
                    // For example: from='/foo'; to='/'
                    lastCommonSep = 0;
                }
                break;
            }
            var fromCode = from.charCodeAt(fromStart + i);
            var toCode = to.charCodeAt(toStart + i);
            if (fromCode !== toCode) break;
            else if (fromCode === 47 /*/*/ ) lastCommonSep = i;
        }
        var out = '';
        // Generate the relative path based on the path difference between `to`
        // and `from`
        for(i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i)if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/ ) {
            if (out.length === 0) out += '..';
            else out += '/..';
        }
        // Lastly, append the rest of the destination (`to`) path that comes after
        // the common path parts
        if (out.length > 0) return out + to.slice(toStart + lastCommonSep);
        else {
            toStart += lastCommonSep;
            if (to.charCodeAt(toStart) === 47 /*/*/ ) ++toStart;
            return to.slice(toStart);
        }
    },
    _makeLong: function _makeLong(path) {
        return path;
    },
    dirname: function dirname(path) {
        $256a03aa568b6949$var$assertPath(path);
        if (path.length === 0) return '.';
        var code = path.charCodeAt(0);
        var hasRoot = code === 47 /*/*/ ;
        var end = -1;
        var matchedSlash = true;
        for(var i = path.length - 1; i >= 1; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else // We saw the first non-path separator
            matchedSlash = false;
        }
        if (end === -1) return hasRoot ? '/' : '.';
        if (hasRoot && end === 1) return '//';
        return path.slice(0, end);
    },
    basename: function basename(path, ext) {
        if (ext !== undefined && typeof ext !== 'string') throw new TypeError('"ext" argument must be a string');
        $256a03aa568b6949$var$assertPath(path);
        var start = 0;
        var end = -1;
        var matchedSlash = true;
        var i;
        if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
            if (ext.length === path.length && ext === path) return '';
            var extIdx = ext.length - 1;
            var firstNonSlashEnd = -1;
            for(i = path.length - 1; i >= 0; --i){
                var code = path.charCodeAt(i);
                if (code === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        // We saw the first non-path separator, remember this index in case
                        // we need it if the extension ends up not matching
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        // Try to match the explicit extension
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) // We matched the extension, so mark this as the end of our path
                            // component
                            end = i;
                        } else {
                            // Extension does not match, so our result is the entire path
                            // component
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path.length;
            return path.slice(start, end);
        } else {
            for(i = path.length - 1; i >= 0; --i){
                if (path.charCodeAt(i) === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else if (end === -1) {
                    // We saw the first non-path separator, mark this as the end of our
                    // path component
                    matchedSlash = false;
                    end = i + 1;
                }
            }
            if (end === -1) return '';
            return path.slice(start, end);
        }
    },
    extname: function extname(path) {
        $256a03aa568b6949$var$assertPath(path);
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        for(var i = path.length - 1; i >= 0; --i){
            var code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return '';
        return path.slice(startDot, end);
    },
    format: function format(pathObject) {
        if (pathObject === null || typeof pathObject !== 'object') throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
        return $256a03aa568b6949$var$_format('/', pathObject);
    },
    parse: function parse(path) {
        $256a03aa568b6949$var$assertPath(path);
        var ret = {
            root: '',
            dir: '',
            base: '',
            ext: '',
            name: ''
        };
        if (path.length === 0) return ret;
        var code = path.charCodeAt(0);
        var isAbsolute = code === 47 /*/*/ ;
        var start;
        if (isAbsolute) {
            ret.root = '/';
            start = 1;
        } else start = 0;
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        var i = path.length - 1;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        // Get non-dir info
        for(; i >= start; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);
                else ret.base = ret.name = path.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path.slice(1, startDot);
                ret.base = path.slice(1, end);
            } else {
                ret.name = path.slice(startPart, startDot);
                ret.base = path.slice(startPart, end);
            }
            ret.ext = path.slice(startDot, end);
        }
        if (startPart > 0) ret.dir = path.slice(0, startPart - 1);
        else if (isAbsolute) ret.dir = '/';
        return ret;
    },
    sep: '/',
    delimiter: ':',
    win32: null,
    posix: null
};
$256a03aa568b6949$var$posix.posix = $256a03aa568b6949$var$posix;
$256a03aa568b6949$exports = $256a03aa568b6949$var$posix;


/*
 * EJS Embedded JavaScript templates
 * Copyright 2112 Matthew Eernisse (mde@fleegix.org)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
*/ /**
 * Private utility functions
 * @module utils
 * @private
 */ /**
 * Escape characters reserved in regular expressions.
 *
 * If `string` is `undefined` or `null`, the empty string is returned.
 *
 * @param {String} string Input string
 * @return {String} Escaped string
 * @static
 * @private
 */ var $02251835488faa61$export$c998f240a39da81a;
/**
 * Escape characters reserved in XML.
 *
 * If `markup` is `undefined` or `null`, the empty string is returned.
 *
 * @implements {EscapeCallback}
 * @param {String} markup Input string
 * @return {String} Escaped string
 * @static
 * @private
 */ var $02251835488faa61$export$b2bcda23b30e00ac;
/**
 * Naive copy of properties from one object to another.
 * Does not recurse into non-scalar properties
 * Does not check to see if the property has a value before copying
 *
 * @param  {Object} to   Destination object
 * @param  {Object} from Source object
 * @return {Object}      Destination object
 * @static
 * @private
 */ var $02251835488faa61$export$9c13236873b118a5;
/**
 * Naive copy of a list of key names, from one object to another.
 * Only copies property if it is actually defined
 * Does not recurse into non-scalar properties
 *
 * @param  {Object} to   Destination object
 * @param  {Object} from Source object
 * @param  {Array} list List of properties to copy
 * @return {Object}      Destination object
 * @static
 * @private
 */ var $02251835488faa61$export$f83db5734555b793;
/**
 * Simple in-process cache implementation. Does not implement limits of any
 * sort.
 *
 * @implements {Cache}
 * @static
 * @private
 */ var $02251835488faa61$export$69a3209f1a06c04d;
/**
 * Transforms hyphen case variable into camel case.
 *
 * @param {String} string Hyphen case string
 * @return {String} Camel case string
 * @static
 * @private
 */ var $02251835488faa61$export$519b2305b0acfa6b;
/**
 * Returns a null-prototype object in runtimes that support it
 *
 * @return {Object} Object, prototype will be set to null where possible
 * @static
 * @private
 */ var $02251835488faa61$export$a59469c2841c043c;
var $02251835488faa61$export$657fe57b4fad0029;
'use strict';
var $02251835488faa61$var$regExpChars = /[|\\{}()[\]^$+*?.]/g;
var $02251835488faa61$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $02251835488faa61$var$hasOwn = function(obj, key) {
    return $02251835488faa61$var$hasOwnProperty.apply(obj, [
        key
    ]);
};
$02251835488faa61$export$c998f240a39da81a = function(string) {
    // istanbul ignore if
    if (!string) return '';
    return String(string).replace($02251835488faa61$var$regExpChars, '\\$&');
};
var $02251835488faa61$var$_ENCODE_HTML_RULES = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&#34;',
    "'": '&#39;'
};
var $02251835488faa61$var$_MATCH_HTML = /[&<>'"]/g;
function $02251835488faa61$var$encode_char(c) {
    return $02251835488faa61$var$_ENCODE_HTML_RULES[c] || c;
}
/**
 * Stringified version of constants used by {@link module:utils.escapeXML}.
 *
 * It is used in the process of generating {@link ClientFunction}s.
 *
 * @readonly
 * @type {String}
 */ var $02251835488faa61$var$escapeFuncStr = 'var _ENCODE_HTML_RULES = {\n      "&": "&amp;"\n    , "<": "&lt;"\n    , ">": "&gt;"\n    , \'"\': "&#34;"\n    , "\'": "&#39;"\n    }\n  , _MATCH_HTML = /[&<>\'"]/g;\nfunction encode_char(c) {\n  return _ENCODE_HTML_RULES[c] || c;\n};\n';
$02251835488faa61$export$b2bcda23b30e00ac = function(markup) {
    return markup == undefined ? '' : String(markup).replace($02251835488faa61$var$_MATCH_HTML, $02251835488faa61$var$encode_char);
};
function $02251835488faa61$var$escapeXMLToString() {
    return Function.prototype.toString.call(this) + ';\n' + $02251835488faa61$var$escapeFuncStr;
}
try {
    if (typeof Object.defineProperty === 'function') // If the Function prototype is frozen, the "toString" property is non-writable. This means that any objects which inherit this property
    // cannot have the property changed using an assignment. If using strict mode, attempting that will cause an error. If not using strict
    // mode, attempting that will be silently ignored.
    // However, we can still explicitly shadow the prototype's "toString" property by defining a new "toString" property on this object.
    Object.defineProperty($02251835488faa61$export$b2bcda23b30e00ac, 'toString', {
        value: $02251835488faa61$var$escapeXMLToString
    });
    else // If Object.defineProperty() doesn't exist, attempt to shadow this property using the assignment operator.
    $02251835488faa61$export$b2bcda23b30e00ac.toString = $02251835488faa61$var$escapeXMLToString;
} catch (err) {
    console.warn('Unable to set escapeXML.toString (is the Function prototype frozen?)');
}
$02251835488faa61$export$9c13236873b118a5 = function(to, from) {
    from = from || {};
    if (to !== null && to !== undefined) for(var p in from){
        if (!$02251835488faa61$var$hasOwn(from, p)) continue;
        if (p === '__proto__' || p === 'constructor') continue;
        to[p] = from[p];
    }
    return to;
};
$02251835488faa61$export$f83db5734555b793 = function(to, from, list) {
    list = list || [];
    from = from || {};
    if (to !== null && to !== undefined) for(var i = 0; i < list.length; i++){
        var p = list[i];
        if (typeof from[p] != 'undefined') {
            if (!$02251835488faa61$var$hasOwn(from, p)) continue;
            if (p === '__proto__' || p === 'constructor') continue;
            to[p] = from[p];
        }
    }
    return to;
};
$02251835488faa61$export$69a3209f1a06c04d = {
    _data: {},
    set: function(key, val) {
        this._data[key] = val;
    },
    get: function(key) {
        return this._data[key];
    },
    remove: function(key) {
        delete this._data[key];
    },
    reset: function() {
        this._data = {};
    }
};
$02251835488faa61$export$519b2305b0acfa6b = function(str) {
    return str.replace(/-[a-z]/g, function(match) {
        return match[1].toUpperCase();
    });
};
$02251835488faa61$export$a59469c2841c043c = function() {
    if (typeof Object.create == 'function') return function() {
        return Object.create(null);
    };
    // Not possible, just pass through
    return function() {
        return {};
    };
}();
$02251835488faa61$export$657fe57b4fad0029 = function(obj) {
    var o = $02251835488faa61$export$a59469c2841c043c();
    for(var p in obj)if ($02251835488faa61$var$hasOwn(obj, p)) o[p] = obj[p];
    return o;
};


var $7b643aa0373da987$var$scopeOptionWarned = false;
var $43cbd6962bb89333$exports = {};
$43cbd6962bb89333$exports = JSON.parse("{\"name\":\"ejs\",\"description\":\"Embedded JavaScript templates\",\"keywords\":[\"template\",\"engine\",\"ejs\"],\"version\":\"3.1.10\",\"author\":\"Matthew Eernisse <mde@fleegix.org> (http://fleegix.org)\",\"license\":\"Apache-2.0\",\"bin\":{\"ejs\":\"./bin/cli.js\"},\"main\":\"./lib/ejs.js\",\"jsdelivr\":\"ejs.min.js\",\"unpkg\":\"ejs.min.js\",\"repository\":{\"type\":\"git\",\"url\":\"git://github.com/mde/ejs.git\"},\"bugs\":\"https://github.com/mde/ejs/issues\",\"homepage\":\"https://github.com/mde/ejs\",\"dependencies\":{\"jake\":\"^10.8.5\"},\"devDependencies\":{\"browserify\":\"^16.5.1\",\"eslint\":\"^6.8.0\",\"git-directory-deploy\":\"^1.5.1\",\"jsdoc\":\"^4.0.2\",\"lru-cache\":\"^4.0.1\",\"mocha\":\"^10.2.0\",\"uglify-js\":\"^3.3.16\"},\"engines\":{\"node\":\">=0.10.0\"},\"scripts\":{\"test\":\"npx jake test\"}}");


var $7b643aa0373da987$require$_VERSION_STRING = $43cbd6962bb89333$exports.version;
var $7b643aa0373da987$var$_DEFAULT_OPEN_DELIMITER = '<';
var $7b643aa0373da987$var$_DEFAULT_CLOSE_DELIMITER = '>';
var $7b643aa0373da987$var$_DEFAULT_DELIMITER = '%';
var $7b643aa0373da987$var$_DEFAULT_LOCALS_NAME = 'locals';
var $7b643aa0373da987$var$_NAME = 'ejs';
var $7b643aa0373da987$var$_REGEX_STRING = '(<%%|%%>|<%=|<%-|<%_|<%#|<%|%>|-%>|_%>)';
var $7b643aa0373da987$var$_OPTS_PASSABLE_WITH_DATA = [
    'delimiter',
    'scope',
    'context',
    'debug',
    'compileDebug',
    'client',
    '_with',
    'rmWhitespace',
    'strict',
    'filename',
    'async'
];
// We don't allow 'cache' option to be passed in the data obj for
// the normal `render` call, but this is where Express 2 & 3 put it
// so we make an exception for `renderFile`
var $7b643aa0373da987$var$_OPTS_PASSABLE_WITH_DATA_EXPRESS = $7b643aa0373da987$var$_OPTS_PASSABLE_WITH_DATA.concat('cache');
var $7b643aa0373da987$var$_BOM = /^\uFEFF/;
var $7b643aa0373da987$var$_JS_IDENTIFIER = /^[a-zA-Z_$][0-9a-zA-Z_$]*$/;
/**
 * EJS template function cache. This can be a LRU object from lru-cache NPM
 * module. By default, it is {@link module:utils.cache}, a simple in-process
 * cache that grows continuously.
 *
 * @type {Cache}
 */ $7b643aa0373da987$exports.cache = $02251835488faa61$export$69a3209f1a06c04d;
/**
 * Custom file loader. Useful for template preprocessing or restricting access
 * to a certain part of the filesystem.
 *
 * @type {fileLoader}
 */ $7b643aa0373da987$exports.fileLoader = $e802116379683780$exports.readFileSync;
/**
 * Name of the object containing the locals.
 *
 * This variable is overridden by {@link Options}`.localsName` if it is not
 * `undefined`.
 *
 * @type {String}
 * @public
 */ $7b643aa0373da987$exports.localsName = $7b643aa0373da987$var$_DEFAULT_LOCALS_NAME;
/**
 * Promise implementation -- defaults to the native implementation if available
 * This is mostly just for testability
 *
 * @type {PromiseConstructorLike}
 * @public
 */ $7b643aa0373da987$exports.promiseImpl = new Function('return this;')().Promise;
/**
 * Get the path to the included file from the parent file path and the
 * specified path.
 *
 * @param {String}  name     specified path
 * @param {String}  filename parent file path
 * @param {Boolean} [isDir=false] whether the parent file path is a directory
 * @return {String}
 */ $7b643aa0373da987$exports.resolveInclude = function(name, filename, isDir) {
    var dirname = $256a03aa568b6949$exports.dirname;
    var extname = $256a03aa568b6949$exports.extname;
    var resolve = $256a03aa568b6949$exports.resolve;
    var includePath = resolve(isDir ? filename : dirname(filename), name);
    var ext = extname(name);
    if (!ext) includePath += '.ejs';
    return includePath;
};
/**
 * Try to resolve file path on multiple directories
 *
 * @param  {String}        name  specified path
 * @param  {Array<String>} paths list of possible parent directory paths
 * @return {String}
 */ function $7b643aa0373da987$var$resolvePaths(name, paths) {
    var filePath;
    if (paths.some(function(v) {
        filePath = $7b643aa0373da987$exports.resolveInclude(name, v, true);
        return $e802116379683780$exports.existsSync(filePath);
    })) return filePath;
}
/**
 * Get the path to the included file by Options
 *
 * @param  {String}  path    specified path
 * @param  {Options} options compilation options
 * @return {String}
 */ function $7b643aa0373da987$var$getIncludePath(path, options) {
    var includePath;
    var filePath;
    var views = options.views;
    var match = /^[A-Za-z]+:\\|^\//.exec(path);
    // Abs path
    if (match && match.length) {
        path = path.replace(/^\/*/, '');
        if (Array.isArray(options.root)) includePath = $7b643aa0373da987$var$resolvePaths(path, options.root);
        else includePath = $7b643aa0373da987$exports.resolveInclude(path, options.root || '/', true);
    } else {
        // Look relative to a passed filename first
        if (options.filename) {
            filePath = $7b643aa0373da987$exports.resolveInclude(path, options.filename);
            if ($e802116379683780$exports.existsSync(filePath)) includePath = filePath;
        }
        // Then look in any views directories
        if (!includePath && Array.isArray(views)) includePath = $7b643aa0373da987$var$resolvePaths(path, views);
        if (!includePath && typeof options.includer !== 'function') throw new Error('Could not find the include file "' + options.escapeFunction(path) + '"');
    }
    return includePath;
}
/**
 * Get the template from a string or a file, either compiled on-the-fly or
 * read from cache (if enabled), and cache the template if needed.
 *
 * If `template` is not set, the file specified in `options.filename` will be
 * read.
 *
 * If `options.cache` is true, this function reads the file from
 * `options.filename` so it must be set prior to calling this function.
 *
 * @memberof module:ejs-internal
 * @param {Options} options   compilation options
 * @param {String} [template] template source
 * @return {(TemplateFunction|ClientFunction)}
 * Depending on the value of `options.client`, either type might be returned.
 * @static
 */ function $7b643aa0373da987$var$handleCache(options, template) {
    var func;
    var filename = options.filename;
    var hasTemplate = arguments.length > 1;
    if (options.cache) {
        if (!filename) throw new Error('cache option requires a filename');
        func = $7b643aa0373da987$exports.cache.get(filename);
        if (func) return func;
        if (!hasTemplate) template = $7b643aa0373da987$var$fileLoader(filename).toString().replace($7b643aa0373da987$var$_BOM, '');
    } else if (!hasTemplate) {
        // istanbul ignore if: should not happen at all
        if (!filename) throw new Error("Internal EJS error: no file name or template provided");
        template = $7b643aa0373da987$var$fileLoader(filename).toString().replace($7b643aa0373da987$var$_BOM, '');
    }
    func = $7b643aa0373da987$exports.compile(template, options);
    if (options.cache) $7b643aa0373da987$exports.cache.set(filename, func);
    return func;
}
/**
 * Try calling handleCache with the given options and data and call the
 * callback with the result. If an error occurs, call the callback with
 * the error. Used by renderFile().
 *
 * @memberof module:ejs-internal
 * @param {Options} options    compilation options
 * @param {Object} data        template data
 * @param {RenderFileCallback} cb callback
 * @static
 */ function $7b643aa0373da987$var$tryHandleCache(options, data, cb) {
    var result;
    if (!cb) {
        if (typeof $7b643aa0373da987$exports.promiseImpl == 'function') return new $7b643aa0373da987$exports.promiseImpl(function(resolve, reject) {
            try {
                result = $7b643aa0373da987$var$handleCache(options)(data);
                resolve(result);
            } catch (err) {
                reject(err);
            }
        });
        else throw new Error('Please provide a callback function');
    } else {
        try {
            result = $7b643aa0373da987$var$handleCache(options)(data);
        } catch (err) {
            return cb(err);
        }
        cb(null, result);
    }
}
/**
 * fileLoader is independent
 *
 * @param {String} filePath ejs file path.
 * @return {String} The contents of the specified file.
 * @static
 */ function $7b643aa0373da987$var$fileLoader(filePath) {
    return $7b643aa0373da987$exports.fileLoader(filePath);
}
/**
 * Get the template function.
 *
 * If `options.cache` is `true`, then the template is cached.
 *
 * @memberof module:ejs-internal
 * @param {String}  path    path for the specified file
 * @param {Options} options compilation options
 * @return {(TemplateFunction|ClientFunction)}
 * Depending on the value of `options.client`, either type might be returned
 * @static
 */ function $7b643aa0373da987$var$includeFile(path, options) {
    var opts = $02251835488faa61$export$9c13236873b118a5($02251835488faa61$export$a59469c2841c043c(), options);
    opts.filename = $7b643aa0373da987$var$getIncludePath(path, opts);
    if (typeof options.includer === 'function') {
        var includerResult = options.includer(path, opts.filename);
        if (includerResult) {
            if (includerResult.filename) opts.filename = includerResult.filename;
            if (includerResult.template) return $7b643aa0373da987$var$handleCache(opts, includerResult.template);
        }
    }
    return $7b643aa0373da987$var$handleCache(opts);
}
/**
 * Re-throw the given `err` in context to the `str` of ejs, `filename`, and
 * `lineno`.
 *
 * @implements {RethrowCallback}
 * @memberof module:ejs-internal
 * @param {Error}  err      Error object
 * @param {String} str      EJS source
 * @param {String} flnm     file name of the EJS file
 * @param {Number} lineno   line number of the error
 * @param {EscapeCallback} esc
 * @static
 */ function $7b643aa0373da987$var$rethrow(err, str, flnm, lineno, esc) {
    var lines = str.split('\n');
    var start = Math.max(lineno - 3, 0);
    var end = Math.min(lines.length, lineno + 3);
    var filename = esc(flnm);
    // Error context
    var context = lines.slice(start, end).map(function(line, i) {
        var curr = i + start + 1;
        return (curr == lineno ? ' >> ' : '    ') + curr + '| ' + line;
    }).join('\n');
    // Alter exception message
    err.path = filename;
    err.message = (filename || 'ejs') + ':' + lineno + '\n' + context + '\n\n' + err.message;
    throw err;
}
function $7b643aa0373da987$var$stripSemi(str) {
    return str.replace(/;(\s*$)/, '$1');
}
/**
 * Compile the given `str` of ejs into a template function.
 *
 * @param {String}  template EJS template
 *
 * @param {Options} [opts] compilation options
 *
 * @return {(TemplateFunction|ClientFunction)}
 * Depending on the value of `opts.client`, either type might be returned.
 * Note that the return type of the function also depends on the value of `opts.async`.
 * @public
 */ $7b643aa0373da987$exports.compile = function compile(template, opts) {
    var templ;
    // v1 compat
    // 'scope' is 'context'
    // FIXME: Remove this in a future version
    if (opts && opts.scope) {
        if (!$7b643aa0373da987$var$scopeOptionWarned) {
            console.warn('`scope` option is deprecated and will be removed in EJS 3');
            $7b643aa0373da987$var$scopeOptionWarned = true;
        }
        if (!opts.context) opts.context = opts.scope;
        delete opts.scope;
    }
    templ = new $7b643aa0373da987$var$Template(template, opts);
    return templ.compile();
};
/**
 * Render the given `template` of ejs.
 *
 * If you would like to include options but not data, you need to explicitly
 * call this function with `data` being an empty object or `null`.
 *
 * @param {String}   template EJS template
 * @param {Object}  [data={}] template data
 * @param {Options} [opts={}] compilation and rendering options
 * @return {(String|Promise<String>)}
 * Return value type depends on `opts.async`.
 * @public
 */ $7b643aa0373da987$exports.render = function(template, d, o) {
    var data = d || $02251835488faa61$export$a59469c2841c043c();
    var opts = o || $02251835488faa61$export$a59469c2841c043c();
    // No options object -- if there are optiony names
    // in the data, copy them to options
    if (arguments.length == 2) $02251835488faa61$export$f83db5734555b793(opts, data, $7b643aa0373da987$var$_OPTS_PASSABLE_WITH_DATA);
    return $7b643aa0373da987$var$handleCache(opts, template)(data);
};
/**
 * Render an EJS file at the given `path` and callback `cb(err, str)`.
 *
 * If you would like to include options but not data, you need to explicitly
 * call this function with `data` being an empty object or `null`.
 *
 * @param {String}             path     path to the EJS file
 * @param {Object}            [data={}] template data
 * @param {Options}           [opts={}] compilation and rendering options
 * @param {RenderFileCallback} cb callback
 * @public
 */ $7b643aa0373da987$exports.renderFile = function() {
    var args = Array.prototype.slice.call(arguments);
    var filename = args.shift();
    var cb;
    var opts = {
        filename: filename
    };
    var data;
    var viewOpts;
    // Do we have a callback?
    if (typeof arguments[arguments.length - 1] == 'function') cb = args.pop();
    // Do we have data/opts?
    if (args.length) {
        // Should always have data obj
        data = args.shift();
        // Normal passed opts (data obj + opts obj)
        if (args.length) // Use shallowCopy so we don't pollute passed in opts obj with new vals
        $02251835488faa61$export$9c13236873b118a5(opts, args.pop());
        else {
            // Express 3 and 4
            if (data.settings) {
                // Pull a few things from known locations
                if (data.settings.views) opts.views = data.settings.views;
                if (data.settings['view cache']) opts.cache = true;
                // Undocumented after Express 2, but still usable, esp. for
                // items that are unsafe to be passed along with data, like `root`
                viewOpts = data.settings['view options'];
                if (viewOpts) $02251835488faa61$export$9c13236873b118a5(opts, viewOpts);
            }
            // Express 2 and lower, values set in app.locals, or people who just
            // want to pass options in their data. NOTE: These values will override
            // anything previously set in settings  or settings['view options']
            $02251835488faa61$export$f83db5734555b793(opts, data, $7b643aa0373da987$var$_OPTS_PASSABLE_WITH_DATA_EXPRESS);
        }
        opts.filename = filename;
    } else data = $02251835488faa61$export$a59469c2841c043c();
    return $7b643aa0373da987$var$tryHandleCache(opts, data, cb);
};
/**
 * Clear intermediate JavaScript cache. Calls {@link Cache#reset}.
 * @public
 */ /**
 * EJS template class
 * @public
 */ $7b643aa0373da987$exports.Template = $7b643aa0373da987$var$Template;
$7b643aa0373da987$exports.clearCache = function() {
    $7b643aa0373da987$exports.cache.reset();
};
function $7b643aa0373da987$var$Template(text, optsParam) {
    var opts = $02251835488faa61$export$657fe57b4fad0029(optsParam);
    var options = $02251835488faa61$export$a59469c2841c043c();
    this.templateText = text;
    /** @type {string | null} */ this.mode = null;
    this.truncate = false;
    this.currentLine = 1;
    this.source = '';
    options.client = opts.client || false;
    options.escapeFunction = opts.escape || opts.escapeFunction || $02251835488faa61$export$b2bcda23b30e00ac;
    options.compileDebug = opts.compileDebug !== false;
    options.debug = !!opts.debug;
    options.filename = opts.filename;
    options.openDelimiter = opts.openDelimiter || $7b643aa0373da987$exports.openDelimiter || $7b643aa0373da987$var$_DEFAULT_OPEN_DELIMITER;
    options.closeDelimiter = opts.closeDelimiter || $7b643aa0373da987$exports.closeDelimiter || $7b643aa0373da987$var$_DEFAULT_CLOSE_DELIMITER;
    options.delimiter = opts.delimiter || $7b643aa0373da987$exports.delimiter || $7b643aa0373da987$var$_DEFAULT_DELIMITER;
    options.strict = opts.strict || false;
    options.context = opts.context;
    options.cache = opts.cache || false;
    options.rmWhitespace = opts.rmWhitespace;
    options.root = opts.root;
    options.includer = opts.includer;
    options.outputFunctionName = opts.outputFunctionName;
    options.localsName = opts.localsName || $7b643aa0373da987$exports.localsName || $7b643aa0373da987$var$_DEFAULT_LOCALS_NAME;
    options.views = opts.views;
    options.async = opts.async;
    options.destructuredLocals = opts.destructuredLocals;
    options.legacyInclude = typeof opts.legacyInclude != 'undefined' ? !!opts.legacyInclude : true;
    if (options.strict) options._with = false;
    else options._with = typeof opts._with != 'undefined' ? opts._with : true;
    this.opts = options;
    this.regex = this.createRegex();
}
$7b643aa0373da987$var$Template.modes = {
    EVAL: 'eval',
    ESCAPED: 'escaped',
    RAW: 'raw',
    COMMENT: 'comment',
    LITERAL: 'literal'
};
$7b643aa0373da987$var$Template.prototype = {
    createRegex: function() {
        var str = $7b643aa0373da987$var$_REGEX_STRING;
        var delim = $02251835488faa61$export$c998f240a39da81a(this.opts.delimiter);
        var open = $02251835488faa61$export$c998f240a39da81a(this.opts.openDelimiter);
        var close = $02251835488faa61$export$c998f240a39da81a(this.opts.closeDelimiter);
        str = str.replace(/%/g, delim).replace(/</g, open).replace(/>/g, close);
        return new RegExp(str);
    },
    compile: function() {
        /** @type {string} */ var src;
        /** @type {ClientFunction} */ var fn;
        var opts = this.opts;
        var prepended = '';
        var appended = '';
        /** @type {EscapeCallback} */ var escapeFn = opts.escapeFunction;
        /** @type {FunctionConstructor} */ var ctor;
        /** @type {string} */ var sanitizedFilename = opts.filename ? JSON.stringify(opts.filename) : 'undefined';
        if (!this.source) {
            this.generateSource();
            prepended += '  var __output = "";\n  function __append(s) { if (s !== undefined && s !== null) __output += s }\n';
            if (opts.outputFunctionName) {
                if (!$7b643aa0373da987$var$_JS_IDENTIFIER.test(opts.outputFunctionName)) throw new Error('outputFunctionName is not a valid JS identifier.');
                prepended += '  var ' + opts.outputFunctionName + ' = __append;' + '\n';
            }
            if (opts.localsName && !$7b643aa0373da987$var$_JS_IDENTIFIER.test(opts.localsName)) throw new Error('localsName is not a valid JS identifier.');
            if (opts.destructuredLocals && opts.destructuredLocals.length) {
                var destructuring = '  var __locals = (' + opts.localsName + ' || {}),\n';
                for(var i = 0; i < opts.destructuredLocals.length; i++){
                    var name = opts.destructuredLocals[i];
                    if (!$7b643aa0373da987$var$_JS_IDENTIFIER.test(name)) throw new Error('destructuredLocals[' + i + '] is not a valid JS identifier.');
                    if (i > 0) destructuring += ',\n  ';
                    destructuring += name + ' = __locals.' + name;
                }
                prepended += destructuring + ';\n';
            }
            if (opts._with !== false) {
                prepended += '  with (' + opts.localsName + ' || {}) {' + '\n';
                appended += "  }\n";
            }
            appended += "  return __output;\n";
            this.source = prepended + this.source + appended;
        }
        if (opts.compileDebug) src = "var __line = 1\n  , __lines = " + JSON.stringify(this.templateText) + '\n' + '  , __filename = ' + sanitizedFilename + ';' + '\n' + 'try {' + '\n' + this.source + '} catch (e) {' + '\n' + '  rethrow(e, __lines, __filename, __line, escapeFn);' + '\n' + '}' + '\n';
        else src = this.source;
        if (opts.client) {
            src = 'escapeFn = escapeFn || ' + escapeFn.toString() + ';' + '\n' + src;
            if (opts.compileDebug) src = 'rethrow = rethrow || ' + $7b643aa0373da987$var$rethrow.toString() + ';' + '\n' + src;
        }
        if (opts.strict) src = '"use strict";\n' + src;
        if (opts.debug) console.log(src);
        if (opts.compileDebug && opts.filename) src = src + '\n' + '//# sourceURL=' + sanitizedFilename + '\n';
        try {
            if (opts.async) // Have to use generated function for this, since in envs without support,
            // it breaks in parsing
            try {
                ctor = new Function('return (async function(){}).constructor;')();
            } catch (e) {
                if (e instanceof SyntaxError) throw new Error('This environment does not support async/await');
                else throw e;
            }
            else ctor = Function;
            fn = new ctor(opts.localsName + ', escapeFn, include, rethrow', src);
        } catch (e) {
            // istanbul ignore else
            if (e instanceof SyntaxError) {
                if (opts.filename) e.message += ' in ' + opts.filename;
                e.message += ' while compiling ejs\n\n';
                e.message += 'If the above error is not helpful, you may want to try EJS-Lint:\n';
                e.message += 'https://github.com/RyanZim/EJS-Lint';
                if (!opts.async) {
                    e.message += '\n';
                    e.message += 'Or, if you meant to create an async function, pass `async: true` as an option.';
                }
            }
            throw e;
        }
        // Return a callable function which will execute the function
        // created by the source-code, with the passed data as locals
        // Adds a local `include` function which allows full recursive include
        var returnedFn = opts.client ? fn : function anonymous(data) {
            var include = function(path, includeData) {
                var d = $02251835488faa61$export$9c13236873b118a5($02251835488faa61$export$a59469c2841c043c(), data);
                if (includeData) d = $02251835488faa61$export$9c13236873b118a5(d, includeData);
                return $7b643aa0373da987$var$includeFile(path, opts)(d);
            };
            return fn.apply(opts.context, [
                data || $02251835488faa61$export$a59469c2841c043c(),
                escapeFn,
                include,
                $7b643aa0373da987$var$rethrow
            ]);
        };
        if (opts.filename && typeof Object.defineProperty === 'function') {
            var filename = opts.filename;
            var basename = $256a03aa568b6949$exports.basename(filename, $256a03aa568b6949$exports.extname(filename));
            try {
                Object.defineProperty(returnedFn, 'name', {
                    value: basename,
                    writable: false,
                    enumerable: false,
                    configurable: true
                });
            } catch (e) {}
        }
        return returnedFn;
    },
    generateSource: function() {
        var opts = this.opts;
        if (opts.rmWhitespace) // Have to use two separate replace here as `^` and `$` operators don't
        // work well with `\r` and empty lines don't work well with the `m` flag.
        this.templateText = this.templateText.replace(/[\r\n]+/g, '\n').replace(/^\s+|\s+$/gm, '');
        // Slurp spaces and tabs before <%_ and after _%>
        this.templateText = this.templateText.replace(/[ \t]*<%_/gm, '<%_').replace(/_%>[ \t]*/gm, '_%>');
        var self = this;
        var matches = this.parseTemplateText();
        var d = this.opts.delimiter;
        var o = this.opts.openDelimiter;
        var c = this.opts.closeDelimiter;
        if (matches && matches.length) matches.forEach(function(line, index) {
            var closing;
            // If this is an opening tag, check for closing tags
            // FIXME: May end up with some false positives here
            // Better to store modes as k/v with openDelimiter + delimiter as key
            // Then this can simply check against the map
            if (line.indexOf(o + d) === 0 // If it is a tag
             && line.indexOf(o + d + d) !== 0) {
                closing = matches[index + 2];
                if (!(closing == d + c || closing == '-' + d + c || closing == '_' + d + c)) throw new Error('Could not find matching close tag for "' + line + '".');
            }
            self.scanLine(line);
        });
    },
    parseTemplateText: function() {
        var str = this.templateText;
        var pat = this.regex;
        var result = pat.exec(str);
        var arr = [];
        var firstPos;
        while(result){
            firstPos = result.index;
            if (firstPos !== 0) {
                arr.push(str.substring(0, firstPos));
                str = str.slice(firstPos);
            }
            arr.push(result[0]);
            str = str.slice(result[0].length);
            result = pat.exec(str);
        }
        if (str) arr.push(str);
        return arr;
    },
    _addOutput: function(line) {
        if (this.truncate) {
            // Only replace single leading linebreak in the line after
            // -%> tag -- this is the single, trailing linebreak
            // after the tag that the truncation mode replaces
            // Handle Win / Unix / old Mac linebreaks -- do the \r\n
            // combo first in the regex-or
            line = line.replace(/^(?:\r\n|\r|\n)/, '');
            this.truncate = false;
        }
        if (!line) return line;
        // Preserve literal slashes
        line = line.replace(/\\/g, '\\\\');
        // Convert linebreaks
        line = line.replace(/\n/g, '\\n');
        line = line.replace(/\r/g, '\\r');
        // Escape double-quotes
        // - this will be the delimiter during execution
        line = line.replace(/"/g, '\\"');
        this.source += '    ; __append("' + line + '")' + '\n';
    },
    scanLine: function(line) {
        var self = this;
        var d = this.opts.delimiter;
        var o = this.opts.openDelimiter;
        var c = this.opts.closeDelimiter;
        var newLineCount = 0;
        newLineCount = line.split('\n').length - 1;
        switch(line){
            case o + d:
            case o + d + '_':
                this.mode = $7b643aa0373da987$var$Template.modes.EVAL;
                break;
            case o + d + '=':
                this.mode = $7b643aa0373da987$var$Template.modes.ESCAPED;
                break;
            case o + d + '-':
                this.mode = $7b643aa0373da987$var$Template.modes.RAW;
                break;
            case o + d + '#':
                this.mode = $7b643aa0373da987$var$Template.modes.COMMENT;
                break;
            case o + d + d:
                this.mode = $7b643aa0373da987$var$Template.modes.LITERAL;
                this.source += '    ; __append("' + line.replace(o + d + d, o + d) + '")' + '\n';
                break;
            case d + d + c:
                this.mode = $7b643aa0373da987$var$Template.modes.LITERAL;
                this.source += '    ; __append("' + line.replace(d + d + c, d + c) + '")' + '\n';
                break;
            case d + c:
            case '-' + d + c:
            case '_' + d + c:
                if (this.mode == $7b643aa0373da987$var$Template.modes.LITERAL) this._addOutput(line);
                this.mode = null;
                this.truncate = line.indexOf('-') === 0 || line.indexOf('_') === 0;
                break;
            default:
                // In script mode, depends on type of tag
                if (this.mode) {
                    // If '//' is found without a line break, add a line break.
                    switch(this.mode){
                        case $7b643aa0373da987$var$Template.modes.EVAL:
                        case $7b643aa0373da987$var$Template.modes.ESCAPED:
                        case $7b643aa0373da987$var$Template.modes.RAW:
                            if (line.lastIndexOf('//') > line.lastIndexOf('\n')) line += '\n';
                    }
                    switch(this.mode){
                        // Just executing code
                        case $7b643aa0373da987$var$Template.modes.EVAL:
                            this.source += '    ; ' + line + '\n';
                            break;
                        // Exec, esc, and output
                        case $7b643aa0373da987$var$Template.modes.ESCAPED:
                            this.source += '    ; __append(escapeFn(' + $7b643aa0373da987$var$stripSemi(line) + '))' + '\n';
                            break;
                        // Exec and output
                        case $7b643aa0373da987$var$Template.modes.RAW:
                            this.source += '    ; __append(' + $7b643aa0373da987$var$stripSemi(line) + ')' + '\n';
                            break;
                        case $7b643aa0373da987$var$Template.modes.COMMENT:
                            break;
                        // Literal <%% mode, append as raw output
                        case $7b643aa0373da987$var$Template.modes.LITERAL:
                            this._addOutput(line);
                            break;
                    }
                } else this._addOutput(line);
        }
        if (self.opts.compileDebug && newLineCount) {
            this.currentLine += newLineCount;
            this.source += '    ; __line = ' + this.currentLine + '\n';
        }
    }
};
/**
 * Escape characters reserved in XML.
 *
 * This is simply an export of {@link module:utils.escapeXML}.
 *
 * If `markup` is `undefined` or `null`, the empty string is returned.
 *
 * @param {String} markup Input string
 * @return {String} Escaped string
 * @public
 * @func
 * */ $7b643aa0373da987$exports.escapeXML = $02251835488faa61$export$b2bcda23b30e00ac;
/**
 * Express.js support.
 *
 * This is an alias for {@link module:ejs.renderFile}, in order to support
 * Express.js out-of-the-box.
 *
 * @func
 */ $7b643aa0373da987$exports.__express = $7b643aa0373da987$exports.renderFile;
/**
 * Version of EJS.
 *
 * @readonly
 * @type {String}
 * @public
 */ $7b643aa0373da987$exports.VERSION = $7b643aa0373da987$require$_VERSION_STRING;
/**
 * Name for detection of EJS.
 *
 * @readonly
 * @type {String}
 * @public
 */ $7b643aa0373da987$exports.name = $7b643aa0373da987$var$_NAME;
/* istanbul ignore if */ if (typeof window != 'undefined') window.ejs = $7b643aa0373da987$exports;


var $facf26be2d6a2738$export$2e2bcd8739ae039 = ({ translate: translate, components: COMPONENTS, globals: globals })=>{
    const COMPONENTS_WITH_CONTROLLER = Object.entries(COMPONENTS).filter(([, v])=>!!v.controller);
    // we create a list of available `routes`:
    const ROUTES = COMPONENTS_WITH_CONTROLLER.reduce((acc, [templateName])=>{
        acc[templateName.replace(/-/g, '_').toUpperCase()] = templateName;
        return acc;
    }, {});
    const renderPage = (route, payload = {})=>{
        const ROOT = document.querySelector('.root');
        const el = document.createElement('div');
        el.setAttribute('data-controller', route);
        Object.entries(payload).forEach(([key, value])=>el.setAttribute(`data-${route}-${key}-value`, value));
        ROOT.innerHTML = '';
        ROOT.append(el);
    };
    const compileTemplate = (templateName)=>(args = {})=>{
            const templateWithProperDataAttributes = COMPONENTS[templateName].template.replace('data-target', `data-${templateName}-target`);
            return (0, (/*@__PURE__*/$parcel$interopDefault($7b643aa0373da987$exports))).compile(templateWithProperDataAttributes, {
                client: true
            })({
                ...args,
                t: translate,
                a: (action)=>`${templateName}#${action}`,
                ...globals
            }, null, (path, d)=>compileTemplate(path)(d));
        };
    // we init stimulus
    const stimulus = (0, $96e1daa2ad7e58e4$export$16975c34e60e1e61).start();
    // we register available `stimulus` controllers
    COMPONENTS_WITH_CONTROLLER.forEach(([templateName, { controller: controller }])=>{
        controller.ROUTES = ROUTES;
        controller.COMPILED_TEMPLATE = compileTemplate(templateName);
        controller.GO = renderPage;
        controller.T = translate;
        stimulus.register(templateName, controller);
    });
    // by default, page called `root` should be rendered.
    renderPage(ROUTES.ROOT);
};


(0, $facf26be2d6a2738$export$2e2bcd8739ae039)({
    translate: (0, $07298ebac3ba71d2$export$2e2bcd8739ae039),
    components: (0, $8c34544ec33d008d$export$2e2bcd8739ae039),
    globals: {
        BUTTON_STATES: $ddfd49b8c61c6cd2$export$20c28856b6c1341a
    }
});


//# sourceMappingURL=index.43ef42e0.js.map
